
/*
* @license
* Modular Theme (c) Presidio Creative Themes
*
* This file is included for advanced development by
* Shopify Agencies.  Modified versions of the theme
* code are not supported by Shopify or Presidio Creative.
*
* In order to use this file you will need to change
* theme.js to theme.dev.js in /layout/theme.liquid
*
*/

(function (scrollLock, Ajaxinate, Flickity, FlickityFade) {
    'use strict';

    (function() {
        const env = {"NODE_ENV":"production"};
        try {
            if (process) {
                process.env = Object.assign({}, process.env);
                Object.assign(process.env, env);
                return;
            }
        } catch (e) {} // avoid ReferenceError: process is not defined
        globalThis.process = { env:env };
    })();

    window.theme = window.theme || {};

    window.theme.subscribers = {};

    window.theme.sizes = {
      mobile: 480,
      small: 768,
      large: 1024,
      widescreen: 1320,
    };

    window.theme.dimensions = {
      headerScrolled: 60,
    };

    window.theme.focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    window.theme.a11yTrigger = null;

    (function () {
      function n(n) {
        var i = window.innerWidth || document.documentElement.clientWidth,
          r = window.innerHeight || document.documentElement.clientHeight,
          t = n.getBoundingClientRect();
        return t.top >= 0 && t.bottom <= r && t.left >= 0 && t.right <= i;
      }
      function t(n) {
        var i = window.innerWidth || document.documentElement.clientWidth,
          r = window.innerHeight || document.documentElement.clientHeight,
          t = n.getBoundingClientRect(),
          u = (t.left >= 0 && t.left <= i) || (t.right >= 0 && t.right <= i),
          f = (t.top >= 0 && t.top <= r) || (t.bottom >= 0 && t.bottom <= r);
        return u && f;
      }
      function i(n, i) {
        function r() {
          var r = t(n);
          r != u && ((u = r), typeof i == 'function' && i(r, n));
        }
        var u = t(n);
        window.addEventListener('load', r);
        window.addEventListener('resize', r);
        window.addEventListener('scroll', r);
      }
      function r(t, i) {
        function r() {
          var r = n(t);
          r != u && ((u = r), typeof i == 'function' && i(r, t));
        }
        var u = n(t);
        window.addEventListener('load', r);
        window.addEventListener('resize', r);
        window.addEventListener('scroll', r);
      }
      window.visibilityHelper = {isElementTotallyVisible: n, isElementPartiallyVisible: t, inViewportPartially: i, inViewportTotally: r};
    })();

    window.theme.getWindowWidth = function () {
      return document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth;
    };

    window.theme.getWindowHeight = function () {
      return document.documentElement.clientHeight || document.body.clientHeight || window.innerHeight;
    };

    window.theme.isMobile = function () {
      return window.matchMedia(`(max-width: ${window.theme.sizes.mobile - 1}px)`).matches;
    };

    window.theme.isSmall = function () {
      return window.matchMedia(`(max-width: ${window.theme.sizes.small - 1}px)`).matches;
    };

    window.theme.isLarge = function () {
      return window.matchMedia(`(min-width: ${window.theme.sizes.large}px)`).matches;
    };

    const PUB_SUB_EVENTS = {
      cartUpdate: 'cart-update',
      quantityUpdate: 'quantity-update',
      optionValueSelectionChange: 'option-value-selection-change',
      variantChange: 'variant-change',
      cartError: 'cart-error',
    };

    window.theme.PUB_SUB_EVENTS = PUB_SUB_EVENTS;

    let subscribers = {};

    function subscribe$1(eventName, callback) {
      if (subscribers[eventName] === undefined) {
        subscribers[eventName] = [];
      }

      subscribers[eventName] = [...subscribers[eventName], callback];

      return function unsubscribe() {
        subscribers[eventName] = subscribers[eventName].filter((cb) => {
          return cb !== callback;
        });
      };
    }

    function publish$1(eventName, data) {
      if (subscribers[eventName]) {
        const promises = subscribers[eventName].map((callback) => callback(data));
        return Promise.all(promises);
      } else {
        return Promise.resolve();
      }
    }

    window.publish = publish$1;
    window.subscribe = subscribe$1;

    class AccordionElements extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.accordions = this.querySelectorAll('[data-accordion]');

        this.accordions.forEach((accordion) => {
          const trigger = accordion.querySelector('[data-accordion-trigger]');
          const body = accordion.querySelector('[data-accordion-body]');
          if (!trigger || !body) return;

          trigger.addEventListener('click', (event) => this.onCollapsibleClick(event));

          body.addEventListener('transitionend', (event) => {
            if (event.target !== body) return;

            if (accordion.getAttribute('open') == 'true') {
              this.setBodyHeight(body, 'auto');

              // Focus on the first focusable element in the details tag
              accordion.querySelector('input, button, a')?.focus();
            }

            if (accordion.getAttribute('open') == 'false') {
              accordion.removeAttribute('open');
              this.setBodyHeight(body, '');
            }
          });
        });

        this.addEventListener('keyup', (event) => this.onKeyUp(event));
      }

      open(accordion) {
        if (accordion.getAttribute('open') == 'true') return;

        const body = accordion.querySelector('[data-accordion-body]');
        const content = accordion.querySelector('[data-accordion-content]');

        accordion.setAttribute('open', true);
        this.setBodyHeight(body, content.offsetHeight);
      }

      close(accordion) {
        if (!accordion.hasAttribute('open')) return;

        const body = accordion.querySelector('[data-accordion-body]');
        const content = accordion.querySelector('[data-accordion-content]');

        this.setBodyHeight(body, content.offsetHeight);

        accordion.setAttribute('open', false);

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.setBodyHeight(body, 0);
          });
        });
      }

      setBodyHeight(body, contentHeight) {
        body.style.height = contentHeight !== 'auto' && contentHeight !== '' ? `${contentHeight}px` : contentHeight;
      }

      onCollapsibleClick(event) {
        event.preventDefault();

        const accordion = event.target.closest('[data-accordion]');
        if (!accordion) return;

        const single = this.hasAttribute('single');

        // When we want only one item expanded at the same time
        if (single) {
          this.accordions.forEach((otherCollapsible) => {
            // if otherCollapsible has attribute open and it's not the one we clicked on, remove the open attribute
            if (otherCollapsible.hasAttribute('open') && otherCollapsible !== accordion) {
              requestAnimationFrame(() => {
                this.close(otherCollapsible);
              });
            }
          });
        }

        if (accordion.hasAttribute('open')) {
          this.close(accordion);
        } else {
          this.open(accordion);
        }
      }

      onKeyUp(event) {
        const accordion = this.querySelector('details[open]');

        if (event.code == 'Escape' && accordion) {
          accordion.querySelector('summary')?.dispatchEvent(new Event('click'));
        }
      }
    }

    if (!customElements.get('accordion-elements')) {
      customElements.define('accordion-elements', AccordionElements);
    }

    /**
     * Currency Helpers
     * -----------------------------------------------------------------------------
     * A collection of useful functions that help with currency formatting
     *
     * Current contents
     * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
     *
     */

    const moneyFormat = '${{amount}}';

    /**
     * Format money values based on your shop currency settings
     * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
     * or 3.00 dollars
     * @param  {String} format - shop money_format setting
     * @return {String} value - formatted value
     */
    window.theme.formatMoney = function (cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'", '.');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ', '');
          break;
        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', ',');
          break;
        case 'amount_with_period_and_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', '.');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    };

    window.theme.debounce = function (fn, time) {
      let timeout;
      return function () {
        // eslint-disable-next-line prefer-rest-params
        if (fn) {
          const functionCall = () => fn.apply(this, arguments);
          clearTimeout(timeout);
          timeout = setTimeout(functionCall, time);
        }
      };
    };

    getScreenOrientation();

    window.theme.readHeights = function () {
      const h = {};
      h.windowHeight = window.innerHeight;
      h.footerHeight = getHeight('[data-section-type*="footer"]');
      h.headerHeight = getHeight('[data-header-height].header--has-scrolled') || 60; // Header height is always 60px on scroll
      h.headerInitialHeight = getHeight('[data-header-height]:not(.header--has-scrolled)');
      return h;
    };

    function setVars() {
      const {windowHeight, headerInitialHeight, headerHeight, footerHeight} = theme.readHeights();

      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      document.documentElement.style.setProperty('--footer-height', `${footerHeight}px`);
      document.documentElement.style.setProperty('--content-full', `${windowHeight - headerHeight}px`);
      document.documentElement.style.setProperty('--content-min', `${windowHeight - headerHeight - footerHeight}px`);
    }

    function getScreenOrientation() {
      if (window.matchMedia('(orientation: portrait)').matches) {
        return 'portrait';
      }

      if (window.matchMedia('(orientation: landscape)').matches) {
        return 'landscape';
      }
    }

    function getHeight(selector) {
      const el = document.querySelector(selector);
      if (el) {
        return el.offsetHeight;
      } else {
        return 0;
      }
    }

    setVars();

    window.addEventListener('DOMContentLoaded', setVars);
    document.addEventListener('theme:resize', setVars);
    document.addEventListener('shopify:section:load', setVars);

    class DeferredMedia extends HTMLElement {
      constructor() {
        super();

        const poster = this.querySelector('[data-deferred-media-button]');
        poster?.addEventListener('click', this.loadContent.bind(this));
      }

      loadContent(focus = true) {
        window.theme.pauseAllMedia();

        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
          this.setAttribute('loaded', true);

          const mediaElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
          if (focus) mediaElement.focus();
          if (mediaElement.nodeName == 'VIDEO' && mediaElement.getAttribute('autoplay')) {
            // Force autoplay on Safari browsers
            mediaElement.play();
          }
        }
      }
    }

    if (!customElements.get('deferred-media')) {
      customElements.define('deferred-media', DeferredMedia);
    }

    window.theme.DeferredMedia = window.theme.DeferredMedia || DeferredMedia;

    if (!customElements.get('collapsible-elements')) {
      customElements.define(
        'collapsible-elements',
        class CollapsibleElements extends HTMLElement {
          constructor() {
            super();

            this.triggers = this.querySelectorAll('[data-collapsible-trigger]');
            this.resetHeight = 0;
          }

          connectedCallback() {
            this.triggers.forEach((trigger) => {
              trigger.addEventListener('click', (event) => this.collapsibleToggleEvent(event, trigger));
              trigger.addEventListener('keyup', (event) => this.collapsibleToggleEvent(event, trigger));
            });
          }

          collapsibleToggleEvent(e, trigger) {
            e.preventDefault();

            const dropdownId = trigger.getAttribute('aria-controls');
            const isAccordion = trigger.hasAttribute('data-accordion');
            const dropdown = document.getElementById(dropdownId);
            const parent = trigger.parentNode;
            const isExpanded = parent.classList.contains('is-expanded');
            const isSpace = e.code === 'Space';
            const isEscape = e.code === 'Escape';
            let dropdownHeight = dropdown.querySelector('[data-collapsible-content]').offsetHeight;

            // Do nothing if any different than ESC and Space key pressed
            if (e.code && !isSpace && !isEscape) {
              return;
            }

            if (!isExpanded && isEscape) {
              return;
            }

            if (isExpanded) {
              setTimeout(() => {
                dropdownHeight = 0;
                this.setDropdownHeight(dropdown, dropdownHeight, isExpanded);
              }, 0);
            } else if (isAccordion) {
              const siblings = getSiblings(parent);
              siblings.forEach((sibling) => {
                if (sibling.classList.contains('is-expanded')) {
                  const trigger = sibling.querySelector('[data-collapsible-trigger]');
                  trigger.dispatchEvent(new Event('click'));
                }
              });
            }

            trigger.setAttribute('aria-expanded', !isExpanded);
            parent.classList.toggle('is-expanded', !isExpanded);

            this.setDropdownHeight(dropdown, dropdownHeight, isExpanded);
          }

          setDropdownHeight(dropdown, dropdownHeight, isExpanded) {
            dropdown.style.maxHeight = `${dropdownHeight}px`;
            dropdown.setAttribute('aria-hidden', isExpanded);
            let maxHeight = 'none';

            if (this.resetHeight) {
              clearTimeout(this.resetHeight);
            }

            if (dropdownHeight === 0) {
              maxHeight = null;
            }

            this.resetHeight = setTimeout(() => {
              dropdown.style.maxHeight = maxHeight;
            }, 500);
          }

          getSiblings(el) {
            return Array.prototype.filter.call(el.parentNode.children, function (child) {
              return child !== el;
            });
          }
        }
      );
    }

    function pauseAllMedia() {
      document.querySelectorAll('[data-host="youtube"]').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      });
      document.querySelectorAll('[data-host="vimeo"]').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      });
      document.querySelectorAll('video').forEach((video) => video.pause());
      document.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
      });
    }

    window.theme.pauseAllMedia = pauseAllMedia;

    if (!customElements.get('product-form')) {
      customElements.define(
        'product-form',
        class ProductForm extends HTMLElement {
          constructor() {
            super();

            this.form = this.querySelector('form');
            this.variantIdInput.disabled = false;
            this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
            this.cart = document.querySelector('cart-drawer');
            this.submitButton = this.querySelector('[type="submit"]');
            this.submitButtonText = this.submitButton.querySelector('[data-add-to-cart-text]');

            if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

            this.hideErrors = this.dataset.hideErrors === 'true';
          }

          onSubmitHandler(evt) {
            evt.preventDefault();

            document.dispatchEvent(
              new CustomEvent('theme:cart:add', {
                detail: {
                  button: this.submitButton,
                },
                bubbles: false,
              })
            );

            const quickAddModal = this.closest('quick-add-modal');
            if (!quickAddModal) {
              window.a11y.lastElement = this.submitButton;
            }
          }

          toggleSubmitButton(disable = true, text) {
            if (disable) {
              this.submitButton.setAttribute('disabled', 'disabled');
              if (text) this.setButtonLabel(text);
            } else {
              this.submitButton.removeAttribute('disabled');
              this.setButtonLabel(text || window.theme.strings.addToCart);
            }
          }

          setButtonLabel(label) {
            const priceEl = this.submitButtonText.querySelector('[data-product-price]');

            this.submitButtonText.textContent = label;

            if (priceEl) this.submitButtonText.appendChild(priceEl);
          }

          get variantIdInput() {
            return this.form.querySelector('[name="id"]');
          }
        }
      );
    }

    if (!customElements.get('popout-select')) {
      customElements.define(
        'popout-select',
        class Popout extends HTMLElement {
          constructor() {
            super();
          }

          connectedCallback() {
            this.popoutList = this.querySelector('[data-popout-list]');
            this.popoutToggle = this.querySelector('[data-popout-toggle]');
            this.popoutToggleText = this.querySelector('[data-popout-toggle-text]');
            this.popoutInput = this.querySelector('[data-popout-input]') || this.parentNode.querySelector('[data-popout-input]') || this.parentNode.parentNode.querySelector('[data-quantity-input]');

            this.popoutOptions = this.querySelectorAll('[data-popout-option]');
            this.productGridItem = this.popoutList.closest('[data-grid-item]');
            this.fireSubmitEvent = this.hasAttribute('submit');

            this.popupToggleFocusoutEvent = (evt) => this.onPopupToggleFocusout(evt);
            this.popupListFocusoutEvent = (evt) => this.onPopupListFocusout(evt);
            this.popupToggleClickEvent = (evt) => this.onPopupToggleClick(evt);
            this.keyUpEvent = (evt) => this.onKeyUp(evt);
            this.bodyClickEvent = (evt) => this.onBodyClick(evt);

            this._connectOptions();
            this._connectToggle();
            this._onFocusOut();
            this.popupListSetDimensions();
          }

          onPopupToggleClick(evt) {
            const button = evt.currentTarget;
            const ariaExpanded = button.getAttribute('aria-expanded') === 'true';

            if (this.productGridItem) {
              const productGridItemImage = this.productGridItem.querySelector('[data-product-image]');

              if (productGridItemImage) {
                productGridItemImage.classList.toggle('is-visible', !ariaExpanded);
              }

              this.popoutList.style.maxHeight = `${Math.abs(this.popoutToggle.getBoundingClientRect().bottom - this.productGridItem.getBoundingClientRect().bottom)}px`;
            }

            evt.currentTarget.setAttribute('aria-expanded', !ariaExpanded);
            this.popoutList.classList.toggle('popout-list--visible');
            this.popupListSetDimensions();
            this.toggleListPosition();

            document.body.addEventListener('click', this.bodyClickEvent);
          }

          onPopupToggleFocusout(evt) {
            const popoutLostFocus = this.contains(evt.relatedTarget);

            if (!popoutLostFocus) {
              this._hideList();
            }
          }

          onPopupListFocusout(evt) {
            const childInFocus = evt.currentTarget.contains(evt.relatedTarget);
            const isVisible = this.popoutList.classList.contains('popout-list--visible');

            if (isVisible && !childInFocus) {
              this._hideList();
            }
          }

          toggleListPosition() {
            const button = this.querySelector('[data-popout-toggle]');
            const popoutTop = this.getBoundingClientRect().top + this.clientHeight;

            const removeTopClass = () => {
              if (button.getAttribute('aria-expanded') !== 'true') {
                this.popoutList.classList.remove('popout-list--top');
              }

              this.popoutList.removeEventListener('transitionend', removeTopClass);
            };

            if (button.getAttribute('aria-expanded') === 'true') {
              if (window.innerHeight / 2 < popoutTop) {
                this.popoutList.classList.add('popout-list--top');
              }
            } else {
              this.popoutList.addEventListener('transitionend', removeTopClass);
            }
          }

          popupListSetDimensions() {
            this.popoutList.style.setProperty('--max-width', '100vw');
            this.popoutList.style.setProperty('--max-height', '100vh');

            requestAnimationFrame(() => {
              this.popoutList.style.setProperty('--max-width', `${parseInt(document.body.clientWidth - this.popoutList.getBoundingClientRect().left)}px`);
              this.popoutList.style.setProperty('--max-height', `${parseInt(document.body.clientHeight - this.popoutList.getBoundingClientRect().top)}px`);
            });
          }

          popupOptionsClick(evt) {
            const link = evt.target.closest('[data-popout-option]');

            if (link.attributes.href.value === '#') {
              evt.preventDefault();

              const attrValue = evt.currentTarget.hasAttribute('data-value') ? evt.currentTarget.getAttribute('data-value') : '';

              this.popoutInput.value = attrValue;

              // Sync option metadata onto the hidden input so downstream logic can read it
              const listItem = evt.currentTarget.closest('li');
              if (listItem) {
                const optionValueId = listItem.getAttribute('data-option-value-id');
                const productUrl = listItem.getAttribute('data-product-url');
                if (optionValueId) this.popoutInput.setAttribute('data-option-value-id', optionValueId);
                if (productUrl) this.popoutInput.setAttribute('data-product-url', productUrl);
              }

              if (this.popoutInput.disabled) {
                this.popoutInput.removeAttribute('disabled');
              }

              if (this.fireSubmitEvent) {
                this._submitForm(attrValue);
              } else {
                const currentTarget = evt.currentTarget.parentElement;
                const listTargetElement = this.popoutList.querySelector('.is-active');
                const targetAttribute = this.popoutList.querySelector('[aria-current]');

                // Fire a bubbling change event so parent controllers can react
                this.popoutInput.dispatchEvent(new Event('change', {bubbles: true}));

                if (listTargetElement) {
                  listTargetElement.classList.remove('is-active');
                  currentTarget.classList.add('is-active');
                }

                if (this.popoutInput.name == 'quantity' && !currentTarget.nextSibling) {
                  this.classList.add('is-active');
                }

                if (targetAttribute && targetAttribute.hasAttribute('aria-current')) {
                  targetAttribute.removeAttribute('aria-current');
                  evt.currentTarget.setAttribute('aria-current', 'true');
                }

                if (attrValue !== '' && this.popoutToggleText) {
                  this.popoutToggleText.textContent = attrValue;
                  this.popoutToggleText.setAttribute('data-popout-toggle-text', attrValue);
                }
                this.onPopupToggleFocusout(evt);
                this.onPopupListFocusout(evt);
              }
            }
          }

          onKeyUp(evt) {
            if (evt.code !== 'Escape') {
              return;
            }
            this._hideList();
            this.popoutToggle.focus();
          }

          onBodyClick(evt) {
            const isOption = this.contains(evt.target);
            const isVisible = this.popoutList.classList.contains('popout-list--visible');

            if (isVisible && !isOption) {
              this._hideList();
            }
          }

          _connectToggle() {
            this.popoutToggle.addEventListener('click', this.popupToggleClickEvent);
          }

          _connectOptions() {
            if (this.popoutOptions.length) {
              this.popoutOptions.forEach((element) => {
                element.addEventListener('click', (evt) => this.popupOptionsClick(evt));
              });
            }
          }

          _onFocusOut() {
            this.addEventListener('keyup', this.keyUpEvent);
            this.popoutToggle.addEventListener('focusout', this.popupToggleFocusoutEvent);
            this.popoutList.addEventListener('focusout', this.popupListFocusoutEvent);
          }

          _submitForm() {
            const form = this.closest('form');
            if (form) {
              form.submit();
            }
          }

          _hideList() {
            this.popoutList.classList.remove('popout-list--visible');
            this.popoutToggle.setAttribute('aria-expanded', false);
            this.toggleListPosition();
            document.body.removeEventListener('click', this.bodyClickEvent);
          }
        }
      );
    }

    /**
     * Recently viewed products – cookie storage and AJAX fetch
     */

    const COOKIE_NAME = 'shopify_recently_viewed';
    const API_SECTION = 'api-product-grid-item';

    function getCookieValue() {
      const row = document.cookie.split('; ').find((r) => r.trim().startsWith(`${COOKIE_NAME}=`));
      if (!row) return null;
      try {
        return decodeURIComponent(row.split('=').slice(1).join('=').trim());
      } catch {
        return row.split('=').slice(1).join('=').trim();
      }
    }

    function readHandles() {
      const value = getCookieValue();
      if (!value) return [];
      let handles = value.split(' ').filter(Boolean);
      const current = document.querySelector('[data-product-template]')?.getAttribute('data-product-handle');
      if (current) handles = handles.filter((h) => h !== current);
      return handles;
    }

    function writeHandles(handles) {
      const expires = new Date();
      expires.setDate(expires.getDate() + 90);
      const value = encodeURIComponent(handles.join(' '));
      document.cookie = `${COOKIE_NAME}=${value}; expires=${expires.toUTCString()}; path=/; domain=${window.location.hostname}`;
    }

    function getHandleFromUrl() {
      const match = decodeURIComponent(window.location.pathname).match(/\/products\/([^/]+)/);
      return match ? match[1] : null;
    }

    Shopify.Products = {
      showRecentlyViewed(params = {}) {
        if (Shopify.visualPreviewMode) return;

        const { howManyToShow = 4, wrapperId = 'RecentlyViewed', onComplete } = params;
        const handles = readHandles();
        const wrapper = document.querySelector(`#${wrapperId}`);

        if (!handles.length || !wrapper) {
          onComplete?.();
          return;
        }

        const toShow = Math.min(handles.length, howManyToShow);
        let shown = 0;

        function fetchNext() {
          if (shown >= toShow) {
            onComplete?.();
            return;
          }

          const handle = handles[shown];
          const url = `${window.theme?.routes?.root || '/'}products/${encodeURIComponent(handle)}?section_id=${API_SECTION}`;

          fetch(url)
            .then((r) => r.text())
            .then((html) => {
              const div = document.createElement('div');
              div.innerHTML = html;
              const content = div.querySelector('[data-api-content]');
              if (content) wrapper.insertAdjacentHTML('beforeend', content.innerHTML);
              shown++;
              fetchNext();
            })
            .catch(() => {
              writeHandles(handles.filter((h) => h !== handle));
              shown++;
              fetchNext();
            });
        }

        fetchNext();
      },

      recordRecentlyViewed(params = {}) {
        const handle = params.handle ?? getHandleFromUrl();
        if (!handle) return;

        let handles = readHandles();
        handles = handles.filter((h) => h !== handle);
        handles.unshift(handle);
        writeHandles(handles.slice(0, params.howManyToStoreInMemory ?? 10));
      },

      clearList() {
        document.cookie = `${COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${window.location.hostname}`;
      },

      get hasProducts() {
        return readHandles().length > 0;
      },
    };

    /**
     * A11y Helpers
     * -----------------------------------------------------------------------------
     * A collection of useful functions that help make your theme more accessible
     */

    /**
     * Moves focus to an HTML element
     * eg for In-page links, after scroll, focus shifts to content area so that
     * next `tab` is where user expects. Used in bindInPageLinks()
     * eg move focus to a modal that is opened. Used in trapFocus()
     *
     * @param {Element} container - Container DOM element to trap focus inside of
     * @param {Object} options - Settings unique to your theme
     * @param {string} options.className - Class name to apply to element on focus.
     */
    function forceFocus(element, options) {
        options = options || {};
      
        var savedTabIndex = element.tabIndex;
      
        element.tabIndex = -1;
        element.dataset.tabIndex = savedTabIndex;
        element.focus();
        if (typeof options.className !== 'undefined') {
          element.classList.add(options.className);
        }
        element.addEventListener('blur', callback);
      
        function callback(event) {
          event.target.removeEventListener(event.type, callback);
      
          element.tabIndex = savedTabIndex;
          delete element.dataset.tabIndex;
          if (typeof options.className !== 'undefined') {
            element.classList.remove(options.className);
          }
        }
      }
      
      /**
       * If there's a hash in the url, focus the appropriate element
       * This compensates for older browsers that do not move keyboard focus to anchor links.
       * Recommendation: To be called once the page in loaded.
       *
       * @param {Object} options - Settings unique to your theme
       * @param {string} options.className - Class name to apply to element on focus.
       * @param {string} options.ignore - Selector for elements to not include.
       */
      
      function focusHash(options) {
        options = options || {};
        var hash = window.location.hash;
        var element = document.getElementById(hash.slice(1));
      
        // if we are to ignore this element, early return
        if (element && options.ignore && element.matches(options.ignore)) {
          return false;
        }
      
        if (hash && element) {
          forceFocus(element, options);
        }
      }
      
      /**
       * When an in-page (url w/hash) link is clicked, focus the appropriate element
       * This compensates for older browsers that do not move keyboard focus to anchor links.
       * Recommendation: To be called once the page in loaded.
       *
       * @param {Object} options - Settings unique to your theme
       * @param {string} options.className - Class name to apply to element on focus.
       * @param {string} options.ignore - CSS selector for elements to not include.
       */
      
      function bindInPageLinks(options) {
        options = options || {};
        var links = Array.prototype.slice.call(
          document.querySelectorAll('a[href^="#"]')
        );

        function queryCheck (selector) {
          return document.getElementById(selector) !== null
        }
      
        return links.filter(function(link) {
          if (link.hash === '#' || link.hash === '') {
            return false;
          }
      
          if (options.ignore && link.matches(options.ignore)) {
            return false;
          }

          if (!queryCheck(link.hash.substr(1))) {
            return false;
          }
      
          var element = document.querySelector(link.hash);
      
          if (!element) {
            return false;
          }
      
          link.addEventListener('click', function() {
            forceFocus(element, options);
          });
      
          return true;
        });
      }
      
      function focusable(container) {
        var elements = Array.prototype.slice.call(
          container.querySelectorAll(
            '[tabindex],' +
              '[draggable],' +
              'a[href],' +
              'area,' +
              'button:enabled,' +
              'input:not([type=hidden]):enabled,' +
              'object,' +
              'select:enabled,' +
              'textarea:enabled'
          )
        );
      
        // Filter out elements that are not visible.
        // Copied from jQuery https://github.com/jquery/jquery/blob/2d4f53416e5f74fa98e0c1d66b6f3c285a12f0ce/src/css/hiddenVisibleSelectors.js
        return elements.filter(function(element) {
          return !!(
            element.offsetWidth ||
            element.offsetHeight ||
            element.getClientRects().length
          );
        });
      }
      
      /**
       * Traps the focus in a particular container
       *
       * @param {Element} container - Container DOM element to trap focus inside of
       * @param {Element} elementToFocus - Element to be focused on first
       * @param {Object} options - Settings unique to your theme
       * @param {string} options.className - Class name to apply to element on focus.
       */
      
      var trapFocusHandlers$1 = {};
      
      function trapFocus(container, options) {
        options = options || {};
        var elements = focusable(container);
        var elementToFocus = options.elementToFocus || container;
        var first = elements[0];
        var last = elements[elements.length - 1];
      
        removeTrapFocus();
      
        trapFocusHandlers$1.focusin = function(event) {
          if (container !== event.target && !container.contains(event.target)) {
            first.focus();
          }
      
          if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
          )
            return;
          document.addEventListener('keydown', trapFocusHandlers$1.keydown);
        };
      
        trapFocusHandlers$1.focusout = function() {
          document.removeEventListener('keydown', trapFocusHandlers$1.keydown);
        };
      
        trapFocusHandlers$1.keydown = function(event) {
          if (event.code !== 'Tab') return; // If not TAB key
      
          // On the last focusable element and tab forward, focus the first element.
          if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
          }
      
          //  On the first focusable element and tab backward, focus the last element.
          if (
            (event.target === container || event.target === first) &&
            event.shiftKey
          ) {
            event.preventDefault();
            last.focus();
          }
        };
      
        document.addEventListener('focusout', trapFocusHandlers$1.focusout);
        document.addEventListener('focusin', trapFocusHandlers$1.focusin);
      
        forceFocus(elementToFocus, options);
      }
      
      /**
       * Removes the trap of focus from the page
       */
      function removeTrapFocus() {
        document.removeEventListener('focusin', trapFocusHandlers$1.focusin);
        document.removeEventListener('focusout', trapFocusHandlers$1.focusout);
        document.removeEventListener('keydown', trapFocusHandlers$1.keydown);
      }
      
      /**
       * Add a preventive message to external links and links that open to a new window.
       * @param {string} elements - Specific elements to be targeted
       * @param {object} options.messages - Custom messages to overwrite with keys: newWindow, external, newWindowExternal
       * @param {string} options.messages.newWindow - When the link opens in a new window (e.g. target="_blank")
       * @param {string} options.messages.external - When the link is to a different host domain.
       * @param {string} options.messages.newWindowExternal - When the link is to a different host domain and opens in a new window.
       * @param {object} options.prefix - Prefix to namespace "id" of the messages
       */
      function accessibleLinks(elements, options) {
        if (typeof elements !== 'string') {
          throw new TypeError(elements + ' is not a String.');
        }
      
        elements = document.querySelectorAll(elements);
      
        if (elements.length === 0) {
          return;
        }
      
        options = options || {};
        options.messages = options.messages || {};
      
        var messages = {
          newWindow: options.messages.newWindow || 'Opens in a new window.',
          external: options.messages.external || 'Opens external website.',
          newWindowExternal:
            options.messages.newWindowExternal ||
            'Opens external website in a new window.'
        };
      
        var prefix = options.prefix || 'a11y';
      
        var messageSelectors = {
          newWindow: prefix + '-new-window-message',
          external: prefix + '-external-message',
          newWindowExternal: prefix + '-new-window-external-message'
        };
      
        function generateHTML(messages) {
          var container = document.createElement('ul');
          var htmlMessages = Object.keys(messages).reduce(function(html, key) {
            return (html +=
              '<li id=' + messageSelectors[key] + '>' + messages[key] + '</li>');
          }, '');
      
          container.setAttribute('hidden', true);
          container.innerHTML = htmlMessages;
      
          document.body.appendChild(container);
        }
      
        function externalSite(link) {
          return link.hostname !== window.location.hostname;
        }
      
        elements.forEach(function(link) {
          var target = link.getAttribute('target');
          var rel = link.getAttribute('rel');
          var isExternal = externalSite(link);
          var isTargetBlank = target === '_blank';
          var missingRelNoopener = rel === null || rel.indexOf('noopener') === -1;
      
          if (isTargetBlank && missingRelNoopener) {
            var relValue = rel === null ? 'noopener' : rel + ' noopener';
            link.setAttribute('rel', relValue);
          }
      
          if (isExternal && isTargetBlank) {
            link.setAttribute('aria-describedby', messageSelectors.newWindowExternal);
          } else if (isExternal) {
            link.setAttribute('aria-describedby', messageSelectors.external);
          } else if (isTargetBlank) {
            link.setAttribute('aria-describedby', messageSelectors.newWindow);
          }
        });
      
        generateHTML(messages);
      }

    var a11y$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        forceFocus: forceFocus,
        focusHash: focusHash,
        bindInPageLinks: bindInPageLinks,
        focusable: focusable,
        trapFocus: trapFocus,
        removeTrapFocus: removeTrapFocus,
        accessibleLinks: accessibleLinks
    });

    if (!customElements.get('header-component')) {
      customElements.define(
        'header-component',
        class HeaderComponent extends HTMLElement {
          constructor() {
            super();

            this.headerContainer = this.parentNode;
            this.bodyWrap = document.querySelector('[data-body-wrap]');
            this.headerInitialHeight = 0;
            this.headerStateEvent = (event) => this.stickyHeaderState(event);
            this.checkMobileNavEvent = () => this.checkMobileNav();
            this.checkNavOverlapEvent = () => this.checkNavigationOverlapping();
            this.checkTransparentHeaderEvent = (e) => this.checkTransparentHeader(e);
            this.updateHeaderHeightEvent = () => this.updateHeaderHeight();
            this.onSectionSelectEvent = this.onSectionSelect.bind(this);
            this.headerSection = this.closest('.shopify-section-header');
            this.header = this.headerSection.querySelector('header-component');
            this.menuToggles = this.headerSection.querySelectorAll('[data-menu-toggle]');
            this.headerIcons = this.header.querySelector('[data-header-icons]');
            this.navStandard = this.header.querySelector('[data-nav-main]');
            this.hamburger = this.header.querySelector('[data-hamburger-icon]');
            this.mobileNav = this.headerSection.querySelector('.nav-hamburger');
            this.scrollableElement = document.querySelector('[data-hamburger-scrollable]');
            this.hamburgerNavLinks = this.scrollableElement.parentNode.querySelectorAll('button, a');
            this.documentClick = (e) => this.hideOnOutsideClick(e);
            this.documentKeyup = (e) => this.hideOnKeyUp(e);
            this.scrollLockTimeout = 0;
            this.resetHeight = 0;
            this.a11y = a11y$1;

            window.addEventListener('load', this.checkNavOverlapEvent);
          }

          connectedCallback() {
            this.refreshHeaderHeight();
            this.resetHeader();
            this.checkTransparentHeader();
            this.checkNavigationOverlapping();
            this.cartToggleEvent();
            this.hideMobileNav();
            this.bindings();
            this.activeLinks();

            document.addEventListener('theme:resize:width', this.checkNavOverlapEvent);
            document.addEventListener('theme:resize:width', this.checkMobileNavEvent);
            document.addEventListener('theme:resize:width', this.updateHeaderHeightEvent);
            document.addEventListener('theme:header:update', this.checkTransparentHeaderEvent);
            document.addEventListener('shopify:section:select', this.onSectionSelectEvent);

            if (this.classList.contains('header--sticky')) {
              this.stickyHeaderState();
              document.addEventListener('theme:scroll', this.headerStateEvent);
            }

            requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
          }

          cartToggleEvent() {
            if (!theme.settings.enableAjaxCart) return;

            this.querySelectorAll('[data-cart-toggle]')?.forEach((button) => {
              button.addEventListener('click', (e) => {
                const cartDrawer = document.querySelector('cart-drawer');

                if (cartDrawer) {
                  e.preventDefault();
                  cartDrawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show'));
                  window.a11y.lastElement = button;
                }
              });
            });
          }

          stickyHeaderState(event) {
            const scrolled = window.scrollY;
            const scrollUp = event && event.detail && event.detail.up;
            const topAnnouncementBar = document.querySelector('[data-announcement-wrapper].announcement__wrapper--top');
            const announcementBarHeight = topAnnouncementBar ? topAnnouncementBar.offsetHeight : 0;
            const scrollThreshold = this.headerInitialHeight + announcementBarHeight;
            const hadScrolledClass = this.classList.contains('header--has-scrolled');

            if (scrollUp && scrolled < scrollThreshold * 2) {
              this.classList.add('header--is-hiding');
            } else {
              this.classList.remove('header--is-hiding');
            }

            if (scrolled > scrollThreshold) {
              if (!hadScrolledClass) {
                const fullHeight = this.offsetHeight;
                if (fullHeight > 0) {
                  this.headerInitialHeight = fullHeight;
                }
              }

              this.classList.add('header--has-scrolled');
              this.classList.remove('header--transparent');
            } else {
              this.classList.remove('header--has-scrolled');

              if (this.isHeaderTransparent()) {
                this.classList.add('header--transparent');
              }

              if (hadScrolledClass) {
                const {headerInitialHeight} = window.theme.readHeights();
                this.headerInitialHeight = headerInitialHeight || this.offsetHeight;
              }
            }
          }

          updateHeaderHeight() {
            this.refreshHeaderHeight();

            if (this.classList.contains('header--sticky')) {
              this.stickyHeaderState();
            }
          }

          refreshHeaderHeight() {
            const {headerInitialHeight} = window.theme.readHeights();
            if (headerInitialHeight > 0) {
              this.headerInitialHeight = headerInitialHeight;
            }
          }

          checkNavigationOverlapping() {
            this.classList.remove('header--is-hamburger');
            this.classList.add('header--is-standard');

            if (this.getNavigationOverlapping() || theme.isSmall()) {
              this.classList.remove('header--is-standard');
              this.classList.add('header--is-hamburger');
            }
          }

          checkMobileNav() {
            const isHamburgerNavOpen = document.body.classList.contains('nav--is-visible');

            if (isHamburgerNavOpen && theme.isLarge()) {
              this.resetHeader();
            }
          }

          checkTransparentHeader() {
            if (this.isHeaderTransparent()) {
              document.body.classList.add('has-transparent-header');
              this.classList.add('header--transparent');
            } else {
              document.body.classList.remove('has-transparent-header');
              this.classList.remove('header--transparent');
            }
          }

          getNavigationOverlapping() {
            const row = this.querySelector('.wrapper--full-padded > .row');
            const headerIcons = this.querySelector('[data-header-icons]');
            if (!row || !headerIcons) return true;

            const headerRowWidth = row.offsetWidth;
            const navMenuWidth = this.getMenuItemsWidth();
            const headerClasses = this.classList;
            const isNavCentered = headerClasses.contains('header--logo-left-links-center');
            const isNavLeftLogoCentered = headerClasses.contains('header--logo-center-links-left');
            const additionalSpace = 80;
            let isNavigationOverlapping = false;
            let headerIconsWidth = headerIcons.offsetWidth;
            let logoWidth = this.getLogoWidth();

            if (isNavCentered) {
              logoWidth = logoWidth < headerIconsWidth ? headerIconsWidth : logoWidth;
              logoWidth *= 2;
              headerIconsWidth = 0;
            }

            isNavigationOverlapping = headerRowWidth < navMenuWidth + logoWidth + headerIconsWidth + additionalSpace;

            if (isNavLeftLogoCentered && logoWidth) {
              isNavigationOverlapping = (headerRowWidth - logoWidth) / 2 < navMenuWidth;
            }

            return isNavigationOverlapping;
          }

          getLogoWidth() {
            const logoImage = this.querySelector('[data-logo-image]');
            const logoText = this.querySelector('[data-logo-text]');
            let logoWidth = 0;

            if (logoImage !== null) {
              logoWidth = parseInt(logoImage.getAttribute('data-width'));
            }

            if (logoText !== null) {
              logoWidth += logoText.offsetWidth;
            }

            return logoWidth;
          }

          getMenuItemsWidth() {
            let itemsWidth = 0;
            const navStandard = this.querySelector('.nav-standard[data-nav-main]');
            if (!navStandard) return 0;

            const menuItems = navStandard.querySelectorAll('.menu > .menu-item');
            menuItems.forEach((menuItem) => {
              itemsWidth += this._outerWidth(menuItem);
            });

            return itemsWidth;
          }

          isHeaderTransparent() {
            const firstSection = document.querySelector('.main-content').firstElementChild;

            if (!firstSection) return false;

            const firstSectionClass = firstSection?.classList.contains('header--full');
            const firstSectionStyle = firstSection?.querySelector('[data-header-style="transparent"]') !== null;
            const transparentHeader = this.getAttribute('data-transparent') === 'true';
            const headerFull = firstSectionClass || firstSectionStyle;
            const headerTransparent = transparentHeader && headerFull;

            return headerTransparent;
          }

          resetHeader() {
            const hamburger = this.querySelector('[data-hamburger-icon]');

            document.body.classList.remove('nav--is-visible');
            hamburger.classList.remove('open');

            if (document.body.classList.contains('cart--is-visible')) {
              document.querySelector('[data-cart-drawer-close]').click();
            }

            // Unlock page scroll
            document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
          }

          bindings() {
            const emptyLinks = this.headerSection.querySelectorAll('[data-nav-main] a[href^="#"]');
            const dropdownParents = this.navStandard.querySelectorAll('[data-dropdown-parent]');
            const dropdownTriggers = this.headerSection.querySelectorAll('[data-nav-main] [data-collapsible-trigger]');
            const triggers = [...dropdownTriggers, ...emptyLinks];

            // Init Bindings
            this.menuToggles.forEach((menuToggle) => {
              menuToggle.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopImmediatePropagation();

                if (document.body.classList.contains('nav--is-visible')) {
                  this.hideMobileNav();
                } else {
                  window.a11y.lastElement = e.currentTarget;
                  this.showMobileNav();
                }
              });
            });

            dropdownParents.forEach((dropdownParent) => {
              const visibleNavLinks = dropdownParent.querySelectorAll('[data-visible-link]');

              dropdownParent.addEventListener('mouseenter', () => {
                if (theme.touched) {
                  return;
                }

                if (!dropdownParent.classList.contains('menu-item--dropdown')) {
                  this.header.classList.add('header--megamenu-visible');
                }

                dropdownParent.classList.add('is-expanded');
                visibleNavLinks.forEach((link) => {
                  link.removeAttribute('tabindex');

                  if (link.hasAttribute('aria-expanded')) {
                    link.setAttribute('aria-expanded', true);
                  }
                });
              });

              dropdownParent.addEventListener('mouseleave', () => {
                if (!dropdownParent.classList.contains('menu-item--dropdown')) {
                  this.header.classList.remove('header--megamenu-visible');
                }

                dropdownParent.classList.remove('is-expanded');
                visibleNavLinks.forEach((link) => {
                  link.setAttribute('tabindex', '-1');

                  if (link.hasAttribute('aria-expanded')) {
                    link.setAttribute('aria-expanded', false);
                  }
                });
              });
            });

            triggers.forEach((trigger) => {
              trigger.addEventListener('click', () => {
                if (trigger.parentNode.classList.contains('is-expanded')) {
                  this.submenuClose(trigger.parentNode);
                } else {
                  this.submenuOpen(trigger.parentNode);
                }
              });

              trigger.addEventListener('keyup', (e) => {
                if (e.code === 'Space') {
                  if (trigger.parentNode.classList.contains('is-expanded')) {
                    this.submenuClose(trigger.parentNode);
                  } else {
                    this.submenuOpen(trigger.parentNode);
                  }
                } else if (e.code === 'Escape') {
                  this.submenuClose(trigger.parentNode);
                }
              });
            });

            // Hide hamburger menu on click outside
            document.addEventListener('click', this.documentClick);

            // Close header dropdowns on focus another elements or ESC key is pressed
            document.addEventListener('keyup', this.documentKeyup);
          }

          hideOnOutsideClick(e) {
            const menuToggle = this.headerIcons.querySelector('[data-menu-toggle]');
            const isMenuToggle = menuToggle.contains(e.target);
            const isMenuContainer = document.querySelector('[data-hamburger-scrollable]').parentNode.contains(e.target);
            const isHamburgerOpen = document.body.classList.contains('nav--is-visible');

            // Close hamburger menu
            if (!isMenuToggle && !isMenuContainer && isHamburgerOpen) {
              this.hideMobileNav();
            }
          }

          hideOnKeyUp(e) {
            const key = e.code;
            const focusedElement = e.target;
            const hamburgerMenu = this.headerSection.querySelectorAll('[data-nav-main]')[1];
            const isHamburgerOpen = this.hamburger.classList.contains('open');
            const expandedItem = document.querySelector('[data-dropdown-parent].is-expanded');

            if (key !== 'Tab' && key !== 'Escape') {
              return;
            }

            if (key === 'Tab') {
              // Close dropdown
              if (focusedElement.hasAttribute('data-menu-item-link') && expandedItem !== null) {
                expandedItem.querySelector('[data-collapsible-trigger]').dispatchEvent(new Event('click'));
              }

              // Close hamburger menu
              if (!hamburgerMenu.contains(focusedElement) && isHamburgerOpen) {
                this.hideMobileNav();
              }
            } else if (key === 'Escape') {
              if (expandedItem !== null) {
                expandedItem.querySelector('[data-collapsible-trigger]').dispatchEvent(new Event('click'));
              }

              if (isHamburgerOpen) {
                this.hideMobileNav();
              }
            }
          }

          showMobileNav() {
            const headerIconsLinks = this.headerIcons.querySelectorAll('a:not([data-menu-toggle])');

            // Scroll lock
            document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: this.scrollableElement}));

            this.hamburger.classList.add('open');
            document.body.classList.add('nav--is-visible');

            headerIconsLinks.forEach((iconLink) => iconLink.setAttribute('tabindex', '-1'));
            this.hamburgerNavLinks.forEach((hamburgerNavLink) => hamburgerNavLink.removeAttribute('tabindex'));
            this.menuToggles.forEach((menuToggle) => menuToggle.setAttribute('aria-expanded', true));

            if (this.mobileNav) {
              this.a11y.trapFocus(this.mobileNav, {
                elementToFocus: this.mobileNav.querySelector('.nav-mobile-close') || this.scrollableElement,
              });
            }
          }

          hideMobileNav() {
            const headerIconsLinks = this.headerIcons.querySelectorAll('a');

            if (!document.body.classList.contains('nav--is-visible')) {
              return;
            }

            this.hamburger.classList.remove('open');
            document.body.classList.add('nav--is-hiding');
            document.body.classList.remove('nav--is-visible');
            this.a11y.removeTrapFocus();

            if (this.scrollLockTimeout) {
              clearTimeout(this.scrollLockTimeout);
            }

            this.scrollLockTimeout = setTimeout(() => {
              // Scroll unlock
              document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
              document.body.classList.remove('nav--is-hiding');
            }, 500);

            headerIconsLinks.forEach((iconLink) => iconLink.removeAttribute('tabindex'));
            this.hamburgerNavLinks.forEach((hamburgerNavLink) => hamburgerNavLink.setAttribute('tabindex', '-1'));
            this.menuToggles.forEach((menuToggle) => menuToggle.setAttribute('aria-expanded', false));
            this.a11y.autoFocusLastElement();
          }

          activeLinks() {
            const menuItemLinks = this.navStandard.querySelectorAll('[data-menu-item-link]');
            const visibleNavLinks = this.navStandard.querySelectorAll('[data-visible-link]');
            let isTopLevel = false;

            menuItemLinks.forEach((link) => {
              if (link.getAttribute('href') === window.location.pathname) {
                link.parentNode.classList.add('is-active');
                isTopLevel = true;
              }
            });

            if (!isTopLevel) {
              visibleNavLinks.forEach((link) => {
                if (link.getAttribute('href') === window.location.pathname) {
                  link.parentNode.classList.add('is-active');
                  link.closest('[data-dropdown-parent]').classList.add('is-active');
                }
              });
            }
          }

          submenuClose(el) {
            const visibleNavLinks = el.querySelectorAll('[data-visible-link]');

            visibleNavLinks.forEach((link) => {
              link.setAttribute('tabindex', '-1');

              if (link.hasAttribute('aria-expanded')) {
                link.setAttribute('aria-expanded', false);
              }
            });

            if (el.classList.contains('menu-item--meganav')) {
              this.header.classList.remove('header--megamenu-visible');
            }
          }

          submenuOpen(menu) {
            const visibleNavLinks = menu.querySelectorAll('[data-visible-link]');

            visibleNavLinks.forEach((link) => {
              link.removeAttribute('tabindex');

              if (link.hasAttribute('aria-expanded')) {
                link.setAttribute('aria-expanded', true);
              }
            });

            if (menu.classList.contains('menu-item--meganav')) {
              this.header.classList.add('header--megamenu-visible');
            }
          }

          disconnectedCallback() {
            document.removeEventListener('theme:scroll', this.headerStateEvent);
            document.removeEventListener('theme:resize:width', this.checkNavOverlapEvent);
            document.removeEventListener('theme:resize:width', this.checkMobileNavEvent);
            document.removeEventListener('theme:resize:width', this.updateHeaderHeightEvent);
            document.removeEventListener('theme:header:update', this.checkTransparentHeaderEvent);
            document.removeEventListener('shopify:section:select', this.onSectionSelectEvent);
            document.removeEventListener('click', this.documentClick);
            document.removeEventListener('keyup', this.documentKeyup);
          }

          onSectionSelect() {
            this.resetHeader();
          }

          _outerWidth(el) {
            const style = getComputedStyle(el);
            let width = el.offsetWidth;

            width += parseInt(style.marginLeft) + parseInt(style.marginRight);

            return width;
          }
        }
      );
    }

    const selectors$j = {
      details: 'details',
      input: 'input:not([type="hidden"])',
      popdown: '[data-popdown]',
      popdownClose: '[data-popdown-close]',
      popdownToggle: '[data-popdown-toggle]',
      predictiveSearch: 'predictive-search',
    };

    const classes$b = {
      searchPopdownVisible: 'has-search-popdown-visible',
    };

    class SearchPopdown extends HTMLElement {
      constructor() {
        super();
        this.popdown = this.querySelector(selectors$j.popdown);
        this.popdownContainer = this.querySelector(selectors$j.details);
        this.popdownToggle = this.querySelector(selectors$j.popdownToggle);
        this.popdownClose = this.querySelector(selectors$j.popdownClose);
        this.a11y = a11y$1;
      }

      connectedCallback() {
        this.popdownContainer.addEventListener('keyup', (event) => event.code === 'Escape' && this.close());
        this.popdownClose.addEventListener('click', this.close.bind(this));
        this.popdownToggle.addEventListener('click', this.onPopdownToggleClick.bind(this));
        this.popdown.addEventListener('transitionend', (event) => {
          if (event.propertyName == 'visibility' && this.popdownContainer.hasAttribute('open') && this.popdownContainer.getAttribute('open') == 'false') {
            this.closeCallback();
          }
        });
      }

      onPopdownToggleClick(event) {
        event.preventDefault();
        event.target.closest(selectors$j.details).hasAttribute('open') ? this.close() : this.open(event);
      }

      onBodyClick(event) {
        if (!this.contains(event.target)) this.close();
      }

      open(event) {
        this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
        event.target.closest(selectors$j.details).setAttribute('open', '');

        document.body.addEventListener('click', this.onBodyClickEvent);
        document.body.classList.add(classes$b.searchPopdownVisible);
        document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: this.popdown}));

        // Safari opening transition fix
        requestAnimationFrame(() => {
          event.target.closest(selectors$j.details).setAttribute('open', 'true');

          // Trap focus after opening transition ends
          this.popdown.addEventListener(
            'transitionend',
            (e) => {
              if (e.target == this.popdown) {
                this.a11y.trapFocus(this.popdown, {
                  elementToFocus: this.popdown.querySelector(selectors$j.input),
                });
                theme.a11yTrigger = event.target;
              }
            },
            {once: true}
          );
        });
      }

      close() {
        this.popdownContainer.setAttribute('open', 'false');

        document.body.removeEventListener('click', this.onBodyClickEvent);
        document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
      }

      closeCallback() {
        this.popdownContainer.removeAttribute('open');
        this.a11y.removeTrapFocus();
        if (theme.a11yTrigger !== null) {
          theme.a11yTrigger.focus();
        }

        document.body.classList.remove(classes$b.searchPopdownVisible);
      }
    }

    customElements.define('header-search-popdown', SearchPopdown);

    /**
     * A11y Helpers
     * -----------------------------------------------------------------------------
     * A collection of useful functions that help make your theme more accessible
     */

    // Define trapFocusHandlers as a global variable within the module.
    const trapFocusHandlers = {};

    const a11y = {
      /**
       * Moves focus to an HTML element
       * @param {Element} element - The element to focus on.
       * @param {Object} options - Settings unique to your theme.
       * @param {string} options.className - Class name to apply to element on focus.
       */
      forceFocus(element, options) {
        options = options || {};

        var savedTabIndex = element.tabIndex;

        element.tabIndex = -1;
        element.dataset.tabIndex = savedTabIndex;
        element.focus({preventScroll: Boolean(options.preventScroll)});
        if (typeof options.className !== 'undefined') {
          element.classList.add(options.className);
        }
        element.addEventListener('blur', callback);

        function callback(event) {
          event.target.removeEventListener(event.type, callback);

          element.tabIndex = savedTabIndex;
          delete element.dataset.tabIndex;
          if (typeof options.className !== 'undefined') {
            element.classList.remove(options.className);
          }
        }
      },

      /**
       * Focus the appropriate element based on the URL hash.
       * @param {Object} options - Settings unique to your theme.
       */
      focusHash(options) {
        options = options || {};
        var hash = window.location.hash;
        var element = document.getElementById(hash.slice(1));

        if (element && options.ignore && element.matches(options.ignore)) {
          return false;
        }

        if (hash && element) {
          this.forceFocus(element, options);
        }
      },

      /**
       * Bind in-page links to focus the appropriate element.
       * @param {Object} options - Settings unique to your theme.
       */
      bindInPageLinks(options) {
        options = options || {};
        var links = Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]'));

        function queryCheck(selector) {
          return document.getElementById(selector) !== null;
        }

        return links.filter((link) => {
          if (link.hash === '#' || link.hash === '') {
            return false;
          }

          if (options.ignore && link.matches(options.ignore)) {
            return false;
          }

          if (!queryCheck(link.hash.substr(1))) {
            return false;
          }

          var element = document.querySelector(link.hash);

          if (!element) {
            return false;
          }

          link.addEventListener('click', () => {
            this.forceFocus(element, options);
          });

          return true;
        });
      },

      focusable(container) {
        var elements = Array.prototype.slice.call(
          container.querySelectorAll('[tabindex],' + '[draggable],' + 'a[href],' + 'area,' + 'button:enabled,' + 'input:not([type=hidden]):enabled,' + 'object,' + 'select:enabled,' + 'textarea:enabled')
        );

        return elements.filter((element) => Boolean((element.offsetWidth || element.offsetHeight || element.getClientRects().length) && this.isVisible(element)));
      },

      trapFocus(container, options) {
        options = options || {};
        var elements = this.focusable(container);
        var elementToFocus = options.elementToFocus || container;
        var first = elements[0];
        var last = elements[elements.length - 1];
        var preventScroll = Boolean(options.preventScroll);

        this.removeTrapFocus();

        trapFocusHandlers.focusin = function (event) {
          if (container !== event.target && !container.contains(event.target)) {
            if (first) {
              first.focus({preventScroll: preventScroll});
            }
          }

          if (event.target !== container && event.target !== last && event.target !== first) return;
          document.addEventListener('keydown', trapFocusHandlers.keydown);
        };

        trapFocusHandlers.focusout = function () {
          document.removeEventListener('keydown', trapFocusHandlers.keydown);
        };

        trapFocusHandlers.keydown = function (event) {
          if (event.code !== 'Tab') return;

          if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus({preventScroll: preventScroll});
          }

          if ((event.target === container || event.target === first) && event.shiftKey) {
            event.preventDefault();
            last.focus({preventScroll: preventScroll});
          }
        };

        document.addEventListener('focusout', trapFocusHandlers.focusout);
        document.addEventListener('focusin', trapFocusHandlers.focusin);

        this.forceFocus(elementToFocus, options);
      },

      removeTrapFocus() {
        document.removeEventListener('focusin', trapFocusHandlers.focusin);
        document.removeEventListener('focusout', trapFocusHandlers.focusout);
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
      },

      autoFocusLastElement() {
        if (window.a11y.lastElement && document.body.classList.contains('is-focused')) {
          setTimeout(() => {
            window.a11y.lastElement?.focus();
          });
        }
      },

      accessibleLinks(elements, options) {
        if (typeof elements !== 'string') {
          throw new TypeError(elements + ' is not a String.');
        }

        elements = document.querySelectorAll(elements);

        if (elements.length === 0) {
          return;
        }

        options = options || {};
        options.messages = options.messages || {};

        var messages = {
          newWindow: options.messages.newWindow || 'Opens in a new window.',
          external: options.messages.external || 'Opens external website.',
          newWindowExternal: options.messages.newWindowExternal || 'Opens external website in a new window.',
        };

        var prefix = options.prefix || 'a11y';

        var messageSelectors = {
          newWindow: prefix + '-new-window-message',
          external: prefix + '-external-message',
          newWindowExternal: prefix + '-new-window-external-message',
        };

        function generateHTML(messages) {
          var container = document.createElement('ul');
          var htmlMessages = Object.keys(messages).reduce((html, key) => {
            return (html += '<li id=' + messageSelectors[key] + '>' + messages[key] + '</li>');
          }, '');

          container.setAttribute('hidden', true);
          container.innerHTML = htmlMessages;

          document.body.appendChild(container);
        }

        function externalSite(link) {
          return link.hostname !== window.location.hostname;
        }

        elements.forEach((link) => {
          var target = link.getAttribute('target');
          var rel = link.getAttribute('rel');
          var isExternal = externalSite(link);
          var isTargetBlank = target === '_blank';
          var missingRelNoopener = rel === null || rel.indexOf('noopener') === -1;

          if (isTargetBlank && missingRelNoopener) {
            var relValue = rel === null ? 'noopener' : rel + ' noopener';
            link.setAttribute('rel', relValue);
          }

          if (isExternal && isTargetBlank) {
            link.setAttribute('aria-describedby', messageSelectors.newWindowExternal);
          } else if (isExternal) {
            link.setAttribute('aria-describedby', messageSelectors.external);
          } else if (isTargetBlank) {
            link.setAttribute('aria-describedby', messageSelectors.newWindow);
          }
        });

        generateHTML(messages);
      },

      isVisible(el) {
        var style = window.getComputedStyle(el);
        return style.display !== 'none' && style.visibility !== 'hidden';
      },
    };

    window.theme = window.theme || {};
    window.theme.a11y = a11y;

    window.theme.throttle = (fn, wait) => {
      let prev, next;
      return function invokeFn(...args) {
        const now = Date.now();
        next = clearTimeout(next);
        if (!prev || now - prev >= wait) {
          // eslint-disable-next-line prefer-spread
          fn.apply(null, args);
          prev = now;
        } else {
          next = setTimeout(invokeFn.bind(null, ...args), wait - (now - prev));
        }
      };
    };

    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);

          publish(theme.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      get selectedOptionValues() {
        const selectedNativeDropdowns = Array.from(this.querySelectorAll('select option[selected]'));
        const selectedRadios = Array.from(this.querySelectorAll('fieldset input:checked'));
        const selectedPopouts = Array.from(this.querySelectorAll('[data-popout-input]'));

        return [...selectedNativeDropdowns, ...selectedRadios, ...selectedPopouts].map(({dataset}) => dataset.optionValueId).filter((id) => Boolean(id));
      }
    }

    customElements.define('variant-selects', VariantSelects);

    class HTMLUpdateUtility {
      /**
       * Used to swap an HTML node with a new node.
       * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
       *
       * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
       */
      static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
        preProcessCallbacks?.forEach((callback) => callback(newContent));

        const newNodeWrapper = document.createElement('div');
        HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
        const newNode = newNodeWrapper.firstChild;

        // dedupe IDs
        const uniqueKey = Date.now();
        oldNode.querySelectorAll('[id], [form]').forEach((element) => {
          element.id && (element.id = `${element.id}-${uniqueKey}`);
          element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
        });

        oldNode.parentNode.insertBefore(newNode, oldNode);
        oldNode.style.display = 'none';

        postProcessCallbacks?.forEach((callback) => callback(newNode));

        setTimeout(() => oldNode.remove(), 500);
      }

      // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      static setInnerHTML(element, html) {
        element.innerHTML = html;
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }
    }

    window.HTMLUpdateUtility = HTMLUpdateUtility;

    class QuantityInput extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', {bubbles: true});
        this.input.addEventListener('change', this.onInputChange.bind(this));
        this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
      }

      quantityUpdateUnsubscriber = undefined;

      connectedCallback() {
        this.validateQtyRules();
        this.quantityUpdateUnsubscriber = subscribe(theme.PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
      }

      disconnectedCallback() {
        if (this.quantityUpdateUnsubscriber) {
          this.quantityUpdateUnsubscriber();
        }
      }

      onInputChange(event) {
        this.validateQtyRules();
        if (this.input && this.input.name === 'updates[]') {
          this.updateCart();
        }
      }

      onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        const button = event.target.nodeName === 'BUTTON' ? event.target : event.target.closest('button');
        const name = button ? button.name : undefined;

        const isIncrease = name === 'increase' || name === 'plus';
        const isDecrease = name === 'decrease' || name === 'minus';

        if (isIncrease) {
          if (parseInt(this.input?.dataset?.min) > parseInt(this.input.step) && this.input.value == 0) {
            this.input.value = this.input.dataset.min;
          } else {
            this.input.stepUp();
          }
        } else if (isDecrease) {
          this.input.stepDown();
        }

        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

        if (this.input?.dataset?.min === previousValue && isDecrease) {
          this.input.value = parseInt(this.input.min);
        }
      }

      validateQtyRules() {
        const value = parseInt(this.input.value);
        if (this.input.min) {
          const buttonDecrease = this.querySelector("button[name='decrease']");
          if (buttonDecrease) buttonDecrease.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
        }
        if (this.input.max) {
          const max = parseInt(this.input.max);
          const buttonIncrease = this.querySelector("button[name='increase']");
          if (buttonIncrease) buttonIncrease.classList.toggle('disabled', value >= max);
        }
      }

      updateCart() {
        if (!this.input || this.input.value === '') return;

        this.dispatchEvent(
          new CustomEvent('theme:cart:update', {
            bubbles: true,
            detail: {
              id: this.input.dataset.id,
              quantity: this.input.value,
            },
          })
        );
      }
    }

    if (!customElements.get('quantity-input')) {
      customElements.define('quantity-input', QuantityInput);
    }

    function isTouchDevice() {
      return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }

    function isTouch() {
      if (isTouchDevice()) {
        document.documentElement.className = document.documentElement.className.replace('no-touch', 'supports-touch');
        window.theme.touch = true;
      } else {
        window.theme.touch = false;
      }
    }

    function floatLabels(container) {
      const floats = container.querySelectorAll('.form-field');
      floats.forEach((element) => {
        const label = element.querySelector('label');
        const input = element.querySelector('input, textarea');
        if (label && input) {
          input.addEventListener('keyup', (event) => {
            if (event.target.value !== '') {
              label.classList.add('label--float');
            } else {
              label.classList.remove('label--float');
            }
          });
          if (input.value && input.value.length) {
            label.classList.add('label--float');
          }
        }
      });
    }

    let lastWindowWidth = window.theme.getWindowWidth();
    let lastWindowHeight = window.theme.getWindowHeight();

    function dispatch$1() {
      document.dispatchEvent(
        new CustomEvent('theme:resize', {
          bubbles: true,
        })
      );

      if (lastWindowWidth !== window.theme.getWindowWidth()) {
        document.dispatchEvent(
          new CustomEvent('theme:resize:width', {
            bubbles: true,
          })
        );

        lastWindowWidth = window.theme.getWindowWidth();
      }

      if (lastWindowHeight !== window.theme.getWindowHeight()) {
        document.dispatchEvent(
          new CustomEvent('theme:resize:height', {
            bubbles: true,
          })
        );

        lastWindowHeight = window.theme.getWindowHeight();
      }
    }

    function resizeListener() {
      window.addEventListener(
        'resize',
        window.theme.debounce(function () {
          dispatch$1();
        }, 50)
      );
    }

    let prev = window.scrollY;
    let up = null;
    let down = null;
    let wasUp = null;
    let wasDown = null;
    let scrollLockTimer = 0;

    function dispatch() {
      const position = window.scrollY;
      if (position > prev) {
        down = true;
        up = false;
      } else if (position < prev) {
        down = false;
        up = true;
      } else {
        up = null;
        down = null;
      }
      prev = position;
      document.dispatchEvent(
        new CustomEvent('theme:scroll', {
          detail: {
            up,
            down,
            position,
          },
          bubbles: false,
        })
      );
      if (up && !wasUp) {
        document.dispatchEvent(
          new CustomEvent('theme:scroll:up', {
            detail: {position},
            bubbles: false,
          })
        );
      }
      if (down && !wasDown) {
        document.dispatchEvent(
          new CustomEvent('theme:scroll:down', {
            detail: {position},
            bubbles: false,
          })
        );
      }
      wasDown = down;
      wasUp = up;
    }

    function lock(e) {
      // Prevent body scroll lock race conditions
      setTimeout(() => {
        if (scrollLockTimer) {
          clearTimeout(scrollLockTimer);
        }

        scrollLock.disablePageScroll(e.detail, {
          allowTouchMove: (el) => el.tagName === 'TEXTAREA',
        });

        document.documentElement.setAttribute('data-scroll-locked', '');
      });
    }

    function unlock(e) {
      const timeout = e.detail;

      if (timeout) {
        scrollLockTimer = setTimeout(removeScrollLock, timeout);
      } else {
        removeScrollLock();
      }
    }

    function removeScrollLock() {
      scrollLock.clearQueueScrollLocks();
      scrollLock.enablePageScroll();
      document.documentElement.removeAttribute('data-scroll-locked');
    }

    function scrollListener() {
      let timeout;
      window.addEventListener(
        'scroll',
        function () {
          if (timeout) {
            window.cancelAnimationFrame(timeout);
          }
          timeout = window.requestAnimationFrame(function () {
            dispatch();
          });
        },
        {passive: true}
      );

      window.addEventListener('theme:scroll:lock', lock);
      window.addEventListener('theme:scroll:unlock', unlock);
    }

    const wrap = (toWrap, wrapperClass = '', wrapperOption) => {
      const wrapper = wrapperOption || document.createElement('div');
      wrapper.classList.add(wrapperClass);
      toWrap.parentNode.insertBefore(wrapper, toWrap);
      return wrapper.appendChild(toWrap);
    };

    function wrapElements(container) {
      // Target tables to make them scrollable
      const tableSelectors = '.rte table';
      const tables = container.querySelectorAll(tableSelectors);
      tables.forEach((table) => {
        wrap(table, 'rte__table-wrapper');
        table.setAttribute('data-scroll-lock-scrollable', '');
      });

      // Target iframes to make them responsive
      const iframeSelectors = '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe';
      const frames = container.querySelectorAll(iframeSelectors);
      frames.forEach((frame) => {
        wrap(frame, 'rte__video-wrapper');
      });
    }

    function ariaToggle(container) {
      const toggleButtons = container.querySelectorAll('[data-aria-toggle]');
      if (toggleButtons.length) {
        toggleButtons.forEach((element) => {
          element.addEventListener('click', function (event) {
            event.preventDefault();
            const currentTarget = event.currentTarget;
            currentTarget.setAttribute('aria-expanded', currentTarget.getAttribute('aria-expanded') == 'false' ? 'true' : 'false');
            const toggleID = currentTarget.getAttribute('aria-controls');
            const toggleElement = document.querySelector(`#${toggleID}`);
            const removeExpandingClass = () => {
              toggleElement.classList.remove('expanding');
              toggleElement.removeEventListener('transitionend', removeExpandingClass);
            };
            const addExpandingClass = () => {
              toggleElement.classList.add('expanding');
              toggleElement.removeEventListener('transitionstart', addExpandingClass);
            };

            toggleElement.addEventListener('transitionstart', addExpandingClass);
            toggleElement.addEventListener('transitionend', removeExpandingClass);

            toggleElement.classList.toggle('expanded');
          });
        });
      }
    }

    const classes$a = {
      loading: 'is-loading',
    };

    const selectors$i = {
      img: 'img.is-loading',
    };

    /*
      Catch images loaded events and add class "is-loaded" to them and their containers
    */
    function loadedImagesEventHook() {
      document.addEventListener(
        'load',
        (e) => {
          if (e.target.tagName.toLowerCase() == 'img' && e.target.classList.contains(classes$a.loading)) {
            e.target.classList.remove(classes$a.loading);
            e.target.parentNode.classList.remove(classes$a.loading);

            if (e.target.parentNode.parentNode.classList.contains(classes$a.loading)) {
              e.target.parentNode.parentNode.classList.remove(classes$a.loading);
            }
          }
        },
        true
      );
    }

    /*
      Remove "is-loading" class to the loaded images and their containers
    */
    function removeLoadingClassFromLoadedImages(container) {
      container.querySelectorAll(selectors$i.img).forEach((img) => {
        if (img.complete) {
          img.classList.remove(classes$a.loading);
          img.parentNode.classList.remove(classes$a.loading);

          if (img.parentNode.parentNode.classList.contains(classes$a.loading)) {
            img.parentNode.parentNode.classList.remove(classes$a.loading);
          }
        }
      });
    }

    const selectors$h = {
      aos: '[data-aos]:not(.aos-animate)',
      aosAnchor: '[data-aos-anchor]',
      aosIndividual: '[data-aos]:not([data-aos-anchor]):not(.aos-animate)',
    };

    const classes$9 = {
      aosAnimate: 'aos-animate',
    };

    const observerConfig = {
      attributes: false,
      childList: true,
      subtree: true,
    };

    let anchorContainers = [];

    const mutationCallback = (mutationList) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
          const element = mutation.target;
          const elementsToAnimate = element.querySelectorAll(selectors$h.aos);
          const anchors = element.querySelectorAll(selectors$h.aosAnchor);

          if (elementsToAnimate.length) {
            elementsToAnimate.forEach((element) => {
              aosItemObserver.observe(element);
            });
          }

          if (anchors.length) {
            // Get all anchors and attach observers
            initAnchorObservers(anchors);
          }
        }
      }
    };

    /*
      Observe each element that needs to be animated
    */
    const aosItemObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(classes$9.aosAnimate);

            // Stop observing element after it was animated
            observer.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
      }
    );

    /*
      Observe anchor elements
    */
    const aosAnchorObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio) {
            const elementsToAnimate = entry.target.querySelectorAll(selectors$h.aos);

            if (elementsToAnimate.length) {
              elementsToAnimate.forEach((item) => {
                item.classList.add(classes$9.aosAnimate);
              });
            }

            // Stop observing anchor element after inner elements were animated
            observer.unobserve(entry.target);

            // Remove the container from the anchorContainers array
            const sectionIndex = anchorContainers.indexOf('#' + entry.target.id);
            if (sectionIndex !== -1) {
              anchorContainers.splice(sectionIndex, 1);
            }
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: [0.1, 0.25, 0.5, 0.75, 1],
      }
    );

    /*
      Watch for mutations in the body and start observing the newly added animated elements and anchors
    */
    function bodyMutationObserver() {
      const bodyObserver = new MutationObserver(mutationCallback);
      bodyObserver.observe(document.body, observerConfig);
    }

    /*
      Observe animated elements that have attribute [data-aos]
    */
    function elementsIntersectionObserver() {
      const elementsToAnimate = document.querySelectorAll(selectors$h.aosIndividual);

      if (elementsToAnimate.length) {
        elementsToAnimate.forEach((element) => {
          aosItemObserver.observe(element);
        });
      }
    }

    /*
      Observe animated elements that have attribute [data-aos]
    */
    function anchorsIntersectionObserver() {
      const anchors = document.querySelectorAll(selectors$h.aosAnchor);

      if (anchors.length) {
        // Get all anchors and attach observers
        initAnchorObservers(anchors);
      }
    }

    function initAnchorObservers(anchors) {
      if (!anchors.length || Shopify.visualPreviewMode) return;

      anchors.forEach((anchor) => {
        const containerId = anchor.dataset.aosAnchor;

        // Avoid adding multiple observers to the same element
        if (containerId && anchorContainers.indexOf(containerId) === -1) {
          const container = document.querySelector(containerId);

          if (container) {
            aosAnchorObserver.observe(container);
            anchorContainers.push(containerId);
          }
        }
      });
    }

    function initAnimations() {
      elementsIntersectionObserver();
      anchorsIntersectionObserver();
      bodyMutationObserver();

      // Remove unloaded section from the anchors array on section:unload event
      document.addEventListener('shopify:section:unload', (e) => {
        if (typeof e.target !== 'object' || e.target.nodeValue === 'undefined') return;

        const sectionId = '#' + e.target.querySelector('[data-section-id]')?.id;
        const sectionIndex = anchorContainers.indexOf(sectionId);

        if (sectionIndex !== -1) {
          anchorContainers.splice(sectionIndex, 1);
        }
      });
    }

    // Safari requestIdleCallback polyfill
    window.requestIdleCallback =
      window.requestIdleCallback ||
      function (cb) {
        var start = Date.now();
        return setTimeout(function () {
          cb({
            didTimeout: false,
            timeRemaining: function () {
              return Math.max(0, 50 - (Date.now() - start));
            },
          });
        }, 1);
      };
    window.cancelIdleCallback =
      window.cancelIdleCallback ||
      function (id) {
        clearTimeout(id);
      };

    // Animate on scroll
    const showAnimations = document.body.getAttribute('data-animations') === 'true';
    if (showAnimations) {
      initAnimations();
    }

    resizeListener();
    scrollListener();
    isTouch();
    loadedImagesEventHook();

    window.addEventListener('DOMContentLoaded', () => {
      floatLabels(document);
      ariaToggle(document);
      wrapElements(document);
      removeLoadingClassFromLoadedImages(document);
    });

    document.addEventListener('shopify:section:load', (e) => {
      const container = e.target;
      if (typeof container !== 'object' || container.nodeValue === 'undefined') return;

      floatLabels(container);
      wrapElements(container);
      ariaToggle(document);

      document.dispatchEvent(new CustomEvent('theme:header:update', {bubbles: true}));
    });

    document.addEventListener('shopify:section:reorder', () => {
      document.dispatchEvent(new CustomEvent('theme:header:update', {bubbles: true}));
    });

    document.addEventListener('shopify:section:unload', () => {
      // When you hide/disable a section, the unload event is fired before the section is actually removed from the DOM
      // We need a little delay before checking for transparent header to make sure it's already removed from the DOM
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('theme:header:update', {bubbles: true}));
      }, 200);
    });

    const classes$8 = {
      focus: 'is-focused',
    };

    const selectors$g = {
      inPageLink: '[data-skip-content]',
      linkesWithOnlyHash: 'a[href="#"]',
    };

    class Accessibility {
      constructor() {
        this.init();
      }

      init() {
        this.a11y = window.theme.a11y;

        // DOM Elements
        this.html = document.documentElement;
        this.body = document.body;
        this.inPageLink = document.querySelector(selectors$g.inPageLink);
        this.linkesWithOnlyHash = document.querySelectorAll(selectors$g.linkesWithOnlyHash);

        // A11Y init methods
        this.a11y.focusHash();
        this.a11y.bindInPageLinks();

        // Events
        this.clickEvents();
        this.focusEvents();
      }

      /**
       * Clicked events accessibility
       *
       * @return  {Void}
       */

      clickEvents() {
        if (this.inPageLink) {
          this.inPageLink.addEventListener('click', (event) => {
            event.preventDefault();
          });
        }

        if (this.linkesWithOnlyHash) {
          this.linkesWithOnlyHash.forEach((item) => {
            item.addEventListener('click', (event) => {
              event.preventDefault();
            });
          });
        }
      }

      /**
       * Focus events
       *
       * @return  {Void}
       */

      focusEvents() {
        document.addEventListener('mousedown', () => {
          this.body.classList.remove(classes$8.focus);
        });

        document.addEventListener('keyup', (event) => {
          if (event.code !== 'Tab') {
            return;
          }

          this.body.classList.add(classes$8.focus);
        });
      }
    }

    window.a11y = new Accessibility();

    /*
      Trigger event after animation completes
    */
    window.theme.waitForAnimationEnd = function (element) {
      return new Promise((resolve) => {
        function onAnimationEnd(event) {
          if (event.target != element) return;

          element.removeEventListener('animationend', onAnimationEnd);
          resolve();
        }

        element?.addEventListener('animationend', onAnimationEnd);
      });
    };

    function FetchError(object) {
      this.status = object.status || null;
      this.headers = object.headers || null;
      this.json = object.json || null;
      this.body = object.body || null;
    }
    FetchError.prototype = Error.prototype;

    const classes$7 = {
      active: 'is-active',
      added: 'is-added',
      disabled: 'is-disabled',
      empty: 'is-empty',
      error: 'has-error',
      headerStuck: 'js__header__stuck',
      hidden: 'is-hidden',
      hiding: 'is-hiding',
      loading: 'is-loading',
      open: 'is-open',
      success: 'is-success',
      visible: 'is-visible',
      expanded: 'is-expanded',
      updated: 'is-updated',
      variantSoldOut: 'variant--soldout',
      variantUnavailable: 'variant--unavailable',
      cartEmpty: 'cartToggle--empty',
    };

    const selectors$f = {
      apiContent: '[data-api-content]',
      apiLineItems: '[data-api-line-items]',
      apiCartPrice: '[data-api-cart-price]',
      cartBarAdd: '[data-cart-bar-add-to-cart]',
      cartCloseError: '[data-cart-error-close]',
      cartDrawer: 'cart-drawer',
      cartDrawerClose: '[data-cart-drawer-close]',
      cartEmpty: '[data-cart-empty]',
      cartErrors: '[data-cart-errors]',
      cartItemRemove: '[data-item-remove]',
      cartMessage: '[data-cart-message]',
      cartPage: '[data-cart-page]',
      cartForm: '[data-cart-form]',
      cartTermsCheckbox: '[data-cart-acceptance-checkbox]',
      cartCheckoutButtonWrapper: '[data-cart-checkout-buttons]',
      cartCheckoutButton: '[data-cart-checkout-button]',
      cartItemsCount: '[data-cart-items-count]',
      cartToggle: '[data-cart-toggle]',
      cartTotal: '[data-cart-total]',
      checkoutButtons: '[data-checkout-buttons]',
      emptyMessage: '[data-empty-message]',
      errorMessage: '[data-error-message]',
      formCloseError: '[data-close-error]',
      formErrorsContainer: '[data-cart-errors-container]',
      formWrapper: '[data-form-wrapper]',
      freeShipping: '[data-cart-message]',
      freeShippingProgress: '[data-cart-progress]',
      headerWrapper: '[data-header-wrapper]',
      item: '[data-item]',
      itemsHolder: '[data-items-holder]',
      leftToSpend: '[data-left-to-spend]',
      navDrawer: '[data-drawer]',
      outerSection: '[data-section-id]',
      priceHolder: '[data-cart-price-holder]',
      quickAddHolder: '[data-quick-add-holder]',
      quickAddModal: '[data-quick-add-modal]',
      qtyInput: 'input[name="updates[]"]',
      termsErrorMessage: '[data-terms-error-message]',
      collapsibleBody: '[data-collapsible-body]',
      discountInput: '[data-discount-input]',
      discountField: '[data-discount-field]',
      discountButton: '[data-apply-discount]',
      discountBody: '[data-discount-body]',
      discountCode: '[data-discount-code]',
      discountErrorMessage: '[data-discount-error-message]',
      removeDiscount: '[data-remove-discount]',
    };

    const attributes$2 = {
      cartTotal: 'data-cart-total',
      disabled: 'disabled',
      freeShipping: 'data-cart-message',
      cartTotalPrice: 'data-cart-total-price',
      freeMessageLimit: 'data-limit',
      item: 'data-item',
      itemIndex: 'data-item-index',
      itemTitle: 'data-item-title',
      open: 'open',
      quickAddHolder: 'data-quick-add-holder',
      quickAddVariant: 'data-quick-add-variant',
      scrollLocked: 'data-scroll-locked',
      name: 'name',
      maxInventoryReached: 'data-max-inventory-reached',
      errorMessagePosition: 'data-error-message-position',
      discountButton: 'data-cart-discount-button',
    };

    class CartItems extends HTMLElement {
      constructor() {
        super();

        this.a11y = window.theme.a11y;
      }

      connectedCallback() {
        // DOM Elements
        this.cartPage = document.querySelector(selectors$f.cartPage);
        this.cartForm = document.querySelector(selectors$f.cartForm);
        this.cartDrawer = document.querySelector(selectors$f.cartDrawer);
        this.cartEmpty = document.querySelector(selectors$f.cartEmpty);
        this.cartItemsCount = document.querySelector(selectors$f.cartItemsCount);
        this.cartTermsCheckbox = document.querySelector(selectors$f.cartTermsCheckbox);
        this.cartCheckoutButtonWrapper = document.querySelector(selectors$f.cartCheckoutButtonWrapper);
        this.cartCheckoutButton = document.querySelector(selectors$f.cartCheckoutButton);
        this.checkoutButtons = document.querySelector(selectors$f.checkoutButtons);
        this.itemsHolder = document.querySelector(selectors$f.itemsHolder);
        this.priceHolder = document.querySelector(selectors$f.priceHolder);
        this.items = document.querySelectorAll(selectors$f.item);
        this.cartTotal = document.querySelector(selectors$f.cartTotal);
        this.freeShipping = document.querySelectorAll(selectors$f.freeShipping);
        this.cartErrorHolder = document.querySelector(selectors$f.cartErrors);
        this.cartCloseErrorMessage = document.querySelector(selectors$f.cartCloseError);
        this.headerWrapper = document.querySelector(selectors$f.headerWrapper);
        this.navDrawer = document.querySelector(selectors$f.navDrawer);
        this.subtotal = window.theme.subtotal;
        this.discountInput = document.querySelector(selectors$f.discountInput);
        this.discountField = document.querySelector(selectors$f.discountField);
        this.discountButton = document.querySelector(selectors$f.discountButton);
        this.hasDiscountBlock = Boolean(document.querySelector(selectors$f.discountButton));
        this.discountErrorMessage = document.querySelector(selectors$f.discountErrorMessage);
        this.existingDiscountCodes = [];
        this.discounts = document.querySelectorAll(selectors$f.discountBody);
        this.emptyMessage = document.querySelector(selectors$f.emptyMessage);
        this.cartToggle = document.querySelector(selectors$f.cartToggle);
        this.cartMessage = document.querySelector(selectors$f.cartMessage);

        // Define Cart object depending on if we have cart drawer or cart page
        this.cart = this.cartDrawer || this.cartPage;

        // Discounts
        if (this.hasDiscountBlock) {
          this.discountButton.addEventListener('click', (event) => {
            event.preventDefault();

            const newDiscountCode = this.discountInput.value.trim();
            this.discountInput.value = '';

            if (newDiscountCode) {
              this.applyDiscount(newDiscountCode);
            }
          });

          // Fill existing discount codes and bind event listeners
          this.bindDiscountEventListeners();
        }

        // Cart events
        this.addToCart = this.addToCart.bind(this);
        this.cartAddEvent = this.cartAddEvent.bind(this);
        this.updateProgress = this.updateProgress.bind(this);
        this.onCartDrawerClose = this.onCartDrawerClose.bind(this);
        this.onCartRefresh = this.getCart.bind(this);

        // Set global event listeners for "Add to cart" and Announcement bar wheel progress
        document.addEventListener('theme:cart:add', this.cartAddEvent);
        document.addEventListener('theme:announcement:init', this.updateProgress);

        if (!theme.settings.enableAjaxCart) {
          document.addEventListener('theme:cart-drawer:close', this.onCartDrawerClose);
        }

        // Free Shipping values

        if (this.cartMessage) {
          this.cartFreeLimitShipping = Number(this.cartMessage.getAttribute(attributes$2.freeMessageLimit)) * window.Shopify.currency.rate;
          const subtotalAttr = this.cartMessage.getAttribute(attributes$2.cartTotalPrice);
          if (subtotalAttr !== null) {
            this.subtotal = Number(subtotalAttr);
          }
          this.updateProgress();
        }

        this.circumference = 28 * Math.PI; // radius - stroke * 4 * PI
        this.freeShippingLimit = this.freeShipping.length ? Number(this.freeShipping[0].getAttribute(attributes$2.freeMessageLimit)) * window.Shopify.currency.rate : 0;

        this.freeShippingMessageHandle(this.subtotal);
        this.updateProgress();

        this.build = this.build.bind(this);
        this.updateCart = this.updateCart.bind(this);
        this.productAddCallback = this.productAddCallback.bind(this);
        this.formSubmitHandler = window.theme.throttle(this.formSubmitHandler.bind(this), 50);

        if (this.cart) {
          // Checking
          this.hasItemsInCart = this.hasItemsInCart.bind(this);
          this.cartCount = this.getCartItemCount();
        }

        // Set classes
        this.toggleClassesOnContainers = this.toggleClassesOnContainers.bind(this);

        // Flags
        this.totalItems = this.items.length;
        this.showCannotAddMoreInCart = false;
        this.cartUpdateFailed = false;
        this.discountError = false;

        // Cart Events
        this.cartEvents();
        this.cartRemoveEvents();
        this.cartUpdateEvents();

        document.addEventListener('theme:product:add', this.productAddCallback);
        document.addEventListener('theme:product:add-error', this.productAddCallback);
        document.addEventListener('theme:cart:refresh', this.onCartRefresh);
      }

      disconnectedCallback() {
        document.removeEventListener('theme:cart:add', this.cartAddEvent);
        document.removeEventListener('theme:cart:refresh', this.onCartRefresh);
        document.removeEventListener('theme:announcement:init', this.updateProgress);
        document.removeEventListener('theme:product:add', this.productAddCallback);
        document.removeEventListener('theme:product:add-error', this.productAddCallback);

        if (document.documentElement.hasAttribute(attributes$2.scrollLocked)) {
          document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
        }
      }

      onCartDrawerClose() {
        if (this.cartDrawer?.classList.contains(classes$7.open)) {
          this.cart?.classList.remove(classes$7.updated);
        }

        this.cartEmpty?.classList.remove(classes$7.updated);
        this.cartErrorHolder?.classList.remove(classes$7.expanded);

        if (this.hasDiscountBlock) {
          this.discountErrorMessage?.classList.add('hidden');
        }
      }

      /**
       * Cart update event hook
       *
       * @return  {Void}
       */

      cartUpdateEvents() {
        this.items = document.querySelectorAll(selectors$f.item);

        this.items.forEach((item) => {
          item.addEventListener('theme:cart:update', (event) => {
            this.updateCart(
              {
                id: event.detail.id,
                quantity: event.detail.quantity,
              },
              item
            );
          });
        });
      }

      /**
       * Cart events
       *
       * @return  {Void}
       */

      cartRemoveEvents() {
        const cartItemRemove = document.querySelectorAll(selectors$f.cartItemRemove);

        cartItemRemove.forEach((button) => {
          const item = button.closest(selectors$f.item);
          button.addEventListener('click', (event) => {
            event.preventDefault();

            if (button.classList.contains(classes$7.disabled)) return;

            this.updateCart(
              {
                id: button.dataset.id,
                quantity: 0,
              },
              item
            );
          });
        });

        if (this.cartCloseErrorMessage) {
          this.cartCloseErrorMessage.addEventListener('click', (event) => {
            event.preventDefault();

            this.cartErrorHolder?.classList.remove(classes$7.expanded);
          });
        }
      }

      /**
       * Cart event add product to cart
       *
       * @return  {Void}
       */

      cartAddEvent(event) {
        let formData = '';
        let button = event.detail.button;

        if (button.hasAttribute('disabled')) return;
        const form = button.form || button.closest('form');
        // Validate form

        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }
        formData = new FormData(form);

        if (form !== null && form.querySelector('[type="file"]')) {
          return;
        }
        if (theme.settings.enableAjaxCart && this.cartDrawer) {
          event.preventDefault();
        }

        const maxInventoryReached = form.getAttribute(attributes$2.maxInventoryReached);
        const errorMessagePosition = form.getAttribute(attributes$2.errorMessagePosition);
        this.showCannotAddMoreInCart = false;
        if (maxInventoryReached === 'true' && errorMessagePosition === 'cart') {
          this.showCannotAddMoreInCart = true;
        }

        this.addToCart(formData, button);
      }

      /**
       * Bind event listeners for discount elements
       *
       * @return  {Void}
       */
      bindDiscountEventListeners() {
        if (!this.hasDiscountBlock) return;

        this.discounts = document.querySelectorAll(selectors$f.discountBody);

        this.discounts.forEach((discount) => {
          const discountCode = discount.dataset.discountCode;

          if (!this.existingDiscountCodes.includes(discountCode)) {
            this.existingDiscountCodes.push(discountCode);
          }

          // Add event listener to remove discount
          const removeButton = discount.querySelector(selectors$f.removeDiscount);
          if (removeButton) {
            // Remove existing listener to prevent duplicates
            removeButton.removeEventListener('click', this.handleRemoveDiscount);

            // Add new listener
            removeButton.addEventListener('click', (event) => {
              event.preventDefault();
              this.removeDiscount(discountCode);
            });
          }
        });
      }

      applyDiscount(discountCode) {
        if (this.existingDiscountCodes.includes(discountCode)) {
          this.discountErrorMessage.classList.remove('hidden');
          this.discountErrorMessage.textContent = window.theme.strings.discount_already_applied;
          return;
        }

        this.existingDiscountCodes.push(discountCode);
        this.updateCartDiscounts(this.existingDiscountCodes.join(','));
      }

      removeDiscount(discountCode) {
        if (!this.existingDiscountCodes.includes(discountCode)) return;

        this.existingDiscountCodes = this.existingDiscountCodes.filter((code) => code !== discountCode);
        this.updateCartDiscounts(this.existingDiscountCodes.join(','));
      }

      updateCartDiscounts(discountString) {
        const lastAttemptedDiscount = discountString
          .split(',')
          .filter((c) => c)
          .pop()
          ?.trim();

        this.disableCartButtons();
        this.discountErrorMessage.classList.add('hidden');

        fetch(window.theme.routes.cart_update_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            discount: discountString,
          }),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.text();
          })
          .then((text) => {
            let data;
            try {
              data = JSON.parse(text);
            } catch (e) {
              console.error('Failed to parse cart update response:', text);
              throw new Error('Invalid JSON response from server.');
            }

            if (lastAttemptedDiscount) {
              const wasApplied = data.discount_codes && Array.isArray(data.discount_codes) && data.discount_codes.some((d) => d.code === lastAttemptedDiscount && d.applicable);

              if (!wasApplied) {
                this.discountError = true;
                this.existingDiscountCodes = this.existingDiscountCodes.filter((code) => code !== lastAttemptedDiscount);
              } else {
                this.discountError = false;
              }
            } else {
              this.discountError = false;
            }

            this.getCart();
          })
          .catch((error) => {
            console.error(error);
          });
      }

      /**
       * Cart events
       *
       * @return  {Void}
       */

      cartEvents() {
        if (this.cartTermsCheckbox) {
          this.cartTermsCheckbox.removeEventListener('change', this.formSubmitHandler);
          this.cartCheckoutButtonWrapper.removeEventListener('click', this.formSubmitHandler);
          this.cartForm.removeEventListener('submit', this.formSubmitHandler);

          this.cartTermsCheckbox.addEventListener('change', this.formSubmitHandler);
          this.cartCheckoutButtonWrapper.addEventListener('click', this.formSubmitHandler);
          this.cartForm.addEventListener('submit', this.formSubmitHandler);
        }
      }

      formSubmitHandler() {
        const termsCheckbox = document.querySelector(selectors$f.cartTermsCheckbox);
        const termsError = document.querySelector(selectors$f.termsErrorMessage);
        const termsAccepted = Boolean(termsCheckbox?.checked);

        if (!termsError || !this.cartCheckoutButton) return;

        // Disable form submit if terms and conditions are not accepted
        if (!termsAccepted) {
          if (termsError.classList.contains(classes$7.expanded)) {
            return;
          }

          termsError.innerText = theme.strings.cartAcceptanceError;
          this.cartCheckoutButton.setAttribute(attributes$2.disabled, true);
          termsError.classList.add(classes$7.expanded);
        } else {
          termsError.classList.remove(classes$7.expanded);
          this.cartCheckoutButton.removeAttribute(attributes$2.disabled);
        }
      }

      /**
       * Cart event remove out of stock error
       *
       * @return  {Void}
       */

      formErrorsEvents(errorContainer) {
        const buttonErrorClose = errorContainer.querySelector(selectors$f.formCloseError);
        buttonErrorClose?.addEventListener('click', (e) => {
          e.preventDefault();

          if (errorContainer) {
            errorContainer.classList.remove(classes$7.visible);
          }
        });
      }

      /**
       * Get response from the cart
       *
       * @return  {Void}
       */

      getCart() {
        if (!this.cart) return;

        fetch(theme.routes.cart_url + '?section_id=api-cart-items')
          .then(this.cartErrorsHandler)
          .then((response) => response.text())
          .then((response) => {
            const element = document.createElement('div');
            element.innerHTML = response;

            const cleanResponse = element.querySelector(selectors$f.apiContent);

            this.build(cleanResponse);
          })
          .catch((error) => console.error(error));
      }

      /**
       * Add item(s) to the cart and show the added item(s)
       *
       * @param   {String}  formData
       * @param   {DOM Element}  button
       *
       * @return  {Void}
       */

      addToCart(formData, button) {
        if (this.cart) {
          this.cart.classList.add(classes$7.loading);
        }

        const quickAddHolder = button?.closest(selectors$f.quickAddHolder);
        const quantity = button?.closest('product-form')?.querySelector('input[name="quantity"]')?.value || 1;
        if (button) {
          button.classList.add(classes$7.loading);
          button.disabled = true;
        }

        if (quickAddHolder) {
          quickAddHolder.classList.add(classes$7.visible);
        }

        fetch(theme.routes.cart_add_url, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/javascript',
          },
          body: formData,
        })
          .then((response) => {
            return response.json();
          })
          .then((response) => {
            if (response.status) {
              this.addToCartError(response, button);

              if (button) {
                button.classList.remove(classes$7.loading);
                button.disabled = false;

                button.dispatchEvent(
                  new CustomEvent('theme:product:add-error', {
                    detail: {
                      response: response,
                      button: button,
                      quantity: quantity,
                    },
                    bubbles: true,
                  })
                );
              }

              if (!this.showCannotAddMoreInCart) return;
            }

            if (this.cart) {
              if (button) {
                button.classList.remove(classes$7.loading);
                button.classList.add(classes$7.added);

                button.dispatchEvent(
                  new CustomEvent('theme:product:add', {
                    detail: {
                      response: response,
                      button: button,
                      quantity: quantity,
                    },
                    bubbles: true,
                  })
                );
              }
              if (!theme.settings.enableAjaxCart) {
                window.location = theme.routes.cart_url;
              }
              this.getCart();
            } else {
              // Redirect to cart page if "Add to cart" is successful
              window.location = theme.routes.cart_url;
            }
          })
          .catch((error) => {
            this.addToCartError(error, button);
            this.enableCartButtons();
          });
      }

      /**
       * Update cart
       *
       * @param   {Object}  updateData
       *
       * @return  {Void}
       */

      updateCart(updateData = {}, currentItem = null) {
        this.cart.classList.add(classes$7.loading);
        this.disableCartButtons();

        const newItem = this.cart.querySelector(`[${attributes$2.item}="${updateData.id}"]`) || currentItem;
        const lineIndex = newItem?.hasAttribute(attributes$2.itemIndex) ? parseInt(newItem.getAttribute(attributes$2.itemIndex)) : 0;
        const itemTitle = newItem?.hasAttribute(attributes$2.itemTitle) ? newItem.getAttribute(attributes$2.itemTitle) : null;

        if (lineIndex === 0) return;

        const data = {
          line: lineIndex,
          quantity: updateData.quantity,
        };

        fetch(theme.routes.cart_change_url, {
          method: 'post',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify(data),
        })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);

            if (parsedState.errors) {
              this.cartUpdateFailed = true;
              this.updateErrorText(itemTitle);
              this.toggleErrorMessage();
              this.resetLineItem(currentItem);
              this.enableCartButtons();
              this.bindDiscountEventListeners();

              return;
            }

            this.getCart();
          })
          .catch((error) => {
            console.error(error);
            this.enableCartButtons();
          });
      }

      /**
       * Reset line item initial state
       *
       * @return  {Void}
       */
      resetLineItem(item) {
        const qtyInput = item.querySelector(selectors$f.qtyInput);
        const qty = qtyInput.getAttribute('value');
        qtyInput.value = qty;
      }

      /**
       * Disable cart buttons and inputs
       *
       * @return  {Void}
       */
      disableCartButtons() {
        if (!this.cart) return;

        const inputs = this.cart.querySelectorAll('input');
        const buttons = this.cart.querySelectorAll(`button, ${selectors$f.cartItemRemove}`);

        if (inputs.length) {
          inputs.forEach((item) => {
            item.classList.add(classes$7.disabled);
            item.blur();
            item.disabled = true;
          });
        }

        if (buttons.length) {
          buttons.forEach((item) => {
            item.setAttribute(attributes$2.disabled, true);
          });
        }
      }

      /**
       * Enable cart buttons and inputs
       *
       * @return  {Void}
       */
      enableCartButtons() {
        if (!this.cart) return;

        const inputs = this.cart.querySelectorAll('input');
        const buttons = this.cart.querySelectorAll(`button, ${selectors$f.cartItemRemove}`);

        if (inputs.length) {
          inputs.forEach((item) => {
            item.classList.remove(classes$7.disabled);
            item.disabled = false;
          });
        }

        if (buttons.length) {
          buttons.forEach((item) => {
            item.removeAttribute(attributes$2.disabled);
          });
        }

        this.cart.classList.remove(classes$7.loading);
      }

      /**
       * Update error text
       *
       * @param   {String}  itemTitle
       *
       * @return  {Void}
       */

      updateErrorText(itemTitle) {
        this.cartErrorHolder.querySelector(selectors$f.errorMessage).innerText = itemTitle;
      }

      /**
       * Toggle error message
       *
       * @return  {Void}
       */

      toggleErrorMessage() {
        if (!this.cartErrorHolder) return;

        this.cartErrorHolder.classList.toggle(classes$7.expanded, this.cartUpdateFailed || this.showCannotAddMoreInCart);

        // Reset cart error events flag
        this.showCannotAddMoreInCart = false;
        this.cartUpdateFailed = false;
      }

      /**
       * Handle errors
       *
       * @param   {Object}  response
       *
       * @return  {Object}
       */

      cartErrorsHandler(response) {
        if (!response.ok) {
          return response.json().then(function (json) {
            const e = new FetchError({
              status: response.statusText,
              headers: response.headers,
              json: json,
            });
            throw e;
          });
        }
        return response;
      }

      /**
       * Add to cart error handle
       *
       * @param   {Object}  data
       * @param   {DOM Element/Null} button
       *
       * @return  {Void}
       */

      /**
       * Hide error message container as soon as an item is successfully added to the cart
       */
      hideAddToCartErrorMessage() {
        const holder = this.button.closest(selectors$f.productForm);
        const errorContainer = holder?.querySelector(selectors$f.formErrorsContainer);

        errorContainer?.classList.remove(classes$7.visible);
      }

      addToCartError(data, button) {
        if (this.showCannotAddMoreInCart) return; // Show error in cart drawer instead of product form

        if (button !== null) {
          const outerContainer = button.closest(selectors$f.outerSection) || button.closest(selectors$f.quickAddHolder) || button.closest(selectors$f.quickAddModal);
          let errorContainer = outerContainer?.querySelector(selectors$f.formErrorsContainer);

          if (errorContainer) {
            let errorMessage = `${data.message}: ${data.description}`;

            if (data.message == data.description) {
              errorMessage = data.message;
            }

            errorContainer.innerHTML = `<div class="errors">${errorMessage}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close-thin" viewBox="0 0 27 27"><path d="M.5.5l26 26M26.5.5l-26 26"></path></svg></button></div>`;
            errorContainer.classList.add(classes$7.visible);
            this.formErrorsEvents(errorContainer);
          }

          button.dispatchEvent(
            new CustomEvent('theme:product:add-error', {
              detail: {
                response: data,
                button: button,
              },
              bubbles: true,
            })
          );
          this.getCart();
        }

        const quickAddHolder = button?.closest(selectors$f.quickAddHolder);

        if (quickAddHolder) {
          quickAddHolder.dispatchEvent(
            new CustomEvent('theme:cart:error', {
              bubbles: true,
              detail: {
                message: data.message,
                description: data.description,
                holder: quickAddHolder,
              },
            })
          );
        }

        this.cart?.classList.remove(classes$7.loading);
      }

      /**
       * Add product to cart events
       *
       * @return  {Void}
       */
      productAddCallback(event) {
        let buttons = [];
        let quickAddHolder = null;
        const hasError = event.type == 'theme:product:add-error';
        const buttonATC = event.detail.button;
        const cartBarButtonATC = document.querySelector(selectors$f.cartBarAdd);

        buttons.push(buttonATC);
        quickAddHolder = buttonATC.closest(selectors$f.quickAddHolder);

        if (cartBarButtonATC) {
          buttons.push(cartBarButtonATC);
        }

        buttons.forEach((button) => {
          button.classList.remove(classes$7.loading);
          if (!hasError) {
            button.classList.add(classes$7.added);
          }
        });

        setTimeout(() => {
          buttons.forEach((button) => {
            button.classList.remove(classes$7.added);
            const isVariantUnavailable =
              button.closest(selectors$f.formWrapper)?.classList.contains(classes$7.variantSoldOut) || button.closest(selectors$f.formWrapper)?.classList.contains(classes$7.variantUnavailable);

            if (!isVariantUnavailable) {
              button.disabled = false;
            }
          });

          quickAddHolder?.classList.remove(classes$7.visible);
        }, 1000);
      }

      /**
       * Toggle classes on different containers and messages
       *
       * @return  {Void}
       */

      toggleClassesOnContainers() {
        const hasItemsInCart = this.hasItemsInCart();

        this.cartToggle.classList.toggle(classes$7.cartEmpty, !hasItemsInCart);
        this.emptyMessage.classList.toggle(classes$7.hidden, hasItemsInCart);
        this.cart.classList.toggle(classes$7.empty, !hasItemsInCart);

        if (!hasItemsInCart && this.cartDrawer) {
          setTimeout(() => {
            this.a11y.trapFocus(this.cartDrawer, {
              elementToFocus: this.cartDrawer.querySelector(selectors$f.cartDrawerClose),
            });
          }, 100);
        }
      }

      /**
       * Build cart depends on results
       *
       * @param   {Object}  data
       *
       * @return  {Void}
       */

      build(data) {
        const cartItemsData = data.querySelector(selectors$f.apiLineItems);

        const cartEmptyData = Boolean(cartItemsData === null);
        const priceData = data.querySelector(selectors$f.apiCartPrice);
        const cartTotal = data.querySelector(selectors$f.cartTotal);

        if (this.priceHolder && priceData) {
          this.priceHolder.innerHTML = priceData.innerHTML;
        }

        if (cartEmptyData) {
          this.itemsHolder.innerHTML = data.innerHTML;
        } else {
          this.itemsHolder.innerHTML = cartItemsData.innerHTML;
        }

        this.newTotalItems = cartItemsData && cartItemsData.querySelectorAll(selectors$f.item).length ? cartItemsData.querySelectorAll(selectors$f.item).length : 0;
        this.subtotal = cartTotal && cartTotal.hasAttribute(attributes$2.cartTotal) ? parseInt(cartTotal.getAttribute(attributes$2.cartTotal)) : 0;
        this.cartCount = this.getCartItemCount();

        document.dispatchEvent(
          new CustomEvent('theme:cart:change', {
            bubbles: true,
            detail: {
              cartCount: this.cartCount,
            },
          })
        );
        const cartCount = this.getCartItemCount();

        if (this.cartItemsCount) {
          if (cartCount > 0 && this.newTotalItems > 0) {
            this.cartItemsCount.innerText = cartCount < 10 ? cartCount : '9+';
          } else {
            this.cartItemsCount.innerText = '0';
          }
        }

        // Update cart total price
        this.cartTotal.innerHTML = this.subtotal === 0 ? window.theme.strings.free : window.theme.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat);

        if (this.totalItems !== this.newTotalItems) {
          this.totalItems = this.newTotalItems;

          this.toggleClassesOnContainers();
        }

        // Add class "is-updated" line items holder to reduce cart items animation delay via CSS variables
        if (this.cartDrawer?.classList.contains(classes$7.open)) {
          this.cart.classList.add(classes$7.updated);
        }

        // Remove cart loading class
        this.cart.classList.remove(classes$7.loading);

        if (this.hasDiscountBlock) {
          if (this.discountField) {
            this.discountField.value = this.existingDiscountCodes.join(',');
          }

          if (this.discountError) {
            this.discountErrorMessage.textContent = window.theme.strings.discount_not_applicable;
            this.discountErrorMessage.classList.remove('hidden');
          } else {
            this.discountErrorMessage.classList.add('hidden');
          }
        }

        this.freeShippingMessageHandle(this.subtotal);
        this.cartRemoveEvents();
        this.cartUpdateEvents();
        this.toggleErrorMessage();
        this.enableCartButtons();
        this.updateProgress();
        this.bindDiscountEventListeners();

        if (this.cartToggle && this.hasItemsInCart()) {
          this.cartToggle.classList.add(classes$7.added);

          window.theme.waitForAnimationEnd(this.cartItemsCount).then(() => {
            this.cartToggle?.classList.remove(classes$7.added);
          });
        }

        document.dispatchEvent(new CustomEvent('theme:product:added', {bubbles: true}));
      }

      /**
       * Get cart item count
       *
       * @return  {Void}
       */

      getCartItemCount() {
        return Array.from(this.cart.querySelectorAll(selectors$f.qtyInput)).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
      }

      /**
       * Check for items in the cart
       *
       * @return  {Void}
       */

      hasItemsInCart() {
        return this.totalItems > 0;
      }

      /**
       * Show/hide free shipping message
       *
       * @param   {Number}  total
       *
       * @return  {Void}
       */

      freeShippingMessageHandle(total) {
        if (!this.freeShipping.length) return;

        this.freeShipping.forEach((message) => {
          const hasQualifiedShippingMessage = message.hasAttribute(attributes$2.freeShipping) && message.getAttribute(attributes$2.freeShipping) === 'true' && total >= 0;
          message.classList.toggle(classes$7.success, hasQualifiedShippingMessage && total >= this.freeShippingLimit);
        });
      }

      /**
       * Update progress when update cart
       *
       * @return  {Void}
       */

      updateProgress() {
        this.freeShipping = document.querySelectorAll(selectors$f.freeShipping);

        if (!this.freeShipping.length) return;

        const rawRatio = this.freeShippingLimit > 0 ? this.subtotal / this.freeShippingLimit : 0;
        const percent = Math.max(0, Math.min(rawRatio * 100, 100));
        const remaining = Math.max(0, this.freeShippingLimit - this.subtotal);
        const leftToSpend = window.theme.formatMoney(remaining, theme.settings.moneyFormat);

        this.freeShipping.forEach((item) => {
          const progressBar = item.querySelector(selectors$f.freeShippingProgress);
          const leftToSpendMessage = item.querySelector(selectors$f.leftToSpend);

          if (leftToSpendMessage) {
            leftToSpendMessage.innerHTML = leftToSpend;
          }

          // Set progress bar value
          if (progressBar) {
            // Progress can be a span styled via CSS var --percent
            progressBar.setAttribute('data-percent', `${percent}`);
            progressBar.style.setProperty('--percent', `${percent}`);
          }
        });
      }
    }

    if (!customElements.get('cart-items')) {
      customElements.define('cart-items', CartItems);
    }

    function appendCartItems() {
      if (document.querySelector('cart-items')) return;

      // Add cart items tag when the cart drawer section is missing so we can still run the JS associated with the error handling
      const cartItems = document.createElement('cart-items');
      document.body.appendChild(cartItems);
    }

    class CartDrawer extends HTMLElement {
      constructor() {
        super();

        this.cartDrawerIsOpen = false;
        this.cartDrawerClose = this.querySelector('[data-cart-drawer-close]');
        this.cartDrawerInner = this.querySelector('[data-cart-drawer-inner]');
        this.openCartDrawer = this.openCartDrawer.bind(this);
        this.closeCartDrawer = this.closeCartDrawer.bind(this);
        this.toggleCartDrawer = this.toggleCartDrawer.bind(this);
        this.openCartDrawerOnProductAdded = this.openCartDrawerOnProductAdded.bind(this);
        this.cartDrawerSection = this.closest('.shopify-section');
        this.cartScroll = document.querySelector('[data-cart-scroll]');
        this.a11y = window.theme.a11y;

        this.closeCartEvents();
      }

      connectedCallback() {
        window.theme.hasCartDrawer = true;

        this.addEventListener('theme:cart-drawer:show', this.openCartDrawer);
        document.addEventListener('theme:cart:toggle', this.toggleCartDrawer);
        document.addEventListener('theme:quick-add:open', this.closeCartDrawer);
        document.addEventListener('theme:product:added', this.openCartDrawerOnProductAdded);
      }

      disconnectedCallback() {
        document.removeEventListener('theme:product:added', this.openCartDrawerOnProductAdded);
        document.removeEventListener('theme:cart:toggle', this.toggleCartDrawer);
        document.removeEventListener('theme:quick-add:open', this.closeCartDrawer);

        if (document.querySelectorAll('cart-drawer').length <= 1) {
          window.theme.hasCartDrawer = false;
        }

        appendCartItems();
      }

      /**
       * Open cart drawer when product is added to cart
       *
       * @return  {Void}
       */
      openCartDrawerOnProductAdded() {
        if (!theme.settings.enableAjaxCart || theme.settings.cartAddFeedback === 'popover') return;

        if (!this.cartDrawerIsOpen) {
          this.openCartDrawer();
        }
      }

      /**
       * Open cart drawer and add class on body
       *
       * @return  {Void}
       */

      openCartDrawer() {
        if (this.cartDrawerIsOpen) return;

        this.cartDrawerIsOpen = true;
        this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
        document.body.addEventListener('click', this.onBodyClickEvent);

        document.dispatchEvent(
          new CustomEvent('theme:cart-drawer:open', {
            detail: {
              target: this,
            },
            bubbles: true,
          })
        );

        document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: this.cartScroll}));

        this.classList.add('is-open');
        this.setAttribute('aria-hidden', 'false');

        // Observe Additional Checkout Buttons
        this.observeAdditionalCheckoutButtons();

        window.theme.waitForAnimationEnd(this.cartDrawerInner).then(() => {
          this.a11y.trapFocus(this, {
            elementToFocus: this.querySelector('[data-cart-drawer-close]'),
          });
        });
      }

      /**
       * Close cart drawer and remove class on body
       *
       * @return  {Void}
       */

      closeCartDrawer() {
        if (!this.classList.contains('is-open')) return;

        this.classList.remove('is-open');
        this.setAttribute('aria-hidden', 'true');

        this.cartDrawerIsOpen = false;

        document.dispatchEvent(
          new CustomEvent('theme:cart-drawer:close', {
            bubbles: true,
          })
        );

        this.a11y.removeTrapFocus();
        this.a11y.autoFocusLastElement();

        document.body.removeEventListener('click', this.onBodyClickEvent);
        document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
      }

      /**
       * Toggle cart drawer
       *
       * @return  {Void}
       */

      toggleCartDrawer() {
        if (!this.cartDrawerIsOpen) {
          this.openCartDrawer();
        } else {
          this.closeCartDrawer();
        }
      }

      /**
       * Event click to element to close cart drawer
       *
       * @return  {Void}
       */

      closeCartEvents() {
        this.cartDrawerClose.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeCartDrawer();
        });

        this.addEventListener('keyup', (e) => {
          if (e.code === 'Escape') {
            this.closeCartDrawer();
          }
        });
      }

      onBodyClick(e) {
        if (e.target.hasAttribute('data-drawer-underlay')) this.closeCartDrawer();
      }

      observeAdditionalCheckoutButtons() {
        // identify an element to observe
        const additionalCheckoutButtons = this.querySelector('.additional-checkout-buttons');
        if (additionalCheckoutButtons) {
          // create a new instance of `MutationObserver` named `observer`,
          // passing it a callback function
          const observer = new MutationObserver(() => {
            this.a11y.trapFocus(this, {
              elementToFocus: this.querySelector('[data-cart-drawer-close]'),
            });
            observer.disconnect();
          });

          // call `observe()` on that MutationObserver instance,
          // passing it the element to observe, and the options object
          observer.observe(additionalCheckoutButtons, {subtree: true, childList: true});
        }
      }
    }

    if (!customElements.get('cart-drawer')) {
      customElements.define('cart-drawer', CartDrawer);
    }

    class CartPopover extends HTMLElement {
      constructor() {
        super();

        this.popoverTimer = '';
        this.showPopoverOnProductAdd = this.showPopover.bind(this);
        document.addEventListener('theme:product:add', this.showPopoverOnProductAdd);
        document.addEventListener('theme:product:add-error', this.showPopoverOnProductAdd);
      }

      connectedCallback() {
        this.popoverHolder = this.querySelector('[data-popover]');
        this.popoverTemplate = this.querySelector('[data-popover-template]');

        this.popoverHolder.addEventListener('click', () => {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show'));
          }
        });
      }

      disconnectedCallback() {
        document.removeEventListener('theme:product:add', this.showPopoverOnProductAdd);
        document.removeEventListener('theme:product:add-error', this.showPopoverOnProductAdd);
      }

      /**
       * Cart Popover
       *
       * @return  {Void}
       */

      renderPopover(response, qty) {
        const templateContent = document.importNode(this.popoverTemplate.content, true);
        const heading = templateContent.querySelector('[data-popover-heading]');
        const image = templateContent.querySelector('[data-popover-image]');
        const title = templateContent.querySelector('[data-popover-title]');
        const variant = templateContent.querySelector('[data-popover-variant]');
        const sellingPlanElement = templateContent.querySelector('[data-popover-selling-plan]');
        const itemProperties = templateContent.querySelector('[data-popover-item-props]');
        const itemPrice = templateContent.querySelector('[data-popover-item-price]');
        const itemUnitPrice = templateContent.querySelector('[data-popover-unit-price]');

        if (response.status) {
          const popoverInner = templateContent.querySelector('.popover-inner');
          popoverInner.classList.add('errors');
          popoverInner.textContent = response.message != null ? String(response.message) : '';
        } else {
          const product = response;
          const stripHtmlRegex = /(<([^>]+)>)/gi;
          const productTitle = product.title.replace(stripHtmlRegex, '');
          let price = product.final_price === 0 ? window.theme.strings.free : window.theme.formatMoney(product.final_price, theme.settings.moneyFormat);
          const prodImg = product.featured_image?.url || theme.assets.no_image;
          let unitPrice = '';
          const sellingPlanName = product.selling_plan_allocation ? product.selling_plan_allocation.selling_plan.name : null;

          // Unit price
          if (product.unit_price_measurement) {
            unitPrice = `${window.theme.formatMoney(product.unit_price, theme.moneyWithoutCurrencyFormat)} / `;
            if (product.unit_price_measurement.reference_value != 1) {
              unitPrice += product.unit_price_measurement.reference_value;
            }
            unitPrice += product.unit_price_measurement.reference_unit;
          }

          // Properties: build with text nodes only (line item values may be untrusted)
          if (product.properties) {
            for (const property in product.properties) {
              if ({}.hasOwnProperty.call(product.properties, property)) {
                const propValue = product.properties[property];
                const propFirstChar = property.slice(0, 1);

                if (propValue && propFirstChar !== '_') {
                  const row = document.createElement('p');
                  row.textContent = `${property}: ${String(propValue)}`;
                  itemProperties.appendChild(row);
                }
              }
            }
          }

          const headingSuffix = heading.textContent;
          heading.textContent = `(${qty}) ${productTitle} ${headingSuffix}`;

          const imgElement = document.createElement('img');
          if (prodImg !== theme.assets.no_image) {
            imgElement.src = `${prodImg}&width=240`;
            imgElement.alt = productTitle;
            imgElement.width = 120;
            imgElement.height = 120;
            imgElement.sizes = '120px';
            imgElement.srcset = `${prodImg}&width=120 1x, ${prodImg}&width=180 1.5x, ${prodImg}&width=240 2x`;
          } else {
            imgElement.src = prodImg;
          }
          image.appendChild(imgElement);

          title.textContent = productTitle;
          variant.textContent = product.product_has_only_default_variant ? '' : String(product.variant_title ?? '');
          sellingPlanElement.textContent = sellingPlanName ? String(sellingPlanName) : '';
          itemPrice.textContent = price;
          itemUnitPrice.textContent = unitPrice;
        }

        const tempElement = document.createElement('div');
        tempElement.appendChild(templateContent);
        const templateContentReplaced = tempElement.innerHTML;
        tempElement.remove();

        return templateContentReplaced;
      }

      showPopover(e) {
        if (!theme.settings.enableAjaxCart || theme.settings.cartAddFeedback !== 'popover') return;

        const response = e.detail.response;
        const quantity = e.detail.quantity;

        if (theme.isMobile()) return;

        this.popoverHolder.innerHTML = this.renderPopover(response, quantity);
        this.popoverHolder.classList.toggle('is-error', Boolean(response.status));
        this.popoverHolder.classList.add('is-visible');

        // clear popover timer, set at top of Cart object
        clearTimeout(this.popoverTimer);

        // set a new instance of popoverTimer
        this.popoverTimer = setTimeout(() => {
          this.hidePopover();
        }, 3000);
      }

      hidePopover() {
        this.popoverHolder.classList.remove('is-visible', 'is-error');
        setTimeout(() => {
          this.popoverHolder.innerHTML = '';
        }, 300);
      }
    }

    if (!customElements.get('cart-popover')) {
      customElements.define('cart-popover', CartPopover);
    }

    const selectors$e = {
      inputSearch: 'input[type="search"]',
      focusedElements: '[aria-selected="true"] a',
      resetButton: 'button[type="reset"]',
    };

    const classes$6 = {
      hidden: 'hidden',
    };

    class HeaderSearchForm extends HTMLElement {
      constructor() {
        super();

        this.input = this.querySelector(selectors$e.inputSearch);
        this.resetButton = this.querySelector(selectors$e.resetButton);

        if (this.input) {
          this.input.form.addEventListener('reset', this.onFormReset.bind(this));
          this.input.addEventListener(
            'input',
            window.theme
              .debounce((event) => {
                this.onChange(event);
              }, 300)
              .bind(this)
          );
        }
      }

      toggleResetButton() {
        const resetIsHidden = this.resetButton.classList.contains(classes$6.hidden);
        if (this.input.value.length > 0 && resetIsHidden) {
          this.resetButton.classList.remove(classes$6.hidden);
        } else if (this.input.value.length === 0 && !resetIsHidden) {
          this.resetButton.classList.add(classes$6.hidden);
        }
      }

      onChange() {
        this.toggleResetButton();
      }

      shouldResetForm() {
        return !document.querySelector(selectors$e.focusedElements);
      }

      onFormReset(event) {
        // Prevent default so the form reset doesn't set the value gotten from the url on page load
        event.preventDefault();
        // Don't reset if the user has selected an element on the predictive search dropdown
        if (this.shouldResetForm()) {
          this.input.value = '';
          this.toggleResetButton();
          event.target.querySelector(selectors$e.inputSearch).focus();
        }
      }
    }

    customElements.define('header-search-form', HeaderSearchForm);

    const selectors$d = {
      allVisibleElements: '[role="option"]',
      ariaSelected: '[aria-selected="true"]',
      interactiveResult: 'a, button, input, select, textarea, [tabindex]',
      predictiveSearch: 'predictive-search',
      predictiveSearchResults: '[data-predictive-search-results]',
      predictiveSearchStatus: '[data-predictive-search-status]',
      searchInput: 'input[type="search"]',
      searchPopdown: '[data-popdown]',
      searchResultsLiveRegion: '[data-predictive-search-live-region-count-value]',
      searchResultsGroupsWrapper: 'data-search-results-groups-wrapper',
      searchForText: '[data-predictive-search-search-for-text]',
      sectionPredictiveSearch: '#shopify-section-predictive-search',
      selectedLink: '[aria-selected="true"] a',
      selectedOption: '[aria-selected="true"] a, button[aria-selected="true"]',
    };

    class PredictiveSearch extends HeaderSearchForm {
      constructor() {
        super();
        this.a11y = a11y$1;
        this.abortController = new AbortController();
        this.allPredictiveSearchInstances = document.querySelectorAll(selectors$d.predictiveSearch);
        this.cachedResults = {};
        this.input = this.querySelector(selectors$d.searchInput);
        this.isOpen = false;
        this.predictiveSearchResults = this.querySelector(selectors$d.predictiveSearchResults);
        this.searchPopdown = this.closest(selectors$d.searchPopdown);
        this.searchTerm = '';
      }

      connectedCallback() {
        this.input.addEventListener('focus', this.onFocus.bind(this));
        this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.addEventListener('keyup', this.onKeyup.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this));

        // Clicking a non-interactive part of the results blurs the input, which would
        // close the dropdown via onFocusOut. Keep focus on the input in that case.
        this.predictiveSearchResults.addEventListener('mousedown', this.onResultsMousedown.bind(this));
      }

      onResultsMousedown(event) {
        if (!event.target.closest(selectors$d.interactiveResult)) event.preventDefault();
      }

      getQuery() {
        return this.input.value.trim();
      }

      onChange() {
        super.onChange();
        const newSearchTerm = this.getQuery();

        if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
          // Remove the results when they are no longer relevant for the new search term
          // so they don't show up when the dropdown opens again
          this.querySelector(selectors$d.searchResultsGroupsWrapper)?.remove();
        }

        // Update the term asap, don't wait for the predictive search query to finish loading
        this.updateSearchForTerm(this.searchTerm, newSearchTerm);

        this.searchTerm = newSearchTerm;

        if (!this.searchTerm.length) {
          this.reset();
          return;
        }

        this.getSearchResults(this.searchTerm);
      }

      onFormSubmit(event) {
        if (!this.getQuery().length || this.querySelector(selectors$d.selectedLink)) event.preventDefault();
      }

      onFormReset(event) {
        super.onFormReset(event);
        if (super.shouldResetForm()) {
          this.searchTerm = '';
          this.abortController.abort();
          this.abortController = new AbortController();
          this.closeResults(true);
        }
      }

      shouldResetForm() {
        return !document.querySelector(selectors$d.selectedLink);
      }

      onFocus() {
        const currentSearchTerm = this.getQuery();

        if (!currentSearchTerm.length) return;

        if (this.searchTerm !== currentSearchTerm) {
          // Search term was changed from other search input, treat it as a user change
          this.onChange();
        } else if (this.getAttribute('results') === 'true') {
          this.open();
        } else {
          this.getSearchResults(this.searchTerm);
        }
      }

      onFocusOut() {
        setTimeout(() => {
          if (!this.contains(document.activeElement)) this.close();
        });
      }

      onKeyup(event) {
        if (!this.getQuery().length) this.close(true);
        event.preventDefault();

        switch (event.code) {
          case 'ArrowUp':
            this.switchOption('up');
            break;
          case 'ArrowDown':
            this.switchOption('down');
            break;
          case 'Enter':
            this.selectOption();
            break;
        }
      }

      onKeydown(event) {
        // Prevent the cursor from moving in the input when using the up and down arrow keys
        if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
          event.preventDefault();
        }
      }

      updateSearchForTerm(previousTerm, newTerm) {
        const searchForTextElement = this.querySelector(selectors$d.searchForText);
        const currentButtonText = searchForTextElement?.innerText;

        if (currentButtonText) {
          if (currentButtonText.match(new RegExp(previousTerm, 'g'))?.length > 1) {
            // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
            return;
          }
          const newButtonText = currentButtonText.replace(previousTerm, newTerm);
          searchForTextElement.innerText = newButtonText;
        }
      }

      switchOption(direction) {
        if (!this.getAttribute('open')) return;

        const moveUp = direction === 'up';
        const selectedElement = this.querySelector(selectors$d.ariaSelected);

        // Filter out hidden elements (duplicated page and article resources) thanks
        // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
        const allVisibleElements = Array.from(this.querySelectorAll(selectors$d.allVisibleElements)).filter((element) => element.offsetParent !== null);

        let activeElementIndex = 0;

        if (moveUp && !selectedElement) return;

        let selectedElementIndex = -1;
        let i = 0;

        while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
          if (allVisibleElements[i] === selectedElement) {
            selectedElementIndex = i;
          }
          i++;
        }

        this.statusElement.textContent = '';

        if (!moveUp && selectedElement) {
          activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
        } else if (moveUp) {
          activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
        }

        if (activeElementIndex === selectedElementIndex) return;

        const activeElement = allVisibleElements[activeElementIndex];

        activeElement.setAttribute('aria-selected', true);
        if (selectedElement) selectedElement.setAttribute('aria-selected', false);

        this.input.setAttribute('aria-activedescendant', activeElement.id);
      }

      selectOption() {
        const selectedOption = this.querySelector(selectors$d.selectedOption);

        if (selectedOption) selectedOption.click();
      }

      getSearchResults(searchTerm) {
        const queryKey = searchTerm.replace(' ', '-').toLowerCase();
        this.setLiveRegionLoadingState();

        if (this.cachedResults[queryKey]) {
          this.renderSearchResults(this.cachedResults[queryKey]);
          return;
        }

        fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`, {signal: this.abortController.signal})
          .then((response) => {
            if (!response.ok) {
              var error = new Error(response.status);
              this.close();
              throw error;
            }
            return response.text();
          })
          .then((text) => {
            const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector(selectors$d.sectionPredictiveSearch).innerHTML;
            // Save bandwidth keeping the cache in all instances synced
            this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
              predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
            });
            this.renderSearchResults(resultsMarkup);
          })
          .catch((error) => {
            if (error?.code === 20) {
              // Code 20 means the call was aborted
              return;
            }
            this.close();
            throw error;
          });
      }

      setLiveRegionLoadingState() {
        this.statusElement = this.statusElement || this.querySelector(selectors$d.predictiveSearchStatus);
        this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

        this.setLiveRegionText(this.loadingText);
        this.setAttribute('loading', true);
      }

      setLiveRegionText(statusText) {
        this.statusElement.setAttribute('aria-hidden', 'false');
        this.statusElement.textContent = statusText;

        setTimeout(() => {
          this.statusElement.setAttribute('aria-hidden', 'true');
        }, 1000);
      }

      renderSearchResults(resultsMarkup) {
        this.predictiveSearchResults.innerHTML = resultsMarkup;

        this.setAttribute('results', true);

        this.setLiveRegionResults();
        this.open();
      }

      setLiveRegionResults() {
        this.removeAttribute('loading');
        this.setLiveRegionText(this.querySelector(selectors$d.searchResultsLiveRegion).textContent);
      }

      getResultsMaxHeight() {
        this.resultsMaxHeight = window.theme.getWindowHeight() - document.querySelector(selectors$d.searchPopdown).getBoundingClientRect().bottom;
        return this.resultsMaxHeight;
      }

      open() {
        this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
        this.setAttribute('open', true);
        this.input.setAttribute('aria-expanded', true);
        this.isOpen = true;
      }

      close(clearSearchTerm = false) {
        this.closeResults(clearSearchTerm);
        this.isOpen = false;
      }

      closeResults(clearSearchTerm = false) {
        if (clearSearchTerm) {
          this.input.value = '';
          this.removeAttribute('results');
        }
        const selected = this.querySelector(selectors$d.ariaSelected);

        if (selected) selected.setAttribute('aria-selected', false);

        this.input.setAttribute('aria-activedescendant', '');
        this.removeAttribute('loading');
        this.removeAttribute('open');
        this.input.setAttribute('aria-expanded', false);
        this.resultsMaxHeight = false;
        this.predictiveSearchResults?.removeAttribute('style');
      }

      reset() {
        this.predictiveSearchResults.innerHTML = '';

        this.input.val = '';
        this.a11y.removeTrapFocus();
      }
    }

    customElements.define('predictive-search', PredictiveSearch);

    const dispatchThemeEvent = (name, detail = undefined) => {
      document.dispatchEvent(new CustomEvent(name, {bubbles: true, detail}));
    };

    class QuickviewModal extends HTMLElement {
      constructor() {
        super();

        this.a11y = window.theme.a11y;
        this.activeHandle = '';
        this.activeTrigger = null;
        this.abortController = null;
        this.isOpen = false;
        this.isAnimating = false;
        this.closeFinalizeTimer = null;
        this.loadingButtonsByHandle = new Map();
        this.resizeObserver = null;

        this.onQuickviewClose = this.onQuickviewClose.bind(this);
        this.onProductAddSuccess = this.onProductAddSuccess.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onDialogClick = this.onDialogClick.bind(this);
        this.onDialogClose = this.onDialogClose.bind(this);
        this.onDialogAnimationEnd = this.onDialogAnimationEnd.bind(this);
        this.syncScrollableState = this.syncScrollableState.bind(this);
      }

      connectedCallback() {
        this.content = this.querySelector('[data-quickview-content]');
        this.dialog = this.querySelector('[data-quickview-dialog]');

        if (!this.content || !this.dialog) {
          return;
        }

        this.addEventListener('click', this.onClick);
        this.addEventListener('theme:product:add', this.onProductAddSuccess);
        this.addDialogEvents();
        this.addGlobalEvents();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('theme:product:add', this.onProductAddSuccess);
        this.removeDialogEvents();
        this.removeGlobalEvents();
        this.disconnectResizeObserver();

        this.abortFetchRequest();
        this.clearCloseFinalizeTimer();
        this.clearAllLoading();
      }

      addDialogEvents() {
        this.dialog.addEventListener('click', this.onDialogClick);
        this.dialog.addEventListener('close', this.onDialogClose);
        this.dialog.addEventListener('animationend', this.onDialogAnimationEnd);
        document.addEventListener('keydown', this.onKeyDown);
      }

      removeDialogEvents() {
        this.dialog?.removeEventListener('click', this.onDialogClick);
        this.dialog?.removeEventListener('close', this.onDialogClose);
        this.dialog?.removeEventListener('animationend', this.onDialogAnimationEnd);
        document.removeEventListener('keydown', this.onKeyDown);
      }

      addGlobalEvents() {
        document.addEventListener('theme:quickview:close', this.onQuickviewClose);
      }

      removeGlobalEvents() {
        document.removeEventListener('theme:quickview:close', this.onQuickviewClose);
      }

      openFromTrigger(trigger) {
        const handle = trigger?.getAttribute('data-trigger-quickview');

        if (!trigger || !handle || this.loadingButtonsByHandle.has(handle)) {
          return;
        }

        const loadingButtons = this.getLoadingButtons(trigger, handle);
        loadingButtons.forEach((button) => button.classList.add('is-loading'));
        this.loadingButtonsByHandle.set(handle, loadingButtons);

        if (this.isOpen && this.activeHandle === handle) {
          this.modalClose();
          this.resetLoading(handle);
          return;
        }

        this.activeTrigger = trigger;
        this.renderModal(handle);
      }

      getLoadingButtons(trigger, handle) {
        const productBlock = trigger.closest('[data-product-block]');
        const scopedButtons = productBlock?.querySelectorAll(`[data-trigger-quickview="${handle}"]`);

        if (scopedButtons?.length) {
          return Array.from(scopedButtons);
        }

        return [trigger];
      }

      async renderModal(handle) {
        this.abortFetchRequest();
        this.classList.add('is-loading');
        this.abortController = new AbortController();

        try {
          const response = await this.fetchModalSection(handle);
          const apiContent = this.extractApiContent(response);
          this.applyApiContent(apiContent, handle);

          dispatchThemeEvent('theme:quickview:loaded', {
            handle: this.activeHandle,
            trigger: this.activeTrigger,
          });
        } catch (error) {
          if (error.name === 'AbortError') return;

          console.error('Quick View error:', error);
          dispatchThemeEvent('theme:quickview:failed', {
            handle,
            trigger: this.activeTrigger,
          });
        } finally {
          this.classList.remove('is-loading');
          this.abortController = null;
          this.resetLoading(handle);
        }
      }

      fetchModalSection(handle) {
        // eslint-disable-next-line compat/compat
        return fetch(`${theme.routes.root}products/${handle}?section_id=api-quickview`, {
          signal: this.abortController.signal,
        }).then((response) => {
          if (!response.ok) {
            throw new Error(`Quick View request failed: ${response.status}`);
          }

          return response.text();
        });
      }

      extractApiContent(response) {
        const htmlObject = document.createElement('div');
        htmlObject.innerHTML = response;
        const apiContent = htmlObject.querySelector('[data-api-content]');

        if (!apiContent) {
          throw new Error('Quick View content missing');
        }

        return apiContent;
      }

      applyApiContent(apiContent, handle) {
        this.content.innerHTML = apiContent.innerHTML;
        this.content.scrollTop = 0;
        this.activeHandle = handle;
        this.modalCreatedCallback();
      }

      modalCreatedCallback() {
        this.initPaymentButton();
        this.modalOpen();
        this.observeContentResize();
      }

      modalOpen() {
        if (this.isOpen) {
          if (this.dialog.hasAttribute('closing')) {
            this.clearCloseFinalizeTimer();
            this.dialog.removeAttribute('closing');
            this.isAnimating = false;
          }

          this.resetTrapFocus();
          this.syncScrollableState();
          return;
        }

        const scrollY = window.scrollY;

        document.documentElement.style.overflowAnchor = 'none';

        // Called directly instead of via theme:scroll:lock because the centralized
        // lock handler defers disablePageScroll with setTimeout, which breaks the
        // synchronous scrollY capture → lock → scrollTo restore sequence below.
        scrollLock.disablePageScroll(this.content);
        document.documentElement.setAttribute('data-scroll-locked', '');

        if (typeof this.dialog.show === 'function' && !this.dialog.open) {
          this.dialog.show();
        } else if (!this.dialog.hasAttribute('open')) {
          this.dialog.setAttribute('open', '');
        }

        this.setOpenState();
        this.isAnimating = true;
        this.resetTrapFocus();

        window.scrollTo(0, scrollY);
        setTimeout(() => {
          document.documentElement.style.overflowAnchor = '';
        });
      }

      modalClose() {
        if (!this.isOpen || this.isAnimating) {
          return;
        }

        if (!this.dialog.hasAttribute('closing')) {
          this.dialog.setAttribute('closing', '');
          this.isAnimating = true;
          this.startCloseFinalizeTimer();
          return;
        }

        this.setClosedState();
        this.content.classList.remove('is-scrollable');
        this.content.scrollTop = 0;
        this.disconnectResizeObserver();
        this.a11y.removeTrapFocus();
        dispatchThemeEvent('theme:scroll:unlock');

        this.autoFocusLastElement();
        this.dispatchQuickviewClosed();

        this.resetLoading(this.activeHandle);
        this.activeHandle = '';
        this.activeTrigger = null;

        if (typeof this.dialog.close === 'function' && this.dialog.open) {
          this.dialog.close();
        } else {
          this.dialog.removeAttribute('open');
        }

        window.setTimeout(() => {
          if (!this.isOpen) {
            this.content.innerHTML = '';
          }
        }, 350);
      }

      setOpenState() {
        this.clearCloseFinalizeTimer();
        this.dialog.removeAttribute('closing');
        this.isAnimating = false;
        this.isOpen = true;
        this.setAttribute('aria-hidden', 'false');
        this.classList.add('is-open');
        document.documentElement.setAttribute('data-quickview-open', '');
      }

      setClosedState() {
        this.clearCloseFinalizeTimer();
        this.isOpen = false;
        this.classList.remove('is-open');
        this.setAttribute('aria-hidden', 'true');
        document.documentElement.removeAttribute('data-quickview-open');
        this.dialog.removeAttribute('closing');
      }

      onQuickviewClose() {
        this.requestClose();
      }

      onProductAddSuccess(event) {
        if (!this.isOpen) {
          return;
        }

        const button = event.detail?.button;
        if (button && this.contains(button)) {
          this.modalClose();
        }
      }

      onClick(event) {
        if (!event.target.closest('[data-quickview-close]')) {
          return;
        }

        this.requestClose(event);
      }

      onKeyDown(event) {
        if (event.key === 'Escape' && this.isOpen) {
          event.preventDefault();
          this.requestClose();
        }
      }

      onDialogClick(event) {
        if (event.target !== this.dialog) {
          return;
        }

        this.requestClose();
      }

      onDialogClose() {
        if (!this.isOpen) return;
        this.requestClose();
      }

      onDialogAnimationEnd(event) {
        if (event.target !== this.dialog) {
          return;
        }

        this.isAnimating = false;

        if (this.dialog.hasAttribute('closing') && this.isOpen) {
          this.clearCloseFinalizeTimer();
          this.modalClose();
          return;
        }

        this.resetTrapFocus();
        this.syncScrollableState();
      }

      requestClose(event = null) {
        event?.preventDefault();
        this.modalClose();
      }

      autoFocusLastElement() {
        if (this.activeTrigger && document.body.contains(this.activeTrigger)) {
          this.activeTrigger.focus();
          return;
        }

        if (!this.activeHandle) {
          return;
        }

        const fallbackButton = document.querySelector(`[data-trigger-quickview="${this.activeHandle}"]`);
        fallbackButton?.focus();
      }

      dispatchQuickviewClosed() {
        dispatchThemeEvent('theme:quickview:closed', {
          handle: this.activeHandle,
          trigger: this.activeTrigger,
        });
      }

      resetTrapFocus() {
        const closeButton = this.querySelector('[data-quickview-close]');

        this.a11y.removeTrapFocus();
        this.a11y.trapFocus(this.content, {
          elementToFocus: closeButton || this.content,
          preventScroll: true,
        });
      }

      resetLoading(handle) {
        if (!handle) {
          return;
        }

        const loadingButtons = this.loadingButtonsByHandle.get(handle);
        if (loadingButtons?.length) {
          loadingButtons.forEach((button) => button.classList.remove('is-loading'));
        }

        this.loadingButtonsByHandle.delete(handle);
      }

      clearAllLoading() {
        this.loadingButtonsByHandle.forEach((loadingButtons) => {
          loadingButtons.forEach((button) => button.classList.remove('is-loading'));
        });
        this.loadingButtonsByHandle.clear();
      }

      abortFetchRequest() {
        if (this.abortController) {
          this.abortController.abort();
        }
      }

      initPaymentButton() {
        const enablePaymentButton = theme.settings.enablePaymentButton;
        const enableAcceptTerms = theme.settings.enableAcceptTerms;

        if (enablePaymentButton && !enableAcceptTerms && typeof Shopify !== 'undefined' && typeof Shopify.PaymentButton !== 'undefined' && typeof Shopify.PaymentButton.init !== 'undefined') {
          Shopify.PaymentButton.init();
        }
      }

      syncScrollableState() {
        if (this.isAnimating) return;

        const inner = this.content.firstElementChild;
        if (!inner) {
          this.content.classList.remove('is-scrollable');
          return;
        }

        const innerHeight = inner.getBoundingClientRect().height;
        const availableHeight = this.content.getBoundingClientRect().height;

        if (!availableHeight) {
          this.content.classList.remove('is-scrollable');
          return;
        }

        const overflowDelta = innerHeight - availableHeight;
        this.content.classList.toggle('is-scrollable', overflowDelta > 1);
      }

      observeContentResize() {
        this.disconnectResizeObserver();

        const inner = this.content.firstElementChild;
        if (!inner || typeof ResizeObserver === 'undefined') {
          return;
        }

        // eslint-disable-next-line compat/compat
        this.resizeObserver = new ResizeObserver(this.syncScrollableState);
        this.resizeObserver.observe(inner);
        this.resizeObserver.observe(this.content);
      }

      disconnectResizeObserver() {
        this.resizeObserver?.disconnect();
        this.resizeObserver = null;
      }

      startCloseFinalizeTimer() {
        this.clearCloseFinalizeTimer();
        this.closeFinalizeTimer = window.setTimeout(() => {
          if (this.dialog?.hasAttribute('closing') && this.isOpen) {
            this.isAnimating = false;
            this.modalClose();
          }
        }, 400);
      }

      clearCloseFinalizeTimer() {
        if (this.closeFinalizeTimer) {
          window.clearTimeout(this.closeFinalizeTimer);
          this.closeFinalizeTimer = null;
        }
      }
    }

    class QuickviewTrigger extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.bindButton();
      }

      bindButton() {
        this.button?.removeEventListener('click', this.onClick);
        this.button = this.querySelector('[data-trigger-quickview]');

        if (!this.button) {
          return;
        }

        this.button.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
      }

      onClick(event) {
        event.preventDefault();

        const modal = document.querySelector('[data-quickview-modal]');
        modal?.openFromTrigger(this.button);
      }
    }

    if (!customElements.get('quickview-modal')) {
      customElements.define('quickview-modal', QuickviewModal);
    }

    if (!customElements.get('quickview-trigger')) {
      customElements.define('quickview-trigger', QuickviewTrigger);
    }

    const selectors$c = {
      productImage: '[data-product-image]',
      video: 'video',
      vimeo: '[data-host="vimeo"]',
      youtube: '[data-host="youtube"]',
    };

    class HoverImages extends HTMLElement {
      constructor() {
        super();

        this.hovered = false;
        this.trigger = null;
        this.iframeReady = false;

        this.mouseEnterEvent = () => this.mouseActions(true);
        this.mouseLeaveEvent = () => this.mouseActions(false);
        this.onIframeLoad = () => {
          this.iframeReady = true;
          this.videoActions();
        };
      }

      connectedCallback() {
        this.trigger = this.closest(selectors$c.productImage) || this;
        this.trigger.addEventListener('mouseenter', this.mouseEnterEvent);
        this.trigger.addEventListener('mouseleave', this.mouseLeaveEvent);
      }

      disconnectedCallback() {
        if (!this.trigger) return;
        this.trigger.removeEventListener('mouseenter', this.mouseEnterEvent);
        this.trigger.removeEventListener('mouseleave', this.mouseLeaveEvent);
      }

      mouseActions(hovered) {
        this.hovered = hovered;
        this.videoActions();
      }

      videoActions() {
        const youtube = this.querySelector(selectors$c.youtube);
        const vimeo = this.querySelector(selectors$c.vimeo);
        const mediaExternal = youtube || vimeo;
        const mediaNative = this.querySelector(selectors$c.video);

        if (mediaExternal) {
          let action = this.hovered ? 'playVideo' : 'pauseVideo';
          let string = `{"event":"command","func":"${action}","args":""}`;

          if (vimeo) {
            action = this.hovered ? 'play' : 'pause';
            string = `{"method":"${action}"}`;
          }

          if (mediaExternal.contentWindow) {
            mediaExternal.contentWindow.postMessage(string, '*');
          }

          if (!this.iframeReady) {
            mediaExternal.addEventListener('load', this.onIframeLoad, {once: true});
          }
        } else if (mediaNative) {
          if (this.hovered) {
            const playPromise = mediaNative.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(() => {});
            }
          } else {
            mediaNative.pause();
            mediaNative.currentTime = 0;
          }
        }
      }
    }

    if (!customElements.get('hover-images')) {
      customElements.define('hover-images', HoverImages);
    }

    window.theme.scrollTo = (elementTop) => {
      const stickyHeaderHeight = document.querySelector('.header-sticky') ? document.querySelector('[data-header-height]').offsetHeight : 0;

      window.scrollTo({
        top: elementTop + window.scrollY - stickyHeaderHeight,
        left: 0,
        behavior: 'smooth',
      });
    };

    if (!customElements.get('tooltip-component')) {
      customElements.define(
        'tooltip-component',
        class Tooltip extends HTMLElement {
          constructor() {
            super();

            this.label = this.hasAttribute('data-tooltip') ? this.getAttribute('data-tooltip') : '';
            this.transitionSpeed = 200;
            this.hideTransitionTimeout = 0;
            this.addPinEvent = () => this.addPin();
            this.addPinMouseEvent = () => this.addPin(true);
            this.removePinEvent = (event) => window.theme.throttle(this.removePin(event), 50);
            this.removePinMouseEvent = (event) => this.removePin(event, true, true);
          }

          connectedCallback() {
            if (!document.querySelector('.tooltip-default')) {
              const tooltipTemplate = `<div class="tooltip-default__arrow"></div><div class="tooltip-default__inner"><div class="tooltip-default__text"></div></div>`;
              const tooltipElement = document.createElement('div');
              tooltipElement.className = 'tooltip-default';
              tooltipElement.innerHTML = tooltipTemplate;
              document.body.appendChild(tooltipElement);
            }

            this.addEventListener('mouseenter', this.addPinMouseEvent);
            this.addEventListener('mouseleave', this.removePinMouseEvent);
            this.addEventListener('pointerleave', this.removePinMouseEvent);
            this.addEventListener('focusin', this.addPinMouseEvent);
            this.addEventListener('focusout', this.removePinMouseEvent);
            this.addEventListener('theme:tooltip:init', this.addPinEvent);
            document.addEventListener('theme:tooltip:close', this.removePinEvent);
            this.onVariantChangeUnsubscriber = subscribe(theme.PUB_SUB_EVENTS.optionValueSelectionChange, this.removePin.bind(this, true, false));
          }

          addPin(stopMouseEnter = false) {
            const tooltipTarget = document.querySelector(`.tooltip-default`);

            if (this.label && tooltipTarget && ((stopMouseEnter && !this.hasAttribute('data-tooltip-stop-mouseenter')) || !stopMouseEnter)) {
              const tooltipTargetArrow = tooltipTarget.querySelector('.tooltip-default__arrow');
              const tooltipTargetInner = tooltipTarget.querySelector('.tooltip-default__inner');
              const tooltipTargetText = tooltipTarget.querySelector('.tooltip-default__text');
              tooltipTargetText.innerHTML = this.label;

              const tooltipTargetWidth = tooltipTargetInner.offsetWidth;
              const tooltipRect = this.getBoundingClientRect();
              const tooltipTop = tooltipRect.top;
              const tooltipWidth = tooltipRect.width;
              const tooltipHeight = tooltipRect.height;
              const tooltipTargetPositionTop = tooltipTop + tooltipHeight + window.scrollY;
              let tooltipTargetPositionLeft = tooltipRect.left - tooltipTargetWidth / 2 + tooltipWidth / 2;
              const tooltipLeftWithWidth = tooltipTargetPositionLeft + tooltipTargetWidth;
              const sideOffset = 24;
              const tooltipTargetWindowDifference = tooltipLeftWithWidth - window.theme.getWindowWidth() + sideOffset;

              if (tooltipTargetWindowDifference > 0) {
                tooltipTargetPositionLeft -= tooltipTargetWindowDifference;
              }

              if (tooltipTargetPositionLeft < 0) {
                tooltipTargetPositionLeft = 0;
              }

              tooltipTargetArrow.style.left = `${tooltipRect.left + tooltipWidth / 2}px`;
              tooltipTarget.style.setProperty('--tooltip-top', `${tooltipTargetPositionTop}px`);

              tooltipTargetInner.style.transform = `translateX(${tooltipTargetPositionLeft}px)`;
              tooltipTarget.classList.remove('is-hiding');
              tooltipTarget.classList.add('is-visible');

              document.addEventListener('theme:scroll', this.removePinEvent);
            }
          }

          removePin(event, stopMouseEnter = false, hideTransition = false) {
            const tooltipTarget = document.querySelector('.tooltip-default');
            const tooltipVisible = tooltipTarget.classList.contains('is-visible');

            if (tooltipTarget && ((stopMouseEnter && !this.hasAttribute('data-tooltip-stop-mouseenter')) || !stopMouseEnter)) {
              if (tooltipVisible && (hideTransition || (event && event.detail && event.detail.hideTransition))) {
                tooltipTarget.classList.add('is-hiding');

                if (this.hideTransitionTimeout) {
                  clearTimeout(this.hideTransitionTimeout);
                }

                this.hideTransitionTimeout = setTimeout(() => {
                  tooltipTarget.classList.remove('is-hiding');
                }, this.transitionSpeed);
              }

              tooltipTarget.classList.remove('is-visible');

              document.removeEventListener('theme:scroll', this.removePinEvent);
            }
          }

          disconnectedCallback() {
            this.onVariantChangeUnsubscriber();
            document.removeEventListener('theme:tooltip:close', this.removePinEvent);
            document.removeEventListener('theme:scroll', this.removePinEvent);
          }
        }
      );
    }

    window.Shopify = window.Shopify || {};
    window.Shopify.theme = window.Shopify.theme || {};
    window.Shopify.theme.sections = window.Shopify.theme.sections || {};

    window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {};
    window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];
    const registered = window.Shopify.theme.sections.registered;
    const instances = window.Shopify.theme.sections.instances;

    const selectors$b = {
      id: 'data-section-id',
      type: 'data-section-type',
    };

    class Registration {
      constructor(type = null, components = []) {
        this.type = type;
        this.components = validateComponentsArray(components);
        this.callStack = {
          onLoad: [],
          onUnload: [],
          onSelect: [],
          onDeselect: [],
          onBlockSelect: [],
          onBlockDeselect: [],
          onReorder: [],
        };
        components.forEach((comp) => {
          for (const [key, value] of Object.entries(comp)) {
            const arr = this.callStack[key];
            if (Array.isArray(arr) && typeof value === 'function') {
              arr.push(value);
            } else {
              console.warn(`Unregisted function: '${key}' in component: '${this.type}'`);
              console.warn(value);
            }
          }
        });
      }

      getStack() {
        return this.callStack;
      }
    }

    class Section {
      constructor(container, registration) {
        this.container = validateContainerElement(container);
        this.id = container.getAttribute(selectors$b.id);
        this.type = registration.type;
        this.callStack = registration.getStack();

        try {
          this.onLoad();
        } catch (e) {
          console.warn(`Error in section: ${this.id}`);
          console.warn(this);
          console.warn(e);
        }
      }

      callFunctions(key, e = null) {
        this.callStack[key].forEach((func) => {
          const props = {
            id: this.id,
            type: this.type,
            container: this.container,
          };
          if (e) {
            func.call(props, e);
          } else {
            func.call(props);
          }
        });
      }

      onLoad() {
        this.callFunctions('onLoad');
      }

      onUnload() {
        this.callFunctions('onUnload');
      }

      onSelect(e) {
        this.callFunctions('onSelect', e);
      }

      onDeselect(e) {
        this.callFunctions('onDeselect', e);
      }

      onBlockSelect(e) {
        this.callFunctions('onBlockSelect', e);
      }

      onBlockDeselect(e) {
        this.callFunctions('onBlockDeselect', e);
      }

      onReorder(e) {
        this.callFunctions('onReorder', e);
      }
    }

    function validateContainerElement(container) {
      if (!(container instanceof Element)) {
        throw new TypeError('Theme Sections: Attempted to load section. The section container provided is not a DOM element.');
      }
      if (container.getAttribute(selectors$b.id) === null) {
        throw new Error(`Theme Sections: The section container provided does not have an id assigned to the ${selectors$b.id} attribute.`);
      }

      return container;
    }

    function validateComponentsArray(value) {
      if ((typeof value !== 'undefined' && typeof value !== 'object') || value === null) {
        throw new TypeError('Theme Sections: The components object provided is not a valid');
      }

      return value;
    }

    /*
     * @shopify/theme-sections
     * -----------------------------------------------------------------------------
     *
     * A framework to provide structure to your Shopify sections and a load and unload
     * lifecycle. The lifecycle is automatically connected to theme editor events so
     * that your sections load and unload as the editor changes the content and
     * settings of your sections.
     */

    function register(type, components) {
      if (typeof type !== 'string') {
        throw new TypeError('Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered');
      }

      if (typeof registered[type] !== 'undefined') {
        throw new Error('Theme Sections: A section of type "' + type + '" has already been registered. You cannot register the same section type twice');
      }

      if (!Array.isArray(components)) {
        components = [components];
      }

      const section = new Registration(type, components);
      registered[type] = section;

      return registered;
    }

    function load(types, containers) {
      types = normalizeType(types);

      if (typeof containers === 'undefined') {
        containers = document.querySelectorAll('[' + selectors$b.type + ']');
      }

      containers = normalizeContainers(containers);

      types.forEach(function (type) {
        const registration = registered[type];

        if (typeof registration === 'undefined') {
          return;
        }

        containers = containers.filter(function (container) {
          // Filter from list of containers because container already has an instance loaded
          if (isInstance(container)) {
            return false;
          }

          // Filter from list of containers because container doesn't have data-section-type attribute
          if (container.getAttribute(selectors$b.type) === null) {
            return false;
          }

          // Keep in list of containers because current type doesn't match
          if (container.getAttribute(selectors$b.type) !== type) {
            return true;
          }

          instances.push(new Section(container, registration));

          // Filter from list of containers because container now has an instance loaded
          return false;
        });
      });
    }

    function reorder(selector) {
      var instancesToReorder = getInstances(selector);

      instancesToReorder.forEach(function (instance) {
        instance.onReorder();
      });
    }

    function unload(selector) {
      var instancesToUnload = getInstances(selector);

      instancesToUnload.forEach(function (instance) {
        var index = instances
          .map(function (e) {
            return e.id;
          })
          .indexOf(instance.id);
        instances.splice(index, 1);
        instance.onUnload();
      });
    }

    function getInstances(selector) {
      var filteredInstances = [];

      // Fetch first element if its an array
      if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector)) {
        var firstElement = selector[0];
      }

      // If selector element is DOM element
      if (selector instanceof Element || firstElement instanceof Element) {
        var containers = normalizeContainers(selector);

        containers.forEach(function (container) {
          filteredInstances = filteredInstances.concat(
            instances.filter(function (instance) {
              return instance.container === container;
            })
          );
        });

        // If select is type string
      } else if (typeof selector === 'string' || typeof firstElement === 'string') {
        var types = normalizeType(selector);

        types.forEach(function (type) {
          filteredInstances = filteredInstances.concat(
            instances.filter(function (instance) {
              return instance.type === type;
            })
          );
        });
      }

      return filteredInstances;
    }

    function getInstanceById(id) {
      var instance;

      for (var i = 0; i < instances.length; i++) {
        if (instances[i].id === id) {
          instance = instances[i];
          break;
        }
      }
      return instance;
    }

    function isInstance(selector) {
      return getInstances(selector).length > 0;
    }

    function normalizeType(types) {
      // If '*' then fetch all registered section types
      if (types === '*') {
        types = Object.keys(registered);

        // If a single section type string is passed, put it in an array
      } else if (typeof types === 'string') {
        types = [types];

        // If single section constructor is passed, transform to array with section
        // type string
      } else if (types.constructor === Section) {
        types = [types.prototype.type];

        // If array of typed section constructors is passed, transform the array to
        // type strings
      } else if (Array.isArray(types) && types[0].constructor === Section) {
        types = types.map(function (Section) {
          return Section.type;
        });
      }

      types = types.map(function (type) {
        return type.toLowerCase();
      });

      return types;
    }

    function normalizeContainers(containers) {
      // Nodelist with entries
      if (NodeList.prototype.isPrototypeOf(containers) && containers.length > 0) {
        containers = Array.prototype.slice.call(containers);

        // Empty Nodelist
      } else if (NodeList.prototype.isPrototypeOf(containers) && containers.length === 0) {
        containers = [];

        // Handle null (document.querySelector() returns null with no match)
      } else if (containers === null) {
        containers = [];

        // Single DOM element
      } else if (!Array.isArray(containers) && containers instanceof Element) {
        containers = [containers];
      }

      return containers;
    }

    if (window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (event) {
        var id = event.detail.sectionId;
        var container = event.target?.querySelector?.(`[${selectors$b.id}="${id}"]`);

        if (container) {
          load(container.getAttribute(selectors$b.type), container);
        }
      });

      document.addEventListener('shopify:section:reorder', function (event) {
        var id = event.detail.sectionId;
        var container = event.target?.querySelector?.(`[${selectors$b.id}="${id}"]`);
        var instance = getInstances(container)[0];

        if (typeof instance === 'object') {
          reorder(container);
        }
      });

      document.addEventListener('shopify:section:unload', function (event) {
        var id = event.detail.sectionId;
        var container = event.target?.querySelector?.(`[${selectors$b.id}="${id}"]`);
        var instance = getInstances(container)[0];

        if (typeof instance === 'object') {
          unload(container);
        }
      });

      document.addEventListener('shopify:section:select', function (event) {
        var instance = getInstanceById(event.detail.sectionId);

        if (typeof instance === 'object') {
          instance.onSelect(event);
        }
      });

      document.addEventListener('shopify:section:deselect', function (event) {
        var instance = getInstanceById(event.detail.sectionId);

        if (typeof instance === 'object') {
          instance.onDeselect(event);
        }
      });

      document.addEventListener('shopify:block:select', function (event) {
        var instance = getInstanceById(event.detail.sectionId);

        if (typeof instance === 'object') {
          instance.onBlockSelect(event);
        }
      });

      document.addEventListener('shopify:block:deselect', function (event) {
        var instance = getInstanceById(event.detail.sectionId);

        if (typeof instance === 'object') {
          instance.onBlockDeselect(event);
        }
      });
    }

    const selectors$a = {
      aos: 'data-aos',
    };

    const removeAnimations = (container) => {
      const animatedElements = container.querySelectorAll(`[${selectors$a.aos}]`);
      animatedElements.forEach((element) => {
        element.removeAttribute(selectors$a.aos);
      });
    };

    const selectors$9 = {
      infinityContainer: '[data-infinity]',
      pagination: '[data-pagination]',
      collectionBlockImage: '[data-product-image]',
      dataId: 'data-section-id',
    };

    let sections$6 = {};

    class Ajaxify {
      constructor(container) {
        this.container = container;
        this.infinityContainer = this.container.querySelector(selectors$9.infinityContainer);
        this.endlessScroll = null;

        if (this.infinityContainer) {
          this.init();
        }
      }

      init() {
        const id = this.container.getAttribute(selectors$9.dataId);
        this.fix();
        this.endlessScroll = new Ajaxinate({
          container: `section[${selectors$9.dataId}="${id}"] ${selectors$9.infinityContainer}`,
          pagination: `section[${selectors$9.dataId}="${id}"] ${selectors$9.pagination}`,
        });
      }

      // Fix ajaxinate in theme editor
      fix() {
        Ajaxinate.prototype.loadMore = function loadMore() {
          this.request = new XMLHttpRequest();

          this.request.onreadystatechange = function success() {
            if (!this.request.responseXML) {
              return;
            }
            if (!this.request.readyState === 4 || !this.request.status === 200) {
              return;
            }

            const newContainer = this.request.responseXML.querySelector(this.settings.container);
            const newPagination = this.request.responseXML.querySelector(this.settings.pagination);

            this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);

            if (typeof newPagination === 'undefined' || newPagination === null) {
              this.removePaginationElement();
            } else {
              this.paginationElement.innerHTML = newPagination.innerHTML;

              if (this.settings.callback && typeof this.settings.callback === 'function') {
                this.settings.callback(this.request.responseXML);
              }

              this.initialize();
            }
          }.bind(this);

          this.request.open('GET', this.nextPageUrl, true);
          this.request.responseType = 'document';
          this.request.send();
        };
      }

      unload() {
        if (this.endlessScroll) {
          this.endlessScroll.destroy();
        }
      }
    }

    const ajaxify = {
      onLoad() {
        sections$6 = new Ajaxify(this.container);
      },
      onUnload: function () {
        if (typeof sections$6.unload === 'function') {
          sections$6.unload();
        }
      },
    };

    const sections$5 = {};

    class Blog {
      constructor(section) {
        this.container = section.container;
        this.checkWidthOnResize = this.checkWindowWidth();

        this.init();
      }

      init() {
        this.checkWindowWidth();

        document.addEventListener('theme:resize', this.checkWidthOnResize);
      }

      checkWindowWidth() {
        if (window.innerWidth < theme.sizes.small) {
          removeAnimations(this.container);
        }
      }

      onUnload() {
        document.removeEventListener('theme:resize', this.checkWidthOnResize);
      }
    }

    const BlogSection = {
      onLoad() {
        sections$5[this.id] = new Blog(this);
      },
      onUnload(e) {
        sections$5[this.id].onUnload(e);
      },
    };

    register('blog', [BlogSection, ajaxify]);
    register('featured-blog', BlogSection);

    const selectors$8 = {
      rangeSlider: '[data-range-slider]',
      rangeDotLeft: '[data-range-left]',
      rangeDotRight: '[data-range-right]',
      rangeLine: '[data-range-line]',
      rangeHolder: '[data-range-holder]',
      dataMin: 'data-se-min',
      dataMax: 'data-se-max',
      dataMinValue: 'data-se-min-value',
      dataMaxValue: 'data-se-max-value',
      dataStep: 'data-se-step',
      dataFilterUpdate: 'data-range-filter-update',
      priceMin: '[data-field-price-min]',
      priceMax: '[data-field-price-max]',
    };

    const classes$5 = {
      classInitialized: 'is-initialized',
    };

    class RangeSlider {
      constructor(section) {
        this.container = section.container;
        this.slider = section.querySelector(selectors$8.rangeSlider);
        this.initFilters = () => this.init();

        if (this.slider) {
          this.onMoveEvent = (event) => this.onMove(event);
          this.onStopEvent = (event) => this.onStop(event);
          this.onStartEvent = (event) => this.onStart(event);
          this.startX = 0;
          this.x = 0;

          // retrieve touch button
          this.touchLeft = this.slider.querySelector(selectors$8.rangeDotLeft);
          this.touchRight = this.slider.querySelector(selectors$8.rangeDotRight);
          this.lineSpan = this.slider.querySelector(selectors$8.rangeLine);

          // get some properties
          this.min = parseFloat(this.slider.getAttribute(selectors$8.dataMin));
          this.max = parseFloat(this.slider.getAttribute(selectors$8.dataMax));

          this.step = 0.0;

          // normalize flag
          this.normalizeFact = 26;

          document.addEventListener('theme:resize:width', this.initFilters);
          document.addEventListener('theme:filter:init', this.initFilters);

          this.init();
        }
      }

      init() {
        // retrieve default values
        let defaultMinValue = this.min;
        if (this.slider.hasAttribute(selectors$8.dataMinValue)) {
          defaultMinValue = parseFloat(this.slider.getAttribute(selectors$8.dataMinValue));
        }
        let defaultMaxValue = this.max;

        if (this.slider.hasAttribute(selectors$8.dataMaxValue)) {
          defaultMaxValue = parseFloat(this.slider.getAttribute(selectors$8.dataMaxValue));
        }

        // check values are correct
        if (defaultMinValue < this.min) {
          defaultMinValue = this.min;
        }

        if (defaultMaxValue > this.max) {
          defaultMaxValue = this.max;
        }

        if (defaultMinValue > defaultMaxValue) {
          defaultMinValue = defaultMaxValue;
        }

        if (this.slider.getAttribute(selectors$8.dataStep)) {
          this.step = Math.abs(parseFloat(this.slider.getAttribute(selectors$8.dataStep)));
        }

        // initial reset
        this.reset();

        // usefull values, min, max, normalize fact is the width of both touch buttons
        this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth;
        this.selectedTouch = null;
        this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact;

        // set defualt values
        this.setMinValue(defaultMinValue);
        this.setMaxValue(defaultMaxValue);

        // link events
        this.touchLeft.addEventListener('mousedown', this.onStartEvent);
        this.touchRight.addEventListener('mousedown', this.onStartEvent);
        this.touchLeft.addEventListener('touchstart', this.onStartEvent, {passive: true});
        this.touchRight.addEventListener('touchstart', this.onStartEvent, {passive: true});

        // initialize
        this.slider.classList.add(classes$5.classInitialized);
      }

      reset() {
        this.touchLeft.style.left = '0px';
        this.touchRight.style.left = this.slider.offsetWidth - this.touchLeft.offsetWidth + 'px';
        this.lineSpan.style.marginLeft = '0px';
        this.lineSpan.style.width = this.slider.offsetWidth - this.touchLeft.offsetWidth + 'px';
        this.startX = 0;
        this.x = 0;
      }

      setMinValue(minValue) {
        const ratio = (minValue - this.min) / (this.max - this.min);
        this.touchLeft.style.left = Math.ceil(ratio * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))) + 'px';
        this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + 'px';
        this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + 'px';
        this.slider.setAttribute(selectors$8.dataMinValue, minValue);
      }

      setMaxValue(maxValue) {
        const ratio = (maxValue - this.min) / (this.max - this.min);
        this.touchRight.style.left = Math.ceil(ratio * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) + this.normalizeFact) + 'px';
        this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + 'px';
        this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + 'px';
        this.slider.setAttribute(selectors$8.dataMaxValue, maxValue);
      }

      onStart(event) {
        // Prevent default dragging of selected content
        event.preventDefault();
        let eventTouch = event;

        if (event.touches) {
          eventTouch = event.touches[0];
        }

        if (event.currentTarget === this.touchLeft) {
          this.x = this.touchLeft.offsetLeft;
        } else {
          this.x = this.touchRight.offsetLeft;
        }

        this.startX = eventTouch.pageX - this.x;
        this.selectedTouch = event.currentTarget;
        document.addEventListener('mousemove', this.onMoveEvent);
        document.addEventListener('mouseup', this.onStopEvent);
        document.addEventListener('touchmove', this.onMoveEvent, {passive: true});
        document.addEventListener('touchend', this.onStopEvent, {passive: true});
      }

      onMove(event) {
        let eventTouch = event;

        if (event.touches) {
          eventTouch = event.touches[0];
        }

        this.x = eventTouch.pageX - this.startX;

        if (this.selectedTouch === this.touchLeft) {
          if (this.x > this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10) {
            this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10;
          } else if (this.x < 0) {
            this.x = 0;
          }

          this.selectedTouch.style.left = this.x + 'px';
        } else if (this.selectedTouch === this.touchRight) {
          if (this.x < this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10) {
            this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10;
          } else if (this.x > this.maxX) {
            this.x = this.maxX;
          }
          this.selectedTouch.style.left = this.x + 'px';
        }

        // update line span
        this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + 'px';
        this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + 'px';

        // write new value
        this.calculateValue();

        // call on change
        if (this.slider.getAttribute('on-change')) {
          const fn = new Function('min, max', this.slider.getAttribute('on-change'));
          fn(this.slider.getAttribute(selectors$8.dataMinValue), this.slider.getAttribute(selectors$8.dataMaxValue));
        }

        this.onChange(this.slider.getAttribute(selectors$8.dataMinValue), this.slider.getAttribute(selectors$8.dataMaxValue));
      }

      onStop(event) {
        document.removeEventListener('mousemove', this.onMoveEvent);
        document.removeEventListener('mouseup', this.onStopEvent);
        document.removeEventListener('touchmove', this.onMoveEvent);
        document.removeEventListener('touchend', this.onStopEvent);

        this.selectedTouch = null;

        // write new value
        this.calculateValue();

        // call did changed
        this.onChanged(this.slider.getAttribute(selectors$8.dataMinValue), this.slider.getAttribute(selectors$8.dataMaxValue));
      }

      onChange(min, max) {
        const rangeHolder = this.slider.closest(selectors$8.rangeHolder);
        if (rangeHolder) {
          const priceMin = rangeHolder.querySelector(selectors$8.priceMin);
          const priceMax = rangeHolder.querySelector(selectors$8.priceMax);

          if (priceMin && priceMax) {
            priceMin.value = min;
            priceMax.value = max;
          }
        }
      }

      onChanged(min, max) {
        if (this.slider.hasAttribute(selectors$8.dataFilterUpdate)) {
          this.slider.dispatchEvent(new CustomEvent('theme:filter:range-update', {bubbles: true}));
        }
      }

      calculateValue() {
        const newValue = (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
        let minValue = this.lineSpan.offsetLeft / this.initialValue;
        let maxValue = minValue + newValue;

        minValue = minValue * (this.max - this.min) + this.min;
        maxValue = maxValue * (this.max - this.min) + this.min;

        if (this.step !== 0.0) {
          let multi = Math.floor(minValue / this.step);
          minValue = this.step * multi;

          multi = Math.floor(maxValue / this.step);
          maxValue = this.step * multi;
        }

        if (this.selectedTouch === this.touchLeft) {
          this.slider.setAttribute(selectors$8.dataMinValue, minValue);
        }

        if (this.selectedTouch === this.touchRight) {
          this.slider.setAttribute(selectors$8.dataMaxValue, maxValue);
        }
      }

      onUnload() {
        if (this.initFilters) {
          document.removeEventListener('theme:resize:width', this.initFilters);
        }
      }
    }

    const sections$4 = {};

    class Collection {
      constructor(section) {
        this.container = section.container;
        this.collectionGridWrapper = this.container.querySelector('[data-collection-grid-wrapper]');
        this.collectionProducts = this.container.querySelector('[data-collection-products]');
        this.collectionWrapper = this.container.querySelector('[data-collection-wrapper]');
        this.pagination = this.container.querySelector('[data-pagination]');
        this.accordionElements = this.container.querySelector('accordion-elements');
        this.filters = this.container.querySelector('[data-filters]');
        this.filtersEnable = this.container.getAttribute('data-filters-enable') === 'true';
        this.filtersForm = this.container.querySelector('[data-filters-form]');
        this.filtersResets = this.container.querySelector('[data-filters-reset]');
        this.showMoreOptions = this.container.querySelectorAll('[data-show-more]');
        this.filterToggleBtn = this.container.querySelector('[data-toggle-filters]');
        this.filtersSticky = this.container.querySelector('[data-filters-sticky]');
        this.collectionSortInputs = this.container.querySelectorAll('[data-collection-sort]');
        this.filtersInputs = [];
        this.sort = null;
        this.collection = null;
        this.reset = null;
        this.filtersPositionState = this.isTopPosition() ? 'top' : 'left';
        this.isRangeSliderInitialized = false;
        this.showMoreEvent = (e) => this.showMore(e);
        this.sortChangeEvent = (e) => this.onSortChange(e);
        this.filterAccordionToggleEvent = (e) => this.onFilterAccordionToggle(e);
        this.toggleMobileFiltersEvent = () => this.toggleMobileFilters();
        this.resizeFiltersEvent = () => this.checkFiltersPosition();
        this.updateFiltersStickyHeaderHeightEvent = () => this.updateFiltersStickyHeaderHeight();
        this.onSectionLoadEvent = () => this.updateFiltersStickyHeaderHeight();
        this.documentClick = (e) => this.closeOnOutsideClick(e);
        this.mobileFiltersOutsideClick = (e) => this.closeMobileFiltersOnOutsideClick(e);

        this.init();
      }

      init() {
        this.updateFiltersStickyHeaderHeight();

        if (this.collectionProducts) {
          this.collection = this.collectionProducts.getAttribute('data-collection');
        }

        this.reinitDynamicElements({initPosition: true});
        document.addEventListener('theme:resize', this.resizeFiltersEvent);
        window.addEventListener('load', this.updateFiltersStickyHeaderHeightEvent);
        document.addEventListener('shopify:section:load', this.onSectionLoadEvent);
      }

      refreshDynamicReferences() {
        this.filters = this.container.querySelector('[data-filters]');
        this.filtersForm = this.container.querySelector('[data-filters-form]');
        this.accordionElements = this.container.querySelector('accordion-elements');
        this.collectionSortInputs = this.container.querySelectorAll('[data-collection-sort]');
        this.filterToggleBtn = this.container.querySelector('[data-toggle-filters]');
        this.filtersSticky = this.container.querySelector('[data-filters-sticky]');
      }

      reinitDynamicElements({initPosition = false} = {}) {
        this.refreshDynamicReferences();

        if (this.filtersEnable && this.filters) {
          this.initFacetedFilters();
          this.checkFiltersPosition(initPosition);
          this.initFilterToggleButtons();
        }

        this.initSort();
        this.initShowMoreOptions();
        this.initMobileFiltersToggle();
        this.bindSwatchFilters();
      }

      initShowMoreOptions() {
        this.showMoreOptions = this.container.querySelectorAll('[data-show-more]');

        // Re-bind after dynamic filter HTML updates
        this.showMoreOptions?.forEach((element) => {
          element.removeEventListener('click', this.showMoreEvent);
          element.addEventListener('click', this.showMoreEvent);
        });
      }

      updateFiltersStickyHeaderHeight() {
        if (!this.filtersSticky) {
          return;
        }

        const header = document.querySelector('[data-header-height]');
        const isHeaderSticky = header?.classList.contains('header--sticky');

        if (isHeaderSticky) {
          this.filtersSticky.style.removeProperty('--header-height');
        } else {
          this.filtersSticky.style.setProperty('--header-height', '0px');
        }
      }

      initSort() {
        if (!this.collectionSortInputs.length) {
          return;
        }

        this.collectionSortInputs.forEach((input) => {
          input.removeEventListener('change', this.sortChangeEvent);
          input.addEventListener('change', this.sortChangeEvent);
        });
      }

      onSortChange(evt) {
        const url = new window.URL(window.location.href);
        const value = evt.currentTarget.value;
        const params = url.searchParams;
        params.set('sort_by', value);
        url.search = params.toString();
        this.collectionProducts.setAttribute('data-sort', value);
        this.requestFilteredProducts(url.toString());

        // Close mobile filters after sorting
        this.closeMobileFilters?.();
      }

      initMobileFiltersToggle() {
        if (!this.filterToggleBtn || !this.filtersSticky) {
          return;
        }

        this.filterToggleBtn.removeEventListener('click', this.toggleMobileFiltersEvent);
        this.filterToggleBtn.addEventListener('click', this.toggleMobileFiltersEvent);
      }

      toggleMobileFilters() {
        const isOpen = this.filtersSticky.classList.contains('is-open');
        if (isOpen) {
          this.closeMobileFilters();
        } else {
          this.filtersSticky.classList.add('is-open');
          document.addEventListener('click', this.mobileFiltersOutsideClick);
        }
      }

      closeMobileFilters() {
        if (this.filtersSticky?.classList.contains('is-open')) {
          this.filtersSticky.classList.remove('is-open');
          document.removeEventListener('click', this.mobileFiltersOutsideClick);
        }
      }

      closeMobileFiltersOnOutsideClick(e) {
        if (!this.filtersSticky?.contains(e.target) && this.filtersSticky?.classList.contains('is-open')) {
          this.closeMobileFilters();
        }
      }

      initFilterToggleButtons() {
        if (!this.filters) {
          return;
        }

        this.filters.querySelectorAll('[data-accordion-trigger]')?.forEach((button) => {
          button.removeEventListener('click', this.filterAccordionToggleEvent);
          button.addEventListener('click', this.filterAccordionToggleEvent);
        });
      }

      onFilterAccordionToggle(e) {
        const button = e.currentTarget;
        const distanceFromTop = button.parentNode.querySelector('[data-filter-container]').getBoundingClientRect().top;
        document.documentElement.style.setProperty('--filters-top', `${distanceFromTop}px`);

        const isPriceFilter = button.parentNode.querySelector('[data-range-slider]');

        if (isPriceFilter && !this.isRangeSliderInitialized) {
          this.filtersForm.dispatchEvent(new CustomEvent('theme:filter:init', {bubbles: true}));
          this.isRangeSliderInitialized = true;
        }

        // Close horizontal filters on click outside their container
        document.addEventListener('click', this.documentClick);
      }

      showMore(e) {
        e.preventDefault();
        const target = e.target.matches('[data-show-more]') ? e.target : e.target.closest('[data-show-more]');

        target.parentElement.classList.add('hidden');
        target.parentElement.previousElementSibling.querySelectorAll('[data-link-hidden]').forEach((link, index) => {
          link.classList.remove('hidden');
          const input = link.querySelector('input');
          if (index === 0 && document.body.classList.contains('is-focused') && input) {
            if (this.collectionSidebarSlideOut || window.theme.isMobile()) {
              this.a11y.removeTrapFocus();
              this.a11y.trapFocus(this.collectionSidebar, {
                elementToFocus: input,
              });
            } else {
              input.focus();
            }
          }
        });
      }

      initFacetedFilters() {
        if (!this.filters.hasAttribute('data-filters-available')) {
          return;
        }

        new RangeSlider(this.filtersForm);
        this.filtersInputs = this.filtersForm.querySelectorAll('input, select, label, textarea');

        if (this.filtersInputs.length) {
          this.filtersInputs.forEach((el) => {
            el.addEventListener(
              'input',
              window.theme.debounce(() => {
                if (this.filtersForm && typeof this.filtersForm.submit === 'function') {
                  this.submitForm();
                }
              }, 500)
            );
          });
        }

        this.filtersForm.addEventListener('theme:filter:range-update', () => this.updateRange());
        this.initResets();
      }

      submitForm() {
        const formData = new FormData(this.filtersForm);
        const search = new URLSearchParams(formData);
        this.requestFilteredProducts(`${this.collection}${search.toString()}`);
      }

      initResets() {
        const resets = this.container.querySelectorAll('[data-filter-reset-button]');
        this.resetAlt = this.collectionProducts.querySelector('[data-filters-reset-button]');

        // Bind reset
        if (resets.length) {
          resets.forEach((button) => {
            button.addEventListener('click', (e) => this.bindResetButton(e));
          });
        }
        if (this.resetAlt) {
          this.resetAlt.addEventListener('click', (e) => this.bindResetButton(e));
        }
      }

      updateRange() {
        if (this.filtersForm && typeof this.filtersForm.submit === 'function') {
          const rangeMin = this.filtersForm.querySelector('[data-se-min-value]');
          const rangeMax = this.filtersForm.querySelector('[data-se-max-value]');
          const priceMin = this.filtersForm.querySelector('[data-field-price-min]');
          const priceMax = this.filtersForm.querySelector('[data-field-price-max]');
          const checkElements = rangeMin && rangeMax && priceMin && priceMax;

          if (checkElements && rangeMin.hasAttribute('data-se-min-value') && rangeMax.hasAttribute('data-se-max-value')) {
            const priceMinValue = parseInt(priceMin.placeholder);
            const priceMaxValue = parseInt(priceMax.placeholder);
            const rangeMinValue = parseInt(rangeMin.getAttribute('data-se-min-value'));
            const rangeMaxValue = parseInt(rangeMax.getAttribute('data-se-max-value'));

            if (priceMinValue !== rangeMinValue || priceMaxValue !== rangeMaxValue) {
              priceMin.value = rangeMinValue;
              priceMax.value = rangeMaxValue;

              this.submitForm();
            }
          }
        }
      }

      closeOnOutsideClick(e) {
        const isFiltersContainer = this.filters.contains(e.target);
        const isFilterExpanded = this.filters.querySelector('details[open]');

        // Close filter
        if (!isFiltersContainer && isFilterExpanded && this.isTopPosition()) {
          const expandedFilter = this.filters.querySelector('details[open]');
          expandedFilter.querySelector('[data-accordion-trigger]').dispatchEvent(new Event('click'));

          document.removeEventListener('click', this.documentClick);
        }
      }

      requestFilteredProducts(url) {
        const collectionWrapperTop = parseInt(Math.ceil(this.collectionWrapper.offsetTop) - theme.dimensions.headerScrolled);

        this.collectionWrapper.classList.add('is-loading');

        // Scroll back to top
        window.scrollTo({
          top: collectionWrapperTop,
          left: 0,
          behavior: 'smooth',
        });

        if (history.replaceState) {
          window.history.pushState({path: url}, '', url);
        }

        fetch(url)
          .then((response) => {
            return response.text();
          })
          .then((data) => {
            const createdElement = document.createElement('div');
            createdElement.innerHTML = data;
            const collectionProductsElement = createdElement.querySelector('[data-collection-products]');
            const pagination = createdElement.querySelector('[data-pagination]');
            const filters = createdElement.querySelector('[data-filters]');

            if (!collectionProductsElement || !this.collectionProducts) {
              return;
            }

            this.collectionProducts.innerHTML = collectionProductsElement.innerHTML;

            if (this.pagination) {
              this.pagination.innerHTML = pagination !== null ? pagination.innerHTML : '';
            }

            if (!this.pagination && pagination !== null) {
              this.collectionGridWrapper.appendChild(pagination);
              this.pagination = this.collectionGridWrapper.querySelector('[data-pagination]');
            }

            if (filters && this.filters) {
              const filtersHTML = filters.innerHTML;

              this.filters.innerHTML = filtersHTML;
            }

            this.reinitDynamicElements();

            ajaxify.onUnload();
            new Ajaxify(this.container);
          })
          .catch((e) => {
            this.collectionWrapper.classList.remove('is-loading');
          })
          .finally(() => {
            // Stop loading animation
            setTimeout(() => {
              this.collectionWrapper.classList.remove('is-loading');
            }, 450);
          });
      }

      checkFiltersPosition(init = false) {
        if (!this.filters) {
          return;
        }

        const currentState = this.isTopPosition() ? 'top' : 'left';
        const stateChanged = this.filtersPositionState !== currentState;

        if (!init && !stateChanged) return;

        // Run only if filters position is set to "Top" or window width is < 1279
        if (this.isTopPosition()) {
          this.accordionElements?.setAttribute('single', true);

          // Close filters if position is set to "Top"
          this.filters.querySelectorAll('details[open]')?.forEach((filter) => {
            const filterExpanded = filter.hasAttribute('open');

            // Check if dropdown is expanded and close it
            if (filterExpanded) {
              filter.removeAttribute('open');
              filter.querySelector('[data-filter-container]').style.height = 0;
            }
          });
        } else {
          this.accordionElements?.removeAttribute('single');
        }

        // Update filters state
        this.filtersPositionState = currentState;
      }

      isTopPosition() {
        return window.innerWidth < theme.sizes.widescreen || this.filters?.classList.contains('collection__filters--top');
      }

      bindResetButton(e) {
        e.preventDefault();

        this.requestFilteredProducts(e.currentTarget.href);
      }

      onUnload() {
        document.removeEventListener('theme:resize', this.resizeFiltersEvent);
        window.removeEventListener('load', this.updateFiltersStickyHeaderHeightEvent);
        document.removeEventListener('shopify:section:load', this.onSectionLoadEvent);
      }

      bindSwatchFilters() {
        this.swatches = [];
        const els = this.container.querySelectorAll('[data-swatch]');
        els.forEach((el) => {
          if (typeof Swatch === 'function') {
            this.swatches.push(new Swatch(el));
          }
        });
      }
    }

    const CollectionSection = {
      onLoad() {
        sections$4[this.id] = new Collection(this);
      },
      onUnload(e) {
        sections$4[this.id].onUnload(e);
      },
    };

    register('collection', [CollectionSection, ajaxify]);
    register('search-template', [CollectionSection, ajaxify]);

    const footerSection = {
      onLoad() {
        // Lighthouse fires security warning for the Shopify link.
        var shopifyLink = document.querySelector('[data-powered-link] a');
        if (shopifyLink) {
          shopifyLink.setAttribute('rel', 'noopener');
        }
      },
    };

    register('footer', [footerSection]);

    const selectors$7 = {
      faqTrigger: '[data-faq-trigger]',
      accordionTrigger: '[data-accordion-trigger]',
    };

    const attributes$1 = {
      faqTrigger: 'data-faq-trigger',
      index: 'data-index',
    };

    const classes$4 = {
      isActive: 'is-active',
    };

    class FaqList extends AccordionElements {
      constructor() {
        super();
      }

      connectedCallback() {
        this.triggers = this.querySelectorAll(selectors$7.faqTrigger);

        this.triggers.forEach((button) => {
          button.addEventListener('click', (event) => {
            if (button.classList.contains(classes$4.isActive)) return;

            const activeButton = this.querySelector(`${selectors$7.faqTrigger}.${classes$4.isActive}`);
            const accordionButton = this.querySelector(`${selectors$7.accordionTrigger}[${attributes$1.index}="${button.dataset.index}"]`);

            activeButton?.classList.remove(classes$4.isActive);
            activeButton?.setAttribute('aria-expanded', 'false');
            accordionButton?.click();

            button.classList.add(classes$4.isActive);
            button.setAttribute('aria-expanded', 'true');
          });
        });
      }
    }

    if (!customElements.get('faq-list')) {
      customElements.define('faq-list', FaqList);
    }

    register('collection-grid', [ajaxify]);

    const sections$3 = {};

    const selectors$6 = {
      logoListSlider: '[data-logo-list-slider]',
      logoListSlide: '[data-logo-list-slide]',
      logoListSlideData: 'data-logo-list-slide',
      logoListSlideIndex: 'data-slide-index',
    };

    const classes$3 = {
      flickityEnabled: 'flickity-enabled',
    };

    class LogoList {
      constructor(section) {
        this.container = section.container;
        this.slideshow = this.container.querySelector(selectors$6.logoListSlider);
        this.sliderInitEvent = () => this.sliderInit();

        this.init();
      }

      init() {
        this.sliderInit();

        document.addEventListener('theme:resize', this.sliderInitEvent);
      }

      sliderInit() {
        const slidesCount = this.slideshow.querySelectorAll(selectors$6.logoListSlide).length;
        const slideWidth = 220;
        const windowWidth = document.documentElement.clientWidth || document.body.clientWidth;
        const slidesWidth = slidesCount * slideWidth;
        const sliderInitialized = this.slideshow.classList.contains(classes$3.flickityEnabled);

        if (windowWidth < slidesWidth) {
          if (!sliderInitialized) {
            this.flkty = new Flickity(this.slideshow, {
              autoPlay: 4000,
              prevNextButtons: false,
              pageDots: false,
              wrapAround: true,
            });
          }
        } else if (sliderInitialized) {
          this.flkty.destroy();
        }
      }

      onUnload() {
        const sliderInitialized = this.slideshow.classList.contains(classes$3.flickityEnabled);

        if (sliderInitialized) {
          this.flkty.destroy();
        }

        document.removeEventListener('theme:resize', this.sliderInitEvent);
      }

      onBlockSelect(evt) {
        const slide = this.slideshow.querySelector(`[${selectors$6.logoListSlideData}="${evt.detail.blockId}"]`);
        const slideIndex = parseInt(slide.getAttribute(selectors$6.logoListSlideIndex));
        const sliderInitialized = this.slideshow.classList.contains(classes$3.flickityEnabled);

        if (sliderInitialized) {
          this.flkty.select(slideIndex);
          this.flkty.pausePlayer();
        }
      }

      onBlockDeselect() {
        const sliderInitialized = this.slideshow.classList.contains(classes$3.flickityEnabled);

        if (sliderInitialized) {
          this.flkty.unpausePlayer();
        }
      }
    }

    const LogoListSection = {
      onLoad() {
        sections$3[this.id] = new LogoList(this);
      },
      onUnload(e) {
        sections$3[this.id].onUnload(e);
      },
      onBlockSelect(e) {
        sections$3[this.id].onBlockSelect(e);
      },
      onBlockDeselect() {
        sections$3[this.id].onBlockDeselect();
      },
    };

    register('logo-list', LogoListSection);

    function getScript(url, callback, callbackError) {
      let head = document.getElementsByTagName('head')[0];
      let done = false;
      let script = document.createElement('script');
      script.src = url;

      // Attach handlers for all browsers
      script.onload = script.onreadystatechange = function () {
        if (!done && (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete')) {
          done = true;
          callback();
        } else {
          callbackError();
        }
      };

      head.appendChild(script);
    }

    const loaders = {};

    function loadScript(options = {}) {
      if (!options.type) {
        options.type = 'json';
      }

      if (options.url) {
        if (loaders[options.url]) {
          return loaders[options.url];
        } else {
          return getScriptWithPromise(options.url, options.type);
        }
      } else if (options.json) {
        if (loaders[options.json]) {
          return Promise.resolve(loaders[options.json]);
        } else {
          return window
            .fetch(options.json)
            .then((response) => {
              return response.json();
            })
            .then((response) => {
              loaders[options.json] = response;
              return response;
            });
        }
      } else if (options.name) {
        const key = ''.concat(options.name, options.version);
        if (loaders[key]) {
          return loaders[key];
        } else {
          return loadShopifyWithPromise(options);
        }
      } else {
        return Promise.reject();
      }
    }

    function getScriptWithPromise(url, type) {
      const loader = new Promise((resolve, reject) => {
        if (type === 'text') {
          fetch(url)
            .then((response) => response.text())
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          getScript(
            url,
            function () {
              resolve();
            },
            function () {
              reject();
            }
          );
        }
      });

      loaders[url] = loader;
      return loader;
    }

    function loadShopifyWithPromise(options) {
      const key = ''.concat(options.name, options.version);
      const loader = new Promise((resolve, reject) => {
        try {
          window.Shopify.loadFeatures([
            {
              name: options.name,
              version: options.version,
              onLoad: (err) => {
                onLoadFromShopify(resolve, reject, err);
              },
            },
          ]);
        } catch (err) {
          reject(err);
        }
      });
      loaders[key] = loader;
      return loader;
    }

    function onLoadFromShopify(resolve, reject, err) {
      if (err) {
        return reject(err);
      } else {
        return resolve();
      }
    }

    const selectors$5 = {
      popupContainer: '.pswp',
      popupCloseBtn: '.pswp__custom-close',
      popupIframe: 'iframe, video',
      popupCustomIframe: '.pswp__custom-iframe',
      popupThumbs: '.pswp__thumbs',
      dataOptionClasses: 'data-pswp-option-classes',
      dataVideoType: 'data-video-type',
    };

    const classes$2 = {
      classCurrent: 'is-current',
      classCustomLoader: 'pswp--custom-loader',
      classCustomOpen: 'pswp--custom-opening',
      classLoader: 'pswp__loader',
    };

    const loaderHTML = `<div class="${classes$2.classLoader}"><div class="loader pswp__loader-line"><div class="loader-indeterminate"></div></div></div>`;

    class LoadPhotoswipe {
      constructor(items, options = '') {
        this.a11y = a11y$1;
        this.items = items;
        this.pswpElement = document.querySelectorAll(selectors$5.popupContainer)[0];
        this.popup = null;
        this.popupThumbs = null;
        this.popupThumbsContainer = this.pswpElement.querySelector(selectors$5.popupThumbs);
        this.closeBtn = this.pswpElement.querySelector(selectors$5.popupCloseBtn);
        this.closeButtonClick = () => this.closeButtonClickEvent();
        const defaultOptions = {
          history: false,
          focus: false,
          mainClass: '',
        };
        this.options = options !== '' ? options : defaultOptions;

        this.init();
      }

      init() {
        this.pswpElement.classList.add(classes$2.classCustomOpen);

        this.initLoader();

        loadScript({url: window.theme.assets.photoswipe})
          .then(() => this.loadPopup())
          .catch((e) => console.error(e));
      }

      initLoader() {
        if (this.pswpElement.classList.contains(classes$2.classCustomLoader) && this.options !== '' && this.options.mainClass) {
          this.pswpElement.setAttribute(selectors$5.dataOptionClasses, this.options.mainClass);
          let loaderElem = document.createElement('div');
          loaderElem.innerHTML = loaderHTML;
          loaderElem = loaderElem.firstChild;
          this.pswpElement.appendChild(loaderElem);
        } else {
          this.pswpElement.setAttribute(selectors$5.dataOptionClasses, '');
        }
      }

      loadPopup() {
        const PhotoSwipe = window.themePhotoswipe.PhotoSwipe.default;
        const PhotoSwipeUI = window.themePhotoswipe.PhotoSwipeUI.default;

        if (this.pswpElement.classList.contains(classes$2.classCustomLoader)) {
          this.pswpElement.classList.remove(classes$2.classCustomLoader);
        }

        this.pswpElement.classList.remove(classes$2.classCustomOpen);

        this.popup = new PhotoSwipe(this.pswpElement, PhotoSwipeUI, this.items, this.options);
        this.popup.init();

        this.a11y.trapFocus(this.pswpElement);

        this.thumbsActions();

        if (this.closeBtn) {
          this.closeBtn.addEventListener('click', this.closeButtonClick);
        }

        this.popup.listen('close', () => this.onClose());
      }

      closeButtonClickEvent() {
        this.popup.close();
        this.a11y.removeTrapFocus();
        if (theme.a11yTrigger !== null) {
          theme.a11yTrigger.focus();
        }
      }

      thumbsActions() {
        if (this.popupThumbsContainer && this.popupThumbsContainer.firstChild) {
          this.popupThumbsContainer.addEventListener('wheel', (e) => this.stopDisabledScroll(e));
          this.popupThumbsContainer.addEventListener('mousewheel', (e) => this.stopDisabledScroll(e));
          this.popupThumbsContainer.addEventListener('DOMMouseScroll', (e) => this.stopDisabledScroll(e));

          this.popupThumbs = this.pswpElement.querySelectorAll(`${selectors$5.popupThumbs} > *`);
          this.popupThumbs.forEach((element, i) => {
            element.addEventListener('click', (e) => {
              e.preventDefault();
              element.parentElement.querySelector(`.${classes$2.classCurrent}`).classList.remove(classes$2.classCurrent);
              element.classList.add(classes$2.classCurrent);
              this.popup.goTo(i);
            });
          });

          this.popup.listen('imageLoadComplete', () => this.setCurrentThumb());
          this.popup.listen('beforeChange', () => this.setCurrentThumb());
        }
      }

      stopDisabledScroll(e) {
        e.stopPropagation();
      }

      onClose() {
        const popupIframe = this.pswpElement.querySelector(selectors$5.popupIframe);
        if (popupIframe) {
          popupIframe.parentNode.removeChild(popupIframe);
        }

        if (this.popupThumbsContainer && this.popupThumbsContainer.firstChild) {
          while (this.popupThumbsContainer.firstChild) {
            this.popupThumbsContainer.removeChild(this.popupThumbsContainer.firstChild);
          }
        }

        this.pswpElement.setAttribute(selectors$5.dataOptionClasses, '');
        const loaderElem = this.pswpElement.querySelector(`.${classes$2.classLoader}`);
        if (loaderElem) {
          this.pswpElement.removeChild(loaderElem);
        }

        this.a11y.removeTrapFocus();

        if (theme.a11yTrigger !== null) {
          theme.a11yTrigger.focus();
        }

        this.closeBtn.removeEventListener('click', this.closeButtonClick);
      }

      setCurrentThumb() {
        const lastCurrentThumb = this.pswpElement.querySelector(`${selectors$5.popupThumbs} > .${classes$2.classCurrent}`);
        if (lastCurrentThumb) {
          lastCurrentThumb.classList.remove(classes$2.classCurrent);
        }

        if (!this.popupThumbs) {
          return;
        }
        const currentThumb = this.popupThumbs[this.popup.getCurrentIndex()];
        currentThumb.classList.add(classes$2.classCurrent);
        this.scrollThumbs(currentThumb);
      }

      scrollThumbs(currentThumb) {
        const thumbsContainerLeft = this.popupThumbsContainer.scrollLeft;
        const thumbsContainerWidth = this.popupThumbsContainer.offsetWidth;
        const thumbsContainerPos = thumbsContainerLeft + thumbsContainerWidth;
        const currentThumbLeft = currentThumb.offsetLeft;
        const currentThumbWidth = currentThumb.offsetWidth;
        const currentThumbPos = currentThumbLeft + currentThumbWidth;

        if (thumbsContainerPos <= currentThumbPos || thumbsContainerPos > currentThumbLeft) {
          const currentThumbMarginLeft = parseInt(window.getComputedStyle(currentThumb).marginLeft);
          this.popupThumbsContainer.scrollTo({
            top: 0,
            left: currentThumbLeft - currentThumbMarginLeft,
            behavior: 'smooth',
          });
        }
      }
    }

    const selectors$4 = {
      videoPlay: '[data-video-play]',
      videoPlayValue: 'data-video-play',
    };

    class VideoPlay {
      constructor(section, selector = selectors$4.videoPlay, selectorValue = selectors$4.videoPlayValue) {
        this.container = section;
        this.videoPlay = this.container.querySelectorAll(selector);

        if (this.videoPlay.length) {
          this.videoPlay.forEach((element) => {
            element.addEventListener('click', (e) => {
              const button = e.currentTarget;
              if (button.hasAttribute(selectorValue) && button.getAttribute(selectorValue).trim() !== '') {
                e.preventDefault();
                theme.a11yTrigger = button;

                const items = [
                  {
                    html: button.getAttribute(selectorValue),
                  },
                ];

                new LoadPhotoswipe(items);
              }
            });
          });
        }
      }
    }

    const videoPlay = {
      onLoad() {
        new VideoPlay(this.container);
      },
    };

    const sections$2 = {};

    const selectors$3 = {
      slideshow: '[data-mosaic-blocks]',
      slideshowPrev: '[data-prev-arrow]',
      slideshowNext: '[data-next-arrow]',
      dataSlide: 'data-slide',
      dataSlideIndex: 'data-slide-index',
    };

    const classes$1 = {
      flickityEnabled: 'flickity-enabled',
    };

    class Mosaic {
      constructor(section) {
        this.container = section.container;
        this.slideshow = this.container.querySelector(selectors$3.slideshow);
        this.slideshowPrev = this.container.querySelector(selectors$3.slideshowPrev);
        this.slideshowNext = this.container.querySelector(selectors$3.slideshowNext);
        this.flkty = null;
        this.sliderInitEvent = () => this.initMobileSlider();

        this.init();
      }

      init() {
        this.initMobileSlider();

        document.addEventListener('theme:resize', this.sliderInitEvent);
      }

      initMobileSlider() {
        const isMobileView = theme.isMobile();
        const options = {
          wrapAround: true,
          prevNextButtons: false,
          pageDots: false,
        };

        const goToPrev = () => this.flkty.previous(true);
        const goToNext = () => this.flkty.next(true);

        if (isMobileView && !this.isInit()) {
          this.flkty = new Flickity(this.slideshow, options);

          // Bind slider controls event listeners
          if (this.slideshowPrev && this.slideshowNext) {
            this.slideshowPrev.addEventListener('click', goToPrev);
            this.slideshowNext.addEventListener('click', goToNext);
          }
        } else if (!isMobileView && this.isInit()) {
          this.flkty.destroy();

          // Unbind all slider controls event listeners
          if (this.slideshowPrev && this.slideshowNext) {
            this.slideshowPrev.removeEventListener('click', goToPrev);
            this.slideshowNext.removeEventListener('click', goToNext);
          }
        }
      }

      isInit() {
        const isInitialized = this.slideshow?.classList.contains(classes$1.flickityEnabled);

        return isInitialized;
      }

      onUnload() {
        if (this.isInit()) {
          this.flkty.destroy();
        }

        document.removeEventListener('theme:resize', this.sliderInitEvent);
      }

      onBlockSelect(evt) {
        const slide = this.container.querySelector(`[${selectors$3.dataSlide}="${evt.detail.blockId}"]`);

        if (this.isInit() && slide !== null) {
          this.flkty.select(parseInt(slide.getAttribute(selectors$3.dataSlideIndex)));
        }
      }
    }

    const MosaicSection = {
      onLoad() {
        sections$2[this.id] = new Mosaic(this);
      },
      onUnload(e) {
        sections$2[this.id].onUnload(e);
      },
      onBlockSelect(e) {
        sections$2[this.id].onBlockSelect(e);
      },
    };

    register('mosaic', [MosaicSection, videoPlay]);

    const selectors$2 = {
      inputGroups: '.input-group--error',
      inputs: 'input.password, input.email',
    };

    class Password {
      constructor(section) {
        this.container = section.container;
        this.inputGroups = this.container.querySelectorAll(selectors$2.inputGroups);

        this.init();
      }

      init() {
        this.inputGroups.forEach((inputGroup) => {
          const input = inputGroup.querySelector(selectors$2.inputs);
          input.focus();
        });
      }
    }

    const PasswordSection = {
      onLoad() {
        new Password(this);
      },
    };

    register('password', PasswordSection);

    class PopupCookie {
      constructor(name, value, expires) {
        this.configuration = {
          expires: expires, // session cookie
          path: '/',
          domain: window.location.hostname,
        };
        this.name = name;
        this.value = value;
      }

      write() {
        const hasCookie = document.cookie.indexOf('; ') !== -1 && !document.cookie.split('; ').find((row) => row.startsWith(this.name));
        if (hasCookie || document.cookie.indexOf('; ') === -1) {
          document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
        }
      }

      read() {
        if (document.cookie.indexOf('; ') !== -1 && document.cookie.split('; ').find((row) => row.startsWith(this.name))) {
          const returnCookie = document.cookie
            .split('; ')
            .find((row) => row.startsWith(this.name))
            .split('=')[1];

          return returnCookie;
        } else {
          return false;
        }
      }

      destroy() {
        if (document.cookie.split('; ').find((row) => row.startsWith(this.name))) {
          document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
        }
      }
    }

    const selectors$1 = {
      popup: '[data-popup]',
      close: '[data-popup-close]',
    };

    const classes = {
      popupVisible: 'popup--visible',
    };

    const attributes = {
      delay: 'data-delay',
      reappearTime: 'data-reappear_time',
      testmode: 'data-testmode',
      checkTrueString: 'true',
    };

    let sections$1 = {};

    class Popup {
      constructor(el) {
        this.popup = el;
        this.close = this.popup.querySelector(selectors$1.close);
        this.timeout = 0;
        this.testmode = this.popup.getAttribute(attributes.testmode) === attributes.checkTrueString;
        this.delay = parseInt(this.popup.getAttribute(attributes.delay)) * 1000;
        this.cookie = new PopupCookie('newsletter', 'user_has_closed', this.expireDate());

        this.init();
      }

      expireDate() {
        const todayDate = new Date();
        const expireDate = new Date();
        let date = parseInt(this.popup.getAttribute(attributes.reappearTime));

        if (date !== 0) {
          expireDate.setTime(todayDate.getTime() + 3600000 * 24 * date);
        } else {
          expireDate.setTime(todayDate.getTime() + 3600000 * 24 * 365 * 100);
        }

        date = expireDate.toGMTString();

        return date;
      }

      init() {
        const cookieExists = this.cookie.read() !== false;
        const isChallengePage = window.location.pathname === '/challenge';
        const submissionSuccess = window.location.search.indexOf('?customer_posted=true') !== -1;

        if (submissionSuccess) {
          this.delay = 0;
        }

        if ((!cookieExists && !isChallengePage) || this.testmode) {
          this.timeout = setTimeout(() => {
            this.popup.classList.add(classes.popupVisible);
            this.popup.setAttribute('aria-hidden', 'false');
            this.initClosers();
            this.close.focus();
          }, this.delay);
        }
      }

      initClosers() {
        this.close.addEventListener('click', this.closeModal.bind(this));
      }

      closeModal(e) {
        e.preventDefault();
        this.popup.classList.remove(classes.popupVisible);
        this.popup.setAttribute('aria-hidden', 'true');
        clearTimeout(this.timeout);

        if (!this.testmode) {
          this.cookie.write();
        }
      }
    }

    const popupSection = {
      onLoad() {
        const popup = this.container.querySelector(selectors$1.popup);
        if (popup !== null) {
          sections$1[this.id] = new Popup(popup);
        }
      },
    };

    register('popup', [popupSection]);

    register('recently-viewed-products', {
      onLoad() {
        const container = this.container;
        const wrapper = container.querySelector('#RecentlyViewed');
        const limit = parseInt(container.getAttribute('data-limit'), 10) || 4;

        if (wrapper) {
          Shopify.Products.showRecentlyViewed({
            howManyToShow: limit,
            onComplete: () => {},
          });
        }
      },
    });

    const sections = {};

    const selectors = {
      section: '[data-section-type="related-products"]',
      product: '[data-product-block]',
      productImage: '[data-product-image]',
      sectionId: 'data-section-id',
      productId: 'data-product-id',
      limit: 'data-limit',
    };

    class RelatedProducts {
      constructor(section) {
        this.container = section.container;

        this.init();
      }

      init() {
        const relatedSection = this.container;
        const sectionId = relatedSection.getAttribute(selectors.sectionId);
        const productId = relatedSection.getAttribute(selectors.productId);
        const limit = relatedSection.getAttribute(selectors.limit);
        const requestUrl = `${theme.routes.product_recommendations_url}?section_id=${sectionId}&limit=${limit}&product_id=${productId}`;

        fetch(requestUrl)
          .then((response) => {
            return response.text();
          })
          .then((data) => {
            const createdElement = document.createElement('div');
            createdElement.innerHTML = data;
            const inner = createdElement.querySelector(selectors.section);

            if (inner.querySelector(selectors.product)) {
              relatedSection.innerHTML = inner.innerHTML;
            }
          });
      }
    }

    const RelatedSection = {
      onLoad() {
        sections[this.id] = new RelatedProducts(this);
      },
    };

    register('related-products', RelatedSection);

    class SlideshowElement extends HTMLElement {
      constructor() {
        super();
        this.flkty = null;

        this.handleCheckVisibility = () => this.checkSliderVisibility();
        this.handlePrevClick = () => this.flkty?.previous(true);
        this.handleNextClick = () => this.flkty?.next(true);
        this.handleScrollClick = (e) => this.onScrollClick(e);
        this.handleSelectSlide = (e) => this.onSelectSlide(e);
        this.handleDeselectSlide = () => this.onDeselectSlide();
        this.handleUnload = () => this.disconnectedCallback();
        this.handleResizeWidth = () => this.flkty?.resize();
      }

      connectedCallback() {
        this.parentContainer = this.closest('.shopify-section');
        this.slideshowPrev = this.parentContainer?.querySelector('[data-prev-arrow]');
        this.slideshowNext = this.parentContainer?.querySelector('[data-next-arrow]');
        this.scrollBtn = this.parentContainer?.querySelector('[data-button-scroll]');

        const options = {
          ...JSON.parse(this.getAttribute('data-options').replace(/'/g, '"')),
          cellSelector: '[data-slide]',
          on: {
            ready: () => {
              requestAnimationFrame(() => this.classList.remove('hero--is-loading'));
            },
            change: (index) => this.replaySlideAnimations(index),
          },
        };

        this.flkty = new FlickityFade(this, options);

        this.slideshowPrev?.addEventListener('click', this.handlePrevClick);
        this.slideshowNext?.addEventListener('click', this.handleNextClick);
        this.scrollBtn?.addEventListener('click', this.handleScrollClick);
        document.addEventListener('theme:scroll', this.handleCheckVisibility);
        document.addEventListener('theme:resize:width', this.handleResizeWidth);
        this.addEventListener('theme:slideshow:selectSlide', this.handleSelectSlide);
        this.addEventListener('theme:slideshow:deselect', this.handleDeselectSlide);
        this.addEventListener('shopify:section:unload', this.handleUnload);
      }

      onScrollClick(e) {
        e.preventDefault();

        const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 60;
        const top = this.parentContainer.offsetTop + this.parentContainer.offsetHeight - headerHeight;

        window.scrollTo({top, behavior: 'smooth'});
      }

      onSelectSlide(evt) {
        if (!this.flkty || typeof evt.detail?.index !== 'number') return;
        this.flkty.select(evt.detail.index);
        this.flkty.stopPlayer();
      }

      onDeselectSlide() {
        if (this.isAutoplay()) {
          this.flkty.playPlayer();
        }
      }

      isAutoplay() {
        return Boolean(this.flkty) && this.flkty.options.autoPlay !== false;
      }

      replaySlideAnimations(index) {
        const slide = this.flkty?.cells?.[index]?.element;
        if (!slide) return;

        const animated = slide.querySelectorAll('[data-aos]');
        if (!animated.length) return;

        // Disable transitions and remove the animate class so the element snaps back to
        // its initial state instantly (otherwise it would transition back over 0.6s and
        // our re-add would just reverse the in-flight transition with no visible replay).
        animated.forEach((el) => {
          el.classList.add('aos-no-transition');
          el.classList.remove('aos-animate');
        });

        // Force reflow so the snap-back is committed before transitions are re-enabled.
        slide.offsetHeight; // eslint-disable-line no-unused-vars

        animated.forEach((el) => {
          el.classList.remove('aos-no-transition');
        });

        requestAnimationFrame(() => {
          animated.forEach((el) => el.classList.add('aos-animate'));
        });
      }

      checkSliderVisibility() {
        if (!this.flkty) return;

        const isInitialized = this.classList.contains('flickity-enabled');
        const isVisible = window.visibilityHelper.isElementPartiallyVisible(this) || window.visibilityHelper.isElementTotallyVisible(this);

        if (isVisible && isInitialized && this.isAutoplay()) {
          this.flkty.playPlayer();
        } else {
          this.flkty.stopPlayer();
        }
      }

      disconnectedCallback() {
        if (!this.flkty) return;

        this.flkty.destroy();
        this.flkty = null;

        document.removeEventListener('theme:scroll', this.handleCheckVisibility);
        document.removeEventListener('theme:resize:width', this.handleResizeWidth);
        this.slideshowPrev?.removeEventListener('click', this.handlePrevClick);
        this.slideshowNext?.removeEventListener('click', this.handleNextClick);
        this.scrollBtn?.removeEventListener('click', this.handleScrollClick);
        this.removeEventListener('theme:slideshow:selectSlide', this.handleSelectSlide);
        this.removeEventListener('theme:slideshow:deselect', this.handleDeselectSlide);
        this.removeEventListener('shopify:section:unload', this.handleUnload);
      }
    }

    customElements.define('slideshow-element', SlideshowElement);

    register('featured-video', [videoPlay]);

    document.addEventListener('DOMContentLoaded', function () {
      // Load all registered sections on the page.
      load('*');

      // Smooth scroll to anchored element
      const anchorLinks = document.querySelectorAll('[data-anchor-link]');
      anchorLinks.forEach((anchorLink) => {
        anchorLink.addEventListener('click', (e) => {
          e.preventDefault();
          const targetElement = document.getElementById(anchorLink.getAttribute('href').split('#')[1]);
          const position = targetElement.getBoundingClientRect().top + window.scrollY - theme.dimensions.headerScrolled;

          window.scrollTo({
            top: position,
            left: 0,
            behavior: 'smooth',
          });
        });
      });

      // Target iframes to make them responsive
      const iframeSelectors = '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe';
      const frames = document.querySelectorAll(iframeSelectors);
      frames.forEach((frame) => {
        wrap(frame, 'rte__video-wrapper');
      });

      if (window.self !== window.top) {
        document.querySelector('html').classList.add('iframe');
      }
    });

    // Apply a specific class to the html element for browser support of cookies.
    if (window.navigator.cookieEnabled) {
      document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
    }

})(themeVendor.ScrollLock, themeVendor.ajaxinate, themeVendor.Flickity, themeVendor.FlickityFade);
